var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 340.556,
    height: 296.104,
    viewBox: "0 0 340.556 296.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tax",
    transform: "translate(-6.279 -28.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(6.279 143.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Floor-2",
    "data-name": "Floor",
    d: "M56.151,234.589c-66.5,35.256-66.5,92.416,0,127.672s174.312,35.256,240.809,0,66.5-92.416,0-127.672S122.647,199.333,56.151,234.589Z",
    transform: "translate(-6.279 -208.147)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(21.682 28.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-2",
    "data-name": "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Percentage",
    d: "M321.349,182.012a2.962,2.962,0,0,0-.475-.818,2.339,2.339,0,0,0-.715-.577,2.489,2.489,0,0,0-.97-.264,3.71,3.71,0,0,0-1.217.132,3.568,3.568,0,0,0-1.11.477,2.2,2.2,0,0,0-.672.694,2.043,2.043,0,0,0-.277.836,2.768,2.768,0,0,0,.065.926,6.081,6.081,0,0,0,.154.614,5.684,5.684,0,0,0,.217.58,2.928,2.928,0,0,0,.476.818,2.33,2.33,0,0,0,.715.577,2.461,2.461,0,0,0,.97.264,3.7,3.7,0,0,0,1.217-.132,3.526,3.526,0,0,0,1.109-.477,2.289,2.289,0,0,0,.681-.7,1.921,1.921,0,0,0,.277-.837,2.925,2.925,0,0,0-.074-.923A7.3,7.3,0,0,0,321.349,182.012Zm-1.638,1.635a1.278,1.278,0,0,1,.01.66.59.59,0,0,1-.459.341.642.642,0,0,1-.585-.068,1.363,1.363,0,0,1-.37-.565,5.634,5.634,0,0,1-.321-1.037,1.273,1.273,0,0,1-.01-.66.59.59,0,0,1,.459-.341.644.644,0,0,1,.585.068,1.369,1.369,0,0,1,.37.566A5.6,5.6,0,0,1,319.711,183.647Zm-9.628-.929a3.555,3.555,0,0,0,1.109-.477,2.289,2.289,0,0,0,.681-.7,1.924,1.924,0,0,0,.277-.837,2.946,2.946,0,0,0-.074-.923,7.342,7.342,0,0,0-.37-1.194,2.958,2.958,0,0,0-.476-.819,2.338,2.338,0,0,0-.715-.577,2.475,2.475,0,0,0-.969-.264,3.691,3.691,0,0,0-1.217.132,3.53,3.53,0,0,0-1.11.477,2.177,2.177,0,0,0-.672.694,2.049,2.049,0,0,0-.277.837,2.787,2.787,0,0,0,.064.926,6.253,6.253,0,0,0,.154.613,6.03,6.03,0,0,0,.217.581,2.968,2.968,0,0,0,.476.818,2.331,2.331,0,0,0,.715.577,2.461,2.461,0,0,0,.97.264A3.694,3.694,0,0,0,310.083,182.718Zm-1.74-3.163a1.27,1.27,0,0,1-.01-.66.589.589,0,0,1,.458-.341.646.646,0,0,1,.585.067,1.37,1.37,0,0,1,.37.566,5.583,5.583,0,0,1,.321,1.037,1.27,1.27,0,0,1,.01.66.588.588,0,0,1-.458.341.642.642,0,0,1-.585-.067,1.365,1.365,0,0,1-.37-.566A5.621,5.621,0,0,1,308.344,179.555Zm9.506-4.474a.241.241,0,0,0-.008-.083.3.3,0,0,0-.182-.2.508.508,0,0,0-.326-.008l-1.4.367a.7.7,0,0,0-.343.175,1.013,1.013,0,0,0-.18.285l-5.283,12.421a.352.352,0,0,0-.022.108.243.243,0,0,0,.007.083.3.3,0,0,0,.182.2.509.509,0,0,0,.326.008l1.4-.367a.7.7,0,0,0,.344-.174,1.018,1.018,0,0,0,.18-.285l5.283-12.422A.388.388,0,0,0,317.85,175.081Z",
    transform: "translate(-112.078 -80.636)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Percentage-2",
    "data-name": "Percentage",
    d: "M464.622,209.958a2.794,2.794,0,0,0,.072-.925,2.069,2.069,0,0,0-.27-.839,2.2,2.2,0,0,0-.667-.7,3.529,3.529,0,0,0-1.106-.484,3.686,3.686,0,0,0-1.216-.139,2.471,2.471,0,0,0-.972.258,2.324,2.324,0,0,0-.72.573,2.927,2.927,0,0,0-.482.815,6.13,6.13,0,0,0-.226.595,5.685,5.685,0,0,0-.154.6,2.775,2.775,0,0,0-.071.925,2.058,2.058,0,0,0,.27.839,2.2,2.2,0,0,0,.667.7,3.548,3.548,0,0,0,1.107.484,3.685,3.685,0,0,0,1.216.139,2.569,2.569,0,0,0,.98-.256,2.174,2.174,0,0,0,.72-.572,3.133,3.133,0,0,0,.474-.817A7.431,7.431,0,0,0,464.622,209.958Zm-2.335.581a1.37,1.37,0,0,1-.374.563.645.645,0,0,1-.586.064.588.588,0,0,1-.456-.344,1.272,1.272,0,0,1,.015-.66,5.615,5.615,0,0,1,.33-1.035,1.367,1.367,0,0,1,.374-.563.645.645,0,0,1,.585-.064.589.589,0,0,1,.456.344,1.28,1.28,0,0,1-.015.66A5.633,5.633,0,0,1,462.287,210.539Zm-7.608-5.5a3.688,3.688,0,0,0,1.216.139,2.572,2.572,0,0,0,.98-.256,2.181,2.181,0,0,0,.72-.572,3.131,3.131,0,0,0,.473-.817,7.311,7.311,0,0,0,.379-1.191,2.8,2.8,0,0,0,.073-.925,2.069,2.069,0,0,0-.27-.839,2.191,2.191,0,0,0-.667-.7,3.544,3.544,0,0,0-1.106-.484,3.691,3.691,0,0,0-1.216-.139,2.475,2.475,0,0,0-.972.258,2.329,2.329,0,0,0-.719.572,2.949,2.949,0,0,0-.483.815q-.138.319-.226.594a5.929,5.929,0,0,0-.153.6,2.772,2.772,0,0,0-.072.925,2.051,2.051,0,0,0,.27.839,2.184,2.184,0,0,0,.667.7A3.553,3.553,0,0,0,454.678,205.041Zm.363-3.527a1.364,1.364,0,0,1,.374-.563.643.643,0,0,1,.586-.064.589.589,0,0,1,.456.344,1.264,1.264,0,0,1-.015.66,5.572,5.572,0,0,1-.329,1.035,1.377,1.377,0,0,1-.374.563.645.645,0,0,1-.586.064.586.586,0,0,1-.456-.343,1.257,1.257,0,0,1,.015-.66A5.558,5.558,0,0,1,455.042,201.514Zm10.64.866a.25.25,0,0,0,.042-.074.274.274,0,0,0-.038-.257.47.47,0,0,0-.271-.167l-1.4-.376a.742.742,0,0,0-.392-.02,1.158,1.158,0,0,0-.318.153l-11.678,7.926a.413.413,0,0,0-.082.08.286.286,0,0,0-.042.074.274.274,0,0,0,.038.257.47.47,0,0,0,.272.166l1.4.377a.749.749,0,0,0,.392.02,1.154,1.154,0,0,0,.317-.153L465.6,202.46A.449.449,0,0,0,465.681,202.38Z",
    transform: "translate(-155.842 -89.41)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Percentage-3",
    "data-name": "Percentage",
    d: "M328.688,38.755a2.791,2.791,0,0,0,.072-.925,2.069,2.069,0,0,0-.27-.838,2.2,2.2,0,0,0-.667-.7,3.537,3.537,0,0,0-1.106-.484,3.687,3.687,0,0,0-1.216-.139,2.472,2.472,0,0,0-.972.258,2.332,2.332,0,0,0-.72.572,2.939,2.939,0,0,0-.482.815,6.138,6.138,0,0,0-.226.594,5.588,5.588,0,0,0-.153.6,2.755,2.755,0,0,0-.072.925,2.05,2.05,0,0,0,.27.839,2.183,2.183,0,0,0,.667.7,3.537,3.537,0,0,0,1.106.484,3.685,3.685,0,0,0,1.216.139,2.569,2.569,0,0,0,.98-.256,2.167,2.167,0,0,0,.72-.572,3.109,3.109,0,0,0,.473-.817A7.35,7.35,0,0,0,328.688,38.755Zm-2.335.582a1.37,1.37,0,0,1-.374.563.643.643,0,0,1-.586.064.587.587,0,0,1-.456-.343,1.273,1.273,0,0,1,.015-.66,5.615,5.615,0,0,1,.33-1.035,1.367,1.367,0,0,1,.374-.563.643.643,0,0,1,.585-.064.589.589,0,0,1,.456.344,1.28,1.28,0,0,1-.015.66A5.63,5.63,0,0,1,326.353,39.337Zm-7.608-5.5a3.689,3.689,0,0,0,1.216.139,2.572,2.572,0,0,0,.98-.256,2.175,2.175,0,0,0,.72-.573,3.091,3.091,0,0,0,.473-.817,7.271,7.271,0,0,0,.379-1.191,2.775,2.775,0,0,0,.073-.925,2.067,2.067,0,0,0-.27-.838,2.192,2.192,0,0,0-.667-.7,3.544,3.544,0,0,0-1.106-.484,3.691,3.691,0,0,0-1.216-.139,2.475,2.475,0,0,0-.972.258,2.347,2.347,0,0,0-.72.572,2.963,2.963,0,0,0-.482.815,6.292,6.292,0,0,0-.226.594,5.692,5.692,0,0,0-.154.6,2.791,2.791,0,0,0-.072.925,2.051,2.051,0,0,0,.27.839,2.191,2.191,0,0,0,.667.7A3.551,3.551,0,0,0,318.744,33.839Zm.363-3.527a1.37,1.37,0,0,1,.374-.563.645.645,0,0,1,.586-.064.589.589,0,0,1,.456.344,1.264,1.264,0,0,1-.015.66,5.551,5.551,0,0,1-.329,1.034,1.373,1.373,0,0,1-.374.564.645.645,0,0,1-.586.064.588.588,0,0,1-.456-.343,1.268,1.268,0,0,1,.016-.66A5.566,5.566,0,0,1,319.108,30.312Zm10.64.866a.273.273,0,0,0,.043-.074.277.277,0,0,0-.038-.257.472.472,0,0,0-.272-.167l-1.4-.376a.742.742,0,0,0-.392-.02,1.174,1.174,0,0,0-.318.153l-11.678,7.926a.412.412,0,0,0-.082.08.264.264,0,0,0-.042.074.274.274,0,0,0,.038.257.469.469,0,0,0,.272.166l1.4.376a.743.743,0,0,0,.392.021,1.172,1.172,0,0,0,.317-.153l11.679-7.925A.427.427,0,0,0,329.747,31.178Z",
    transform: "translate(-114.879 -28.049)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Percentage-4",
    "data-name": "Percentage",
    d: "M43.421,101.525a2.967,2.967,0,0,0-.476-.818,2.335,2.335,0,0,0-.715-.577,2.478,2.478,0,0,0-.97-.264,3.689,3.689,0,0,0-1.216.132,3.561,3.561,0,0,0-1.11.477,2.206,2.206,0,0,0-.672.694,2.059,2.059,0,0,0-.277.837,2.789,2.789,0,0,0,.066.926,6.116,6.116,0,0,0,.154.614,5.907,5.907,0,0,0,.217.58,2.953,2.953,0,0,0,.476.817,2.33,2.33,0,0,0,.715.577,2.472,2.472,0,0,0,.97.264,3.7,3.7,0,0,0,1.217-.132,3.549,3.549,0,0,0,1.109-.477,2.29,2.29,0,0,0,.681-.7,1.914,1.914,0,0,0,.276-.837,2.92,2.92,0,0,0-.074-.923A7.34,7.34,0,0,0,43.421,101.525Zm-1.638,1.635a1.278,1.278,0,0,1,.01.66.588.588,0,0,1-.458.341.644.644,0,0,1-.585-.067,1.362,1.362,0,0,1-.37-.566,5.569,5.569,0,0,1-.322-1.037,1.27,1.27,0,0,1-.01-.66.589.589,0,0,1,.458-.341.642.642,0,0,1,.585.067,1.363,1.363,0,0,1,.37.566A5.622,5.622,0,0,1,41.783,103.16Zm-9.629-.927a3.527,3.527,0,0,0,1.109-.477,2.29,2.29,0,0,0,.681-.7,1.914,1.914,0,0,0,.276-.837,2.93,2.93,0,0,0-.074-.924,7.353,7.353,0,0,0-.37-1.193,2.963,2.963,0,0,0-.476-.818,2.338,2.338,0,0,0-.715-.577,2.489,2.489,0,0,0-.97-.264,3.691,3.691,0,0,0-1.217.132,3.556,3.556,0,0,0-1.109.477,2.195,2.195,0,0,0-.673.694,2.058,2.058,0,0,0-.276.837,2.77,2.77,0,0,0,.065.926,6.25,6.25,0,0,0,.154.613,5.855,5.855,0,0,0,.217.581,2.966,2.966,0,0,0,.476.818,2.328,2.328,0,0,0,.715.577,2.464,2.464,0,0,0,.97.264A3.678,3.678,0,0,0,32.154,102.233Zm-1.74-3.162a1.273,1.273,0,0,1-.01-.66.589.589,0,0,1,.458-.341.646.646,0,0,1,.585.067,1.369,1.369,0,0,1,.37.566,5.622,5.622,0,0,1,.322,1.037,1.27,1.27,0,0,1,.01.66.588.588,0,0,1-.458.341.642.642,0,0,1-.585-.067,1.36,1.36,0,0,1-.37-.566A5.616,5.616,0,0,1,30.414,99.071Zm9.5-4.476a.258.258,0,0,0-.007-.083.305.305,0,0,0-.182-.2A.51.51,0,0,0,39.4,94.3l-1.4.368a.71.71,0,0,0-.344.175,1.015,1.015,0,0,0-.18.286L32.2,107.554a.372.372,0,0,0-.022.108.239.239,0,0,0,.007.083.3.3,0,0,0,.182.2.5.5,0,0,0,.326.008l1.4-.368a.708.708,0,0,0,.344-.175,1.02,1.02,0,0,0,.179-.285L39.9,94.7A.391.391,0,0,0,39.918,94.594Z",
    transform: "translate(-28.326 -51.788)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Percentage-5",
    "data-name": "Percentage",
    d: "M146.224,44.92a2.8,2.8,0,0,0-.148-.917,2.147,2.147,0,0,0-.462-.765,2.323,2.323,0,0,0-.816-.549,3.658,3.658,0,0,0-1.194-.253,3.7,3.7,0,0,0-1.22.107,2.383,2.383,0,0,0-.888.445,2.211,2.211,0,0,0-.567.7,2.826,2.826,0,0,0-.278.892,5.921,5.921,0,0,0-.08.626,5.671,5.671,0,0,0-.009.613,2.8,2.8,0,0,0,.148.917,2.147,2.147,0,0,0,.462.765,2.32,2.32,0,0,0,.817.549,3.654,3.654,0,0,0,1.194.253,3.722,3.722,0,0,0,1.22-.106,2.488,2.488,0,0,0,.9-.445,2.045,2.045,0,0,0,.567-.7,2.968,2.968,0,0,0,.269-.892A7.178,7.178,0,0,0,146.224,44.92Zm-2.142,1.032a1.307,1.307,0,0,1-.232.624.628.628,0,0,1-.557.179.614.614,0,0,1-.526-.244,1.286,1.286,0,0,1-.14-.647,5.443,5.443,0,0,1,.078-1.076,1.3,1.3,0,0,1,.232-.624.628.628,0,0,1,.556-.18.619.619,0,0,1,.527.245,1.287,1.287,0,0,1,.14.647A5.439,5.439,0,0,1,144.082,45.952ZM135.357,42.1a3.7,3.7,0,0,0,1.22-.107,2.477,2.477,0,0,0,.9-.445,2.06,2.06,0,0,0,.567-.7,2.968,2.968,0,0,0,.269-.892,7.179,7.179,0,0,0,.089-1.239,2.8,2.8,0,0,0-.148-.917,2.147,2.147,0,0,0-.462-.765,2.323,2.323,0,0,0-.816-.549,3.658,3.658,0,0,0-1.194-.253,3.7,3.7,0,0,0-1.22.107,2.383,2.383,0,0,0-.888.445,2.22,2.22,0,0,0-.567.7,2.826,2.826,0,0,0-.278.892,5.921,5.921,0,0,0-.08.626,5.679,5.679,0,0,0-.009.613,2.8,2.8,0,0,0,.148.917,2.139,2.139,0,0,0,.462.764,2.313,2.313,0,0,0,.817.549A3.653,3.653,0,0,0,135.357,42.1Zm-.478-3.516a1.307,1.307,0,0,1,.232-.624.629.629,0,0,1,.557-.18.616.616,0,0,1,.526.245,1.294,1.294,0,0,1,.14.647,5.446,5.446,0,0,1-.078,1.076,1.307,1.307,0,0,1-.232.624.628.628,0,0,1-.557.179.617.617,0,0,1-.526-.244,1.287,1.287,0,0,1-.14-.647A5.437,5.437,0,0,1,134.879,38.584Zm10.591-1.273a.254.254,0,0,0,.024-.08.283.283,0,0,0-.1-.244.49.49,0,0,0-.3-.108l-1.455-.088a.736.736,0,0,0-.388.058,1.083,1.083,0,0,0-.274.212l-9.53,10.062a.389.389,0,0,0-.061.095.269.269,0,0,0-.024.08.281.281,0,0,0,.1.243.486.486,0,0,0,.3.108l1.456.089a.733.733,0,0,0,.387-.058,1.11,1.11,0,0,0,.274-.212l9.53-10.063A.392.392,0,0,0,145.47,37.311Z",
    transform: "translate(-59.788 -30.979)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Money",
    d: "M322.175,111a8.425,8.425,0,0,1-4.119,3.377l.978,2.838-3.341.971-.942-2.735a19.875,19.875,0,0,1-4.178.5,12.959,12.959,0,0,1-3.535-.393l.523-4.259a13.281,13.281,0,0,0,3.474.4,13.093,13.093,0,0,0,3.565-.5q3.173-.922,2.671-2.38a1.369,1.369,0,0,0-1.3-.874A19.1,19.1,0,0,0,312.8,108a31.578,31.578,0,0,1-4,.135,6.9,6.9,0,0,1-3.084-.861,4.571,4.571,0,0,1-2.08-2.658,4.982,4.982,0,0,1,.426-4.272,8.47,8.47,0,0,1,4.318-3.379l-.969-2.812,3.34-.971.952,2.761a18.441,18.441,0,0,1,3.224-.375,12.813,12.813,0,0,1,2.947.241l-.4,4.252a12.912,12.912,0,0,0-5.876.189,4.86,4.86,0,0,0-2.24,1.143,1.324,1.324,0,0,0-.351,1.381,1.311,1.311,0,0,0,1.261.815,18.4,18.4,0,0,0,3.122-.092,30.64,30.64,0,0,1,4.011-.139,7.106,7.106,0,0,1,3.079.849,4.486,4.486,0,0,1,2.09,2.641A4.915,4.915,0,0,1,322.175,111Z",
    transform: "translate(-111.199 -51.394)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Money-2",
    "data-name": "Money",
    d: "M449.278,58.011a10.178,10.178,0,0,1-5.95.946l-.879,3.153-3.712-.873.847-3.039a20.93,20.93,0,0,1-4.191-1.757A12.936,12.936,0,0,1,432.36,54.2l3.167-3.675a13.261,13.261,0,0,0,2.976,2.213,13.9,13.9,0,0,0,3.624,1.427q3.525.83,3.978-.79a1.334,1.334,0,0,0-.653-1.5,19.588,19.588,0,0,0-2.991-1.626,32.662,32.662,0,0,1-3.794-2,6.716,6.716,0,0,1-2.32-2.437,4.581,4.581,0,0,1-.256-3.572,5.963,5.963,0,0,1,3.085-3.739,10.189,10.189,0,0,1,6.136-.842l.871-3.125,3.712.873-.855,3.068a19.456,19.456,0,0,1,3.228,1.364,12.9,12.9,0,0,1,2.584,1.788L451.8,45.36a13.331,13.331,0,0,0-5.573-2.945,5.64,5.64,0,0,0-2.8-.128,1.61,1.61,0,0,0-1.2,1.1,1.277,1.277,0,0,0,.658,1.426,18.851,18.851,0,0,0,2.956,1.573,31.585,31.585,0,0,1,3.81,2,6.933,6.933,0,0,1,2.324,2.423,4.5,4.5,0,0,1,.276,3.561A5.875,5.875,0,0,1,449.278,58.011Z",
    transform: "translate(-150.078 -30.374)",
    fill: "#f0f0f0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadows",
    transform: "translate(23.277 148.277)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow",
    cx: 43.609,
    cy: 23.121,
    rx: 43.609,
    ry: 23.121,
    transform: "translate(200.508 104.489)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow-2",
    "data-name": "Shadow",
    cx: 25.589,
    cy: 13.567,
    rx: 25.589,
    ry: 13.567,
    transform: "translate(132.148 114.739)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow-3",
    "data-name": "Shadow",
    cx: 25.589,
    cy: 13.567,
    rx: 25.589,
    ry: 13.567,
    transform: "translate(91.002 132.022)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow-4",
    "data-name": "Shadow",
    d: "M357.987,308.355v-3.1h5.855v-3.1h5.853v-3.1h5.855v-3.1H381.4v-3.1h5.854v-3.1h5.853v-3.886L260.318,215.441v3.467h-5.853v3.1h-5.855v3.1h-5.853v3.1H236.9v3.1h-5.853v3.1h-5.855v3.1h-7.33l133.586,70.825Z",
    transform: "translate(-87.037 -215.441)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow-5",
    "data-name": "Shadow",
    d: "M42.231,383.54l-10.49-5.57c-1.509-.8-1.509-2.1,0-2.9l138.061-73.2a6.52,6.52,0,0,1,5.464,0l10.49,5.57c1.509.8,1.509,2.1,0,2.9L47.7,383.54A6.52,6.52,0,0,1,42.231,383.54Z",
    transform: "translate(-30.609 -246.205)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ticket",
    transform: "translate(156.572 147.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ticket-2",
    "data-name": "Ticket"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2480",
    "data-name": "Group 2480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2478",
    "data-name": "Group 2478",
    transform: "translate(0.672 0.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M359.071,305.625v-2.939a.174.174,0,0,1,.18-.165h5.674v-2.938a.174.174,0,0,1,.18-.166h5.673V296.48a.174.174,0,0,1,.18-.166h5.674v-2.938a.173.173,0,0,1,.18-.165h5.674v-2.938a.174.174,0,0,1,.18-.166h5.674v-2.938a.174.174,0,0,1,.18-.166H394.2V284.16L262.843,214.518v2.818a.173.173,0,0,1-.18.165h-5.673v2.938a.173.173,0,0,1-.18.166h-5.675v2.938a.173.173,0,0,1-.18.165h-5.673v2.938a.174.174,0,0,1-.18.166h-5.674v2.938a.173.173,0,0,1-.18.165h-5.673v2.938a.174.174,0,0,1-.18.166H227.72v2.938a.173.173,0,0,1-.18.166h-5.181l131.089,69.5Z",
    transform: "translate(-222.358 -214.518)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2479",
    "data-name": "Group 2479"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M262.734,214.646,393.726,284.1v2.582h-5.493a.347.347,0,0,0-.361.331v2.773h-5.494a.347.347,0,0,0-.361.331v2.773h-5.493a.346.346,0,0,0-.36.33v2.773H370.67a.347.347,0,0,0-.361.331v2.772h-5.493a.347.347,0,0,0-.361.331V302.2h-5.494a.346.346,0,0,0-.36.33V305.3h-5.4L222.74,236.129h4.509a.347.347,0,0,0,.361-.331v-2.773H233.1a.346.346,0,0,0,.36-.33v-2.773h5.494a.347.347,0,0,0,.36-.331v-2.772h5.494a.347.347,0,0,0,.361-.331v-2.773h5.493a.347.347,0,0,0,.36-.331v-2.772h5.494a.347.347,0,0,0,.36-.331v-2.773h5.494a.346.346,0,0,0,.36-.331v-2.53m-.36-.573v3.1h-5.854v3.1h-5.854v3.1h-5.853v3.1h-5.854v3.1H233.1v3.1h-5.855v3.1H221.4l131.712,69.833h5.853v-3.1h5.855v-3.1h5.853v-3.1h5.854v-3.1h5.854v-3.1h5.854v-3.1h5.853v-3.1L262.374,214.073Z",
    transform: "translate(-221.396 -214.073)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2552",
    "data-name": "Group 2552",
    transform: "translate(22.694 11.752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2484",
    "data-name": "Group 2484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2481",
    "data-name": "Group 2481"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M254.6,243.026a.773.773,0,0,0,.36-.089l17.562-9.312a.633.633,0,0,0,.264-.9.756.756,0,0,0-.984-.242l-17.562,9.311a.633.633,0,0,0-.264.9A.733.733,0,0,0,254.6,243.026Z",
    transform: "translate(-253.879 -232.39)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2482",
    "data-name": "Group 2482",
    transform: "translate(0.45 0.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M254.793,245.947a.289.289,0,0,0,.136-.033L278.346,233.5a.238.238,0,0,0,.1-.339.286.286,0,0,0-.37-.091l-23.417,12.415a.237.237,0,0,0-.1.339A.276.276,0,0,0,254.793,245.947Z",
    transform: "translate(-254.523 -233.036)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2483",
    "data-name": "Group 2483",
    transform: "translate(3.378 1.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M258.983,248.365a.291.291,0,0,0,.135-.033l23.417-12.415a.237.237,0,0,0,.1-.339.286.286,0,0,0-.369-.091L258.849,247.9a.237.237,0,0,0-.1.339A.277.277,0,0,0,258.983,248.365Z",
    transform: "translate(-258.713 -235.455)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2487",
    "data-name": "Group 2487",
    transform: "translate(6.305 3.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2485",
    "data-name": "Group 2485",
    transform: "translate(8.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M275.742,249.232a.294.294,0,0,0,.135-.033l20.488-10.863a.238.238,0,0,0,.1-.339.287.287,0,0,0-.37-.091l-20.488,10.863a.238.238,0,0,0-.1.339A.279.279,0,0,0,275.742,249.232Z",
    transform: "translate(-275.471 -237.873)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2486",
    "data-name": "Group 2486",
    transform: "translate(0 12.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M263.173,260.823a.286.286,0,0,0,.135-.033l5.854-3.1a.238.238,0,0,0,.1-.339.287.287,0,0,0-.37-.091l-5.853,3.1a.237.237,0,0,0-.1.339A.276.276,0,0,0,263.173,260.823Z",
    transform: "translate(-262.903 -257.223)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2490",
    "data-name": "Group 2490",
    transform: "translate(9.233 5.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2488",
    "data-name": "Group 2488",
    transform: "translate(8.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M279.931,251.652a.3.3,0,0,0,.136-.033l20.488-10.863a.238.238,0,0,0,.1-.339.287.287,0,0,0-.37-.091L279.8,251.188a.238.238,0,0,0-.1.339A.277.277,0,0,0,279.931,251.652Z",
    transform: "translate(-279.661 -240.293)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2489",
    "data-name": "Group 2489",
    transform: "translate(0 12.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M267.364,263.242a.293.293,0,0,0,.135-.033l5.853-3.1a.238.238,0,0,0,.1-.339.287.287,0,0,0-.37-.091l-5.853,3.1a.238.238,0,0,0-.1.339A.278.278,0,0,0,267.364,263.242Z",
    transform: "translate(-267.094 -259.643)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2493",
    "data-name": "Group 2493",
    transform: "translate(12.16 6.623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2491",
    "data-name": "Group 2491",
    transform: "translate(8.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M284.121,254.071a.3.3,0,0,0,.136-.033l20.488-10.863a.237.237,0,0,0,.1-.339.286.286,0,0,0-.37-.091l-20.488,10.863a.238.238,0,0,0-.1.339A.276.276,0,0,0,284.121,254.071Z",
    transform: "translate(-283.851 -242.712)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2492",
    "data-name": "Group 2492",
    transform: "translate(0 12.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M271.554,265.661a.294.294,0,0,0,.135-.033l5.853-3.1a.237.237,0,0,0,.1-.339.286.286,0,0,0-.37-.091l-5.853,3.1a.238.238,0,0,0-.1.339A.278.278,0,0,0,271.554,265.661Z",
    transform: "translate(-271.284 -262.062)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2496",
    "data-name": "Group 2496",
    transform: "translate(15.087 8.174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2494",
    "data-name": "Group 2494",
    transform: "translate(8.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M288.311,256.49a.289.289,0,0,0,.136-.033l20.488-10.863a.238.238,0,0,0,.1-.339.287.287,0,0,0-.37-.091l-20.488,10.863a.237.237,0,0,0-.1.339A.277.277,0,0,0,288.311,256.49Z",
    transform: "translate(-288.041 -245.131)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2495",
    "data-name": "Group 2495",
    transform: "translate(0 12.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M275.744,268.081a.294.294,0,0,0,.135-.033l5.853-3.1a.238.238,0,0,0,.1-.339.287.287,0,0,0-.37-.091l-5.853,3.1a.238.238,0,0,0-.1.339A.279.279,0,0,0,275.744,268.081Z",
    transform: "translate(-275.473 -264.481)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2499",
    "data-name": "Group 2499",
    transform: "translate(18.015 9.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2497",
    "data-name": "Group 2497",
    transform: "translate(8.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M292.5,258.909a.3.3,0,0,0,.136-.033l20.487-10.863a.238.238,0,0,0,.1-.339.286.286,0,0,0-.37-.091l-20.487,10.863a.237.237,0,0,0-.1.339A.277.277,0,0,0,292.5,258.909Z",
    transform: "translate(-292.232 -247.55)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2498",
    "data-name": "Group 2498",
    transform: "translate(0 12.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M279.933,270.5a.289.289,0,0,0,.136-.033l5.853-3.1a.239.239,0,0,0,.1-.339.286.286,0,0,0-.37-.091l-5.853,3.1a.237.237,0,0,0-.1.339A.277.277,0,0,0,279.933,270.5Z",
    transform: "translate(-279.663 -266.9)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2502",
    "data-name": "Group 2502",
    transform: "translate(20.942 11.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2500",
    "data-name": "Group 2500",
    transform: "translate(8.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M296.692,261.329a.293.293,0,0,0,.135-.033l20.488-10.863a.237.237,0,0,0,.1-.339.287.287,0,0,0-.369-.091l-20.488,10.863a.237.237,0,0,0-.1.339A.276.276,0,0,0,296.692,261.329Z",
    transform: "translate(-296.422 -249.97)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2501",
    "data-name": "Group 2501",
    transform: "translate(0 12.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M284.123,272.919a.3.3,0,0,0,.136-.033l5.853-3.1a.237.237,0,0,0,.1-.339.287.287,0,0,0-.369-.091l-5.853,3.1a.238.238,0,0,0-.1.339A.278.278,0,0,0,284.123,272.919Z",
    transform: "translate(-283.853 -269.32)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2505",
    "data-name": "Group 2505",
    transform: "translate(23.869 12.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2503",
    "data-name": "Group 2503",
    transform: "translate(8.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M300.882,263.747a.293.293,0,0,0,.135-.033l20.488-10.864a.237.237,0,0,0,.1-.339.286.286,0,0,0-.37-.091l-20.488,10.863a.239.239,0,0,0-.1.339A.278.278,0,0,0,300.882,263.747Z",
    transform: "translate(-300.612 -252.388)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2504",
    "data-name": "Group 2504",
    transform: "translate(0 12.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M288.313,275.338a.3.3,0,0,0,.136-.033l5.853-3.1a.237.237,0,0,0,.1-.339.285.285,0,0,0-.369-.091l-5.853,3.1a.238.238,0,0,0-.1.339A.276.276,0,0,0,288.313,275.338Z",
    transform: "translate(-288.043 -271.739)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2508",
    "data-name": "Group 2508",
    transform: "translate(26.797 14.383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2506",
    "data-name": "Group 2506",
    transform: "translate(8.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M305.072,266.167a.286.286,0,0,0,.135-.033L325.7,255.27a.238.238,0,0,0,.1-.339.287.287,0,0,0-.37-.091L304.937,265.7a.237.237,0,0,0-.1.339A.279.279,0,0,0,305.072,266.167Z",
    transform: "translate(-304.801 -254.808)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2507",
    "data-name": "Group 2507",
    transform: "translate(0 12.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M292.5,277.757a.3.3,0,0,0,.136-.033l5.853-3.1a.237.237,0,0,0,.1-.339.288.288,0,0,0-.37-.091l-5.853,3.1a.237.237,0,0,0-.1.339A.276.276,0,0,0,292.5,277.757Z",
    transform: "translate(-292.233 -274.159)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2511",
    "data-name": "Group 2511",
    transform: "translate(29.724 15.934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2509",
    "data-name": "Group 2509",
    transform: "translate(8.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M309.262,268.585a.294.294,0,0,0,.135-.033l20.488-10.863a.238.238,0,0,0,.1-.339.286.286,0,0,0-.37-.091l-20.488,10.863a.238.238,0,0,0-.1.339A.278.278,0,0,0,309.262,268.585Z",
    transform: "translate(-308.991 -257.226)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2510",
    "data-name": "Group 2510",
    transform: "translate(0 12.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M296.693,280.176a.286.286,0,0,0,.135-.033l5.854-3.1a.238.238,0,0,0,.1-.339.286.286,0,0,0-.37-.091l-5.853,3.1a.237.237,0,0,0-.1.339A.276.276,0,0,0,296.693,280.176Z",
    transform: "translate(-296.423 -276.576)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2514",
    "data-name": "Group 2514",
    transform: "translate(32.652 17.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2512",
    "data-name": "Group 2512",
    transform: "translate(8.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M313.451,271a.3.3,0,0,0,.136-.033l20.488-10.863a.238.238,0,0,0,.1-.339.287.287,0,0,0-.37-.091l-20.488,10.863a.238.238,0,0,0-.1.339A.277.277,0,0,0,313.451,271Z",
    transform: "translate(-313.181 -259.646)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2513",
    "data-name": "Group 2513",
    transform: "translate(0 12.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M300.884,282.6a.293.293,0,0,0,.135-.033l5.853-3.1a.238.238,0,0,0,.1-.339.287.287,0,0,0-.37-.091l-5.853,3.1a.238.238,0,0,0-.1.339A.278.278,0,0,0,300.884,282.6Z",
    transform: "translate(-300.614 -278.996)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2517",
    "data-name": "Group 2517",
    transform: "translate(35.579 19.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2515",
    "data-name": "Group 2515",
    transform: "translate(8.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M317.641,273.424a.3.3,0,0,0,.136-.033l20.488-10.863a.237.237,0,0,0,.1-.339.287.287,0,0,0-.37-.091l-20.488,10.863a.238.238,0,0,0-.1.339A.277.277,0,0,0,317.641,273.424Z",
    transform: "translate(-317.371 -262.065)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2516",
    "data-name": "Group 2516",
    transform: "translate(0 12.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M305.074,285.014a.293.293,0,0,0,.135-.033l5.853-3.1a.237.237,0,0,0,.1-.339.287.287,0,0,0-.37-.091l-5.853,3.1a.238.238,0,0,0-.1.339A.278.278,0,0,0,305.074,285.014Z",
    transform: "translate(-304.804 -281.415)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2520",
    "data-name": "Group 2520",
    transform: "translate(38.506 20.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2518",
    "data-name": "Group 2518",
    transform: "translate(8.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M321.831,275.843a.289.289,0,0,0,.136-.033l20.488-10.863a.238.238,0,0,0,.1-.339.286.286,0,0,0-.37-.091L321.7,275.38a.237.237,0,0,0-.1.339A.276.276,0,0,0,321.831,275.843Z",
    transform: "translate(-321.561 -264.484)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2519",
    "data-name": "Group 2519",
    transform: "translate(0 12.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M309.264,287.433a.293.293,0,0,0,.135-.033l5.853-3.1a.238.238,0,0,0,.1-.339.286.286,0,0,0-.37-.091l-5.853,3.1a.238.238,0,0,0-.1.339A.278.278,0,0,0,309.264,287.433Z",
    transform: "translate(-308.993 -283.834)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2523",
    "data-name": "Group 2523",
    transform: "translate(41.434 22.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2521",
    "data-name": "Group 2521",
    transform: "translate(8.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M326.022,278.262a.3.3,0,0,0,.136-.033l20.487-10.863a.239.239,0,0,0,.1-.339.286.286,0,0,0-.37-.091L325.888,277.8a.237.237,0,0,0-.1.339A.277.277,0,0,0,326.022,278.262Z",
    transform: "translate(-325.752 -266.903)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2522",
    "data-name": "Group 2522",
    transform: "translate(0 12.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M313.453,289.853a.289.289,0,0,0,.136-.033l5.853-3.1a.239.239,0,0,0,.1-.339.286.286,0,0,0-.37-.091l-5.853,3.1a.237.237,0,0,0-.1.339A.278.278,0,0,0,313.453,289.853Z",
    transform: "translate(-313.183 -286.253)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2526",
    "data-name": "Group 2526",
    transform: "translate(44.361 23.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2524",
    "data-name": "Group 2524",
    transform: "translate(8.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M330.212,280.682a.293.293,0,0,0,.135-.033l20.488-10.863a.237.237,0,0,0,.1-.339.287.287,0,0,0-.369-.091l-20.488,10.863a.237.237,0,0,0-.1.339A.276.276,0,0,0,330.212,280.682Z",
    transform: "translate(-329.942 -269.323)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2525",
    "data-name": "Group 2525",
    transform: "translate(0 12.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M317.643,292.272a.3.3,0,0,0,.136-.033l5.853-3.1a.238.238,0,0,0,.1-.339.288.288,0,0,0-.37-.091l-5.853,3.1a.238.238,0,0,0-.1.339A.277.277,0,0,0,317.643,292.272Z",
    transform: "translate(-317.373 -288.673)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2529",
    "data-name": "Group 2529",
    transform: "translate(47.288 25.247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2527",
    "data-name": "Group 2527",
    transform: "translate(8.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M334.4,283.1a.294.294,0,0,0,.135-.033L355.025,272.2a.237.237,0,0,0,.1-.339.286.286,0,0,0-.37-.091l-20.488,10.863a.238.238,0,0,0-.1.339A.278.278,0,0,0,334.4,283.1Z",
    transform: "translate(-334.132 -271.742)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2528",
    "data-name": "Group 2528",
    transform: "translate(0 12.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M321.833,294.691a.3.3,0,0,0,.136-.033l5.853-3.1a.237.237,0,0,0,.1-.339.285.285,0,0,0-.369-.091l-5.853,3.1a.238.238,0,0,0-.1.339A.276.276,0,0,0,321.833,294.691Z",
    transform: "translate(-321.563 -291.092)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2532",
    "data-name": "Group 2532",
    transform: "translate(50.216 26.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2530",
    "data-name": "Group 2530",
    transform: "translate(8.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M338.592,285.52a.287.287,0,0,0,.135-.033l20.488-10.863a.237.237,0,0,0,.1-.339.287.287,0,0,0-.37-.091l-20.488,10.864a.237.237,0,0,0-.1.339A.279.279,0,0,0,338.592,285.52Z",
    transform: "translate(-338.321 -274.161)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2531",
    "data-name": "Group 2531",
    transform: "translate(0 12.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M326.023,297.111a.3.3,0,0,0,.136-.033l5.853-3.1a.238.238,0,0,0,.1-.339.285.285,0,0,0-.37-.091l-5.853,3.1a.237.237,0,0,0-.1.339A.277.277,0,0,0,326.023,297.111Z",
    transform: "translate(-325.753 -293.511)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2535",
    "data-name": "Group 2535",
    transform: "translate(53.143 28.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2533",
    "data-name": "Group 2533",
    transform: "translate(8.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M342.782,287.939a.293.293,0,0,0,.135-.033l20.488-10.864a.238.238,0,0,0,.1-.339.286.286,0,0,0-.37-.091l-20.488,10.864a.238.238,0,0,0-.1.339A.278.278,0,0,0,342.782,287.939Z",
    transform: "translate(-342.511 -276.579)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2534",
    "data-name": "Group 2534",
    transform: "translate(0 12.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M330.213,299.53a.286.286,0,0,0,.135-.033l5.854-3.1a.238.238,0,0,0,.1-.339.287.287,0,0,0-.37-.091l-5.853,3.1a.236.236,0,0,0-.1.339A.276.276,0,0,0,330.213,299.53Z",
    transform: "translate(-329.943 -295.931)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2538",
    "data-name": "Group 2538",
    transform: "translate(56.071 29.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2536",
    "data-name": "Group 2536",
    transform: "translate(8.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M346.971,290.358a.3.3,0,0,0,.136-.033L367.6,279.461a.238.238,0,0,0,.1-.339.288.288,0,0,0-.37-.091l-20.488,10.863a.238.238,0,0,0-.1.339A.278.278,0,0,0,346.971,290.358Z",
    transform: "translate(-346.701 -278.999)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2537",
    "data-name": "Group 2537",
    transform: "translate(0 12.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M334.4,301.948a.294.294,0,0,0,.135-.033l5.853-3.1a.238.238,0,0,0,.1-.339.287.287,0,0,0-.37-.091l-5.853,3.1a.238.238,0,0,0-.1.339A.278.278,0,0,0,334.4,301.948Z",
    transform: "translate(-334.134 -298.349)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2541",
    "data-name": "Group 2541",
    transform: "translate(61.917 33.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2539",
    "data-name": "Group 2539",
    transform: "translate(8.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M355.339,295.189a.285.285,0,0,0,.135-.033l20.489-10.863a.238.238,0,0,0,.1-.339.286.286,0,0,0-.37-.091L355.2,294.726a.237.237,0,0,0-.1.339A.276.276,0,0,0,355.339,295.189Z",
    transform: "translate(-355.069 -283.83)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2540",
    "data-name": "Group 2540",
    transform: "translate(0 12.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M342.772,306.779a.3.3,0,0,0,.135-.033l5.853-3.1a.238.238,0,0,0,.1-.339.286.286,0,0,0-.37-.091l-5.853,3.1a.238.238,0,0,0-.1.339A.278.278,0,0,0,342.772,306.779Z",
    transform: "translate(-342.501 -303.18)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2542",
    "data-name": "Group 2542",
    transform: "translate(76.102 40.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M363.526,302.809a.774.774,0,0,0,.36-.089l11.707-6.207a.633.633,0,0,0,.264-.9.756.756,0,0,0-.984-.243l-11.708,6.207a.633.633,0,0,0-.263.9A.735.735,0,0,0,363.526,302.809Z",
    transform: "translate(-362.804 -295.278)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2543",
    "data-name": "Group 2543",
    transform: "translate(76.558 40.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M363.727,311.938a.286.286,0,0,0,.135-.033l29.256-15.511a.238.238,0,0,0,.1-.339.287.287,0,0,0-.37-.091l-29.256,15.512a.238.238,0,0,0-.1.339A.279.279,0,0,0,363.727,311.938Z",
    transform: "translate(-363.457 -295.931)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2544",
    "data-name": "Group 2544",
    transform: "translate(79.548 42.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M368.007,314.3a.3.3,0,0,0,.136-.033L397.4,298.76a.237.237,0,0,0,.1-.339.286.286,0,0,0-.369-.091l-29.256,15.51a.238.238,0,0,0-.1.339A.278.278,0,0,0,368.007,314.3Z",
    transform: "translate(-367.737 -298.297)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2545",
    "data-name": "Group 2545",
    transform: "translate(82.539 43.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M372.288,316.669a.293.293,0,0,0,.135-.033l29.256-15.51a.238.238,0,0,0,.1-.339.286.286,0,0,0-.37-.091l-29.255,15.51a.237.237,0,0,0-.1.339A.276.276,0,0,0,372.288,316.669Z",
    transform: "translate(-372.018 -300.663)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2546",
    "data-name": "Group 2546",
    transform: "translate(85.529 45.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M376.568,319.036A.3.3,0,0,0,376.7,319l29.255-15.511a.237.237,0,0,0,.1-.339.285.285,0,0,0-.369-.091l-29.256,15.511a.238.238,0,0,0-.1.339A.277.277,0,0,0,376.568,319.036Z",
    transform: "translate(-376.298 -303.029)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2547",
    "data-name": "Group 2547",
    transform: "translate(102.908 54.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M401.443,333.7a.286.286,0,0,0,.135-.033l29.256-15.51a.238.238,0,0,0,.1-.339.287.287,0,0,0-.37-.091l-29.256,15.511a.237.237,0,0,0-.1.339A.278.278,0,0,0,401.443,333.7Z",
    transform: "translate(-401.173 -317.693)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2548",
    "data-name": "Group 2548",
    transform: "translate(105.899 56.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M405.723,336.066a.3.3,0,0,0,.136-.033l29.256-15.511a.237.237,0,0,0,.1-.339.285.285,0,0,0-.369-.091L405.589,335.6a.238.238,0,0,0-.1.339A.277.277,0,0,0,405.723,336.066Z",
    transform: "translate(-405.453 -320.058)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2549",
    "data-name": "Group 2549",
    transform: "translate(97.04 51.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M393.044,322.662a.293.293,0,0,0,.135-.033l17.562-9.311a.238.238,0,0,0,.1-.339.286.286,0,0,0-.37-.091L392.909,322.2a.237.237,0,0,0-.1.339A.276.276,0,0,0,393.044,322.662Z",
    transform: "translate(-392.774 -312.855)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2550",
    "data-name": "Group 2550",
    transform: "translate(99.967 53.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M397.233,325.024a.294.294,0,0,0,.135-.033l17.562-9.311a.237.237,0,0,0,.1-.339.285.285,0,0,0-.369-.091L397.1,324.561a.238.238,0,0,0-.1.339A.278.278,0,0,0,397.233,325.024Z",
    transform: "translate(-396.963 -315.217)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2551",
    "data-name": "Group 2551",
    transform: "translate(102.894 54.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M401.423,327.385a.294.294,0,0,0,.135-.033l17.561-9.311a.237.237,0,0,0,.1-.339.286.286,0,0,0-.369-.091l-17.562,9.311a.238.238,0,0,0-.1.339A.278.278,0,0,0,401.423,327.385Z",
    transform: "translate(-401.152 -317.578)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Form_3",
    "data-name": "Form 3",
    transform: "translate(28.92 32.133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Open_Envelope",
    "data-name": "Open Envelope"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2554",
    "data-name": "Group 2554",
    transform: "translate(0.002 47.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2553",
    "data-name": "Group 2553",
    transform: "translate(0 30.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M38.688,227.1,174.57,155.062l5.438,2.883a5.14,5.14,0,0,1,2.556,4.066v92.049a5.141,5.141,0,0,1-2.556,4.066L49.238,327.457a6.122,6.122,0,0,1-5.112,0l-2.881-1.527a5.14,5.14,0,0,1-2.556-4.066Z",
    transform: "translate(-38.688 -155.062)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M38.688,227.1,174.57,155.062l5.438,2.883a5.14,5.14,0,0,1,2.556,4.066v92.049a5.141,5.141,0,0,1-2.556,4.066L49.238,327.457a6.122,6.122,0,0,1-5.112,0l-2.881-1.527a5.14,5.14,0,0,1-2.556-4.066Z",
    transform: "translate(-38.688 -155.062)",
    fill: "#fff",
    opacity: 0.15
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M173.82,130.05l.556-.278-2.112-1.127v0a3.692,3.692,0,0,0-.56-.246l-59.8-20.349a4.332,4.332,0,0,0-4.592,1.34L40.414,199.1a10.019,10.019,0,0,0-1.726,5.122v5.958l2.074,1.105L174.57,138.142v-5.959A3.8,3.8,0,0,0,173.82,130.05Z",
    transform: "translate(-38.688 -107.854)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M110.285,110.313a3.253,3.253,0,0,0-.692.674l-66.9,89.708a9.182,9.182,0,0,0-1.243,2.564l-2.079-1.1a11.584,11.584,0,0,1,.54-1.356c.01-.019.01-.028.02-.038.092-.187.184-.364.286-.543.02-.028.03-.056.051-.084a4.75,4.75,0,0,1,.356-.542l66.891-89.708a3.118,3.118,0,0,1,.336-.374c.112-.1.235-.205.357-.3Z",
    transform: "translate(-38.894 -108.34)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M204.249,129.763a3.423,3.423,0,0,0-.571-.252l-59.811-20.357a4.391,4.391,0,0,0-3.892.674l-2.078-1.1a4.437,4.437,0,0,1,3.9-.674L201.6,128.4a3.323,3.323,0,0,1,.56.252Z",
    transform: "translate(-68.584 -107.855)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M110.278,111.116l-66.9,89.711a10.013,10.013,0,0,0-1.726,5.122v5.958l135.883-72.047v-5.953a4.359,4.359,0,0,0-2.866-3.782l-59.8-20.349A4.331,4.331,0,0,0,110.278,111.116Z",
    transform: "translate(-39.582 -108.472)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M110.278,111.116l-66.9,89.711a10.013,10.013,0,0,0-1.726,5.122v5.958l135.883-72.047v-5.953a4.359,4.359,0,0,0-2.866-3.782l-59.8-20.349A4.331,4.331,0,0,0,110.278,111.116Z",
    transform: "translate(-39.582 -108.472)",
    fill: "#fff",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M44.523,228.329l16.408-8.85,16.439-8.8,32.926-17.525,33-17.415,16.522-8.668,16.554-8.618L159.958,167.3l-16.439,8.8-32.926,17.524-33,17.414L61.076,219.71Z",
    transform: "translate(-40.446 -125.989)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shadow-6",
    "data-name": "Shadow",
    d: "M162.657,129.615l-23.948-8.149L87.49,148.624,48.3,201.174v79.653l114.352-60.543Z",
    transform: "translate(-41.584 -65.615)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Form",
    transform: "translate(9.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paper"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1265",
    "data-name": "Path 1265",
    transform: "translate(-52.395 -34.415)",
    fill: "#fafafa",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 55.56821060180664 282.2508544921875 C 55.26608657836914 282.2508544921875 54.97786712646484 282.1899108886719 54.77746200561523 282.0836791992188 L 53.63249206542969 281.4761657714844 C 53.22743225097656 281.2616271972656 52.87239837646484 280.7053527832031 52.87239837646484 280.2856140136719 L 52.87239837646484 99.05844879150391 C 52.87239837646484 98.63882446289062 53.22761917114258 98.08213806152344 53.63258743286133 97.86719512939453 L 172.0947723388672 35.06132125854492 C 172.2951812744141 34.95510482788086 172.5833129882812 34.8941650390625 172.8852691650391 34.8941650390625 C 173.1872100830078 34.8941650390625 173.475341796875 34.95510482788086 173.6757354736328 35.06135177612305 L 174.8180541992188 35.66697692871094 C 175.2234344482422 35.88144683837891 175.5787048339844 36.43766784667969 175.5787048339844 36.85750961303711 L 175.5787048339844 218.0858917236328 C 175.5787048339844 218.5055389404297 175.2234954833984 219.0621643066406 174.8185577392578 219.277099609375 L 56.35842895507812 282.0837097167969 C 56.15821075439453 282.18994140625 55.87027359008789 282.2508544921875 55.56821060180664 282.2508544921875 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 172.88525390625 35.37155151367188 C 172.6224517822266 35.37155151367188 172.4200897216797 35.42919921875 172.3183898925781 35.48312377929688 L 53.85641479492188 98.28887939453125 C 53.58831787109375 98.43118286132812 53.34979248046875 98.83778381347656 53.34979248046875 99.05844116210938 L 53.34979248046875 280.2856140136719 C 53.34979248046875 280.5062866210938 53.58795166015625 280.912353515625 53.85626220703125 281.054443359375 L 55.00108337402344 281.6618347167969 C 55.10282897949219 281.7157592773438 55.30525207519531 281.7734375 55.56822204589844 281.7734375 C 55.83099365234375 281.7734375 56.03298950195312 281.7159118652344 56.13479614257812 281.661865234375 L 174.5947265625 218.8554077148438 C 174.86279296875 218.7131042480469 175.1012878417969 218.3065795898438 175.1012878417969 218.0858764648438 L 175.1012878417969 36.85748291015625 C 175.1012878417969 36.63681030273438 174.8629913330078 36.2308349609375 174.5943908691406 36.0887451171875 L 173.4521942138672 35.483154296875 C 173.3504180908203 35.42919921875 173.1480560302734 35.37155151367188 172.88525390625 35.37155151367188 M 172.88525390625 34.416748046875 C 173.2522277832031 34.416748046875 173.6191864013672 34.49099731445312 173.8993530273438 34.63949584960938 L 175.0416564941406 35.24517822265625 C 175.6019897460938 35.54156494140625 176.0560913085938 36.2640380859375 176.0560913085938 36.85748291015625 L 176.0560913085938 218.0858764648438 C 176.0560913085938 218.6799774169922 175.6019897460938 219.4017333984375 175.0423583984375 219.6987762451172 L 56.58206176757812 282.5054321289062 C 56.02243041992188 282.8025207519531 55.11418151855469 282.802490234375 54.55384826660156 282.5054321289062 L 53.40875244140625 281.8978881835938 C 52.84912109375 281.6014709472656 52.39498901367188 280.8789978027344 52.39498901367188 280.2856140136719 L 52.39498901367188 99.05844116210938 C 52.39498901367188 98.46501159667969 52.84912109375 97.74256896972656 53.40875244140625 97.44551086425781 L 171.8711547851562 34.63949584960938 C 172.1513214111328 34.49099731445312 172.5182800292969 34.416748046875 172.88525390625 34.416748046875 Z",
    stroke: "none",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M56.342,318.209a2,2,0,0,1-.375.093l-.195.022a2.964,2.964,0,0,1-.617-.022,1.983,1.983,0,0,1-.374-.093,2.071,2.071,0,0,1-.226-.1l-1.14-.6a2.031,2.031,0,0,1-1.015-1.613V134.667a1.725,1.725,0,0,1,.3-.917l3.169,1.677a1.843,1.843,0,0,0-.3.917V317.571C55.568,318.08,55.9,318.331,56.342,318.209Z",
    transform: "translate(-52.396 -70.018)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2557",
    "data-name": "Group 2557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2555",
    "data-name": "Group 2555",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M175.042,35.245,173.9,34.64a2.419,2.419,0,0,0-2.028,0L53.409,97.446A2.033,2.033,0,0,0,52.4,99.058V110.8l3.172,1.693L176.056,48.613V36.857A2.03,2.03,0,0,0,175.042,35.245Z",
    transform: "translate(-52.395 -34.417)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2556",
    "data-name": "Group 2556",
    transform: "translate(0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M176.149,36.575c-.125-.38-.516-.5-.976-.258L56.711,99.125a1.945,1.945,0,0,0-.718.7l-3.169-1.678a1.9,1.9,0,0,1,.718-.7L172,34.64a2.376,2.376,0,0,1,2.021,0l1.148.6A2.074,2.074,0,0,1,176.149,36.575Z",
    transform: "translate(-52.824 -34.414)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M52.4,134.661v11.753l3.169,1.68V136.339a1.841,1.841,0,0,1,.3-.917L52.7,133.744A1.725,1.725,0,0,0,52.4,134.661Z",
    transform: "translate(-52.396 -70.016)",
    opacity: 0.15
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Forms",
    transform: "translate(8.733 27.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2560",
    "data-name": "Group 2560",
    transform: "translate(0.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2558",
    "data-name": "Group 2558",
    transform: "translate(70.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M209.58,76.64,184.209,90.092v2.242L209.58,78.883Z",
    transform: "translate(-171.524 -76.64)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M204.109,83.629l-38.056,20.177v2.242l38.056-20.176Z",
    transform: "translate(-166.053 -79.145)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M205.933,90.618,172.1,108.553v2.242L205.932,92.86Z",
    transform: "translate(-167.876 -81.65)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2559",
    "data-name": "Group 2559",
    transform: "translate(0 36.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M76.906,156.479a.346.346,0,0,1,.377-.006.43.43,0,0,1,.159.378v2.575a1.1,1.1,0,0,1-.159.546.971.971,0,0,1-.377.394l-3.493,1.853v12.463a1.1,1.1,0,0,1-.158.546.977.977,0,0,1-.377.395L70.278,177a.344.344,0,0,1-.377.006.426.426,0,0,1-.158-.379V164.165l-3.493,1.852a.342.342,0,0,1-.377.006.427.427,0,0,1-.158-.378v-2.576a1.092,1.092,0,0,1,.158-.545.973.973,0,0,1,.377-.395Z",
    transform: "translate(-65.714 -142.08)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M89.9,149.607q.4-.211.606-.054a.815.815,0,0,1,.288.382l4.326,13.013a.936.936,0,0,1,.079.323.892.892,0,0,1-.129.445.8.8,0,0,1-.308.321l-2.5,1.325c-.265.142-.454.173-.567.094a.471.471,0,0,1-.207-.291l-.555-1.723-5.279,2.8-.555,2.312a1.747,1.747,0,0,1-.21.512,1.351,1.351,0,0,1-.565.506l-2.5,1.326a.281.281,0,0,1-.307.006.351.351,0,0,1-.129-.309,1.764,1.764,0,0,1,.08-.406l4.326-17.6a2.987,2.987,0,0,1,.287-.686,1.449,1.449,0,0,1,.606-.588ZM86.69,161.929l3.215-1.7L88.3,155.246Z",
    transform: "translate(-70.438 -139.595)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M108.591,149.507l-2.54,5.72a4.277,4.277,0,0,1-.268.531,1.342,1.342,0,0,1-.544.458l-3.018,1.6a.281.281,0,0,1-.308.006.352.352,0,0,1-.129-.309.835.835,0,0,1,.01-.114,1.267,1.267,0,0,1,.05-.184l4.585-10.279-4.385-5.231a.5.5,0,0,1-.059-.235.89.89,0,0,1,.129-.445.791.791,0,0,1,.308-.321l3-1.588c.266-.141.457-.16.576-.063s.2.176.258.228l2.4,2.833,2.322-5.337c.053-.108.14-.276.259-.5a1.333,1.333,0,0,1,.575-.548l3.036-1.609a.279.279,0,0,1,.308-.006.351.351,0,0,1,.129.309.945.945,0,0,1-.059.3l-4.406,9.99,4.545,5.341a.492.492,0,0,1,.048.132.5.5,0,0,1,.011.1.894.894,0,0,1-.13.445.794.794,0,0,1-.307.321l-3.017,1.6c-.265.141-.446.18-.546.119a1,1,0,0,1-.268-.247Z",
    transform: "translate(-76.583 -134.069)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2570",
    "data-name": "Group 2570",
    transform: "translate(0 92.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2561",
    "data-name": "Group 2561",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M173.626,221.3,64.894,278.944v5.765l108.732-57.648Z",
    transform: "translate(-64.894 -221.296)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M173.626,221.3,64.894,278.944v5.765l108.732-57.648Z",
    transform: "translate(-64.894 -221.296)",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M65.563,288.11l107.394-56.938V238.8L65.563,295.734V288.11m-.669-.18v8.693l108.732-57.648v-8.694L64.894,287.93Z",
    transform: "translate(-64.894 -224.517)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2562",
    "data-name": "Group 2562",
    transform: "translate(72.224 24.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M168.269,268.93l.669-.622v-8.1l-.669.622Z",
    transform: "translate(-168.269 -260.21)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2563",
    "data-name": "Group 2563",
    transform: "translate(36.367 43.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M116.947,298.535l.669-.622v-8.142l-.669.622Z",
    transform: "translate(-116.947 -289.771)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    d: "M65.563,300.828l107.394-56.939v7.624L65.563,308.451v-7.623m-.669-.18v8.694l108.732-57.648V243L64.894,300.647Z",
    transform: "translate(-64.894 -229.075)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2564",
    "data-name": "Group 2564",
    transform: "translate(72.224 33.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M168.269,281.647l.669-.622v-8.1l-.669.622Z",
    transform: "translate(-168.269 -272.927)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2565",
    "data-name": "Group 2565",
    transform: "translate(36.367 52.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    d: "M116.947,311.253l.669-.622v-8.142l-.669.622Z",
    transform: "translate(-116.947 -302.489)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M65.563,313.545l107.394-56.939v7.625L65.563,321.168v-7.623m-.669-.18v8.693l108.732-57.647v-8.695L64.894,313.364Z",
    transform: "translate(-64.894 -233.633)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2566",
    "data-name": "Group 2566",
    transform: "translate(72.224 41.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    d: "M168.269,294.364l.669-.622v-8.1l-.669.622Z",
    transform: "translate(-168.269 -285.645)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2567",
    "data-name": "Group 2567",
    transform: "translate(36.367 60.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M116.947,323.97l.669-.622v-8.142l-.669.622Z",
    transform: "translate(-116.947 -315.206)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M65.563,326.262l107.394-56.938v7.624L65.563,333.886v-7.624m-.669-.18v8.694l108.732-57.648v-8.694L64.894,326.082Z",
    transform: "translate(-64.894 -238.191)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2568",
    "data-name": "Group 2568",
    transform: "translate(72.224 49.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M168.269,307.081l.669-.622v-8.1l-.669.622Z",
    transform: "translate(-168.269 -298.362)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2569",
    "data-name": "Group 2569",
    transform: "translate(36.367 68.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M116.947,336.687l.669-.622v-8.142l-.669.622Z",
    transform: "translate(-116.947 -327.923)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M65.563,370.43l35.7-18.936V361.6l-35.7,18.937V370.43m-.669-.355v11.531l37.037-19.647V350.429L64.894,370.075Z",
    transform: "translate(-64.894 -174.77)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M196.832,301.039,141.9,330.162v4.854l54.93-29.122Z",
    transform: "translate(-88.1 -157.068)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2571",
    "data-name": "Group 2571",
    transform: "translate(0 88.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M112.979,214.517,64.894,240.011v5.765l48.085-25.494Z",
    transform: "translate(-64.894 -214.517)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M112.979,214.517,64.894,240.011v5.765l48.085-25.494Z",
    transform: "translate(-64.894 -214.517)",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2572",
    "data-name": "Group 2572",
    transform: "translate(1.986 120.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M71.556,268.978,67.736,271v-4.6l3.82-2.025Zm-3.366,1.3,2.913-1.546V265.1l-2.913,1.546Z",
    transform: "translate(-67.736 -264.377)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2573",
    "data-name": "Group 2573",
    transform: "translate(1.986 129.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M71.556,282.348l-3.82,2.025v-4.6l3.82-2.025Zm-3.366,1.3,2.913-1.546v-3.64l-2.913,1.546Z",
    transform: "translate(-67.736 -277.747)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2574",
    "data-name": "Group 2574",
    transform: "translate(1.986 137.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M71.556,295.718l-3.82,2.025v-4.6l3.82-2.025Zm-3.366,1.3,2.913-1.546v-3.64l-2.913,1.546Z",
    transform: "translate(-67.736 -291.117)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2577",
    "data-name": "Group 2577",
    transform: "translate(7.887 99.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2575",
    "data-name": "Group 2575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M114.5,232.929a.688.688,0,0,1-.17.138L76.354,253.2c-.163.086-.219-.045-.124-.294a1.282,1.282,0,0,1,.464-.606l37.973-20.133c.162-.086.218.046.124.294A1.5,1.5,0,0,1,114.5,232.929Z",
    transform: "translate(-76.183 -232.14)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2576",
    "data-name": "Group 2576",
    transform: "translate(0 2.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M114.5,236.324a.706.706,0,0,1-.17.139L76.354,256.6c-.163.087-.219-.045-.124-.294a1.291,1.291,0,0,1,.464-.606l37.973-20.133c.162-.086.218.046.124.294A1.487,1.487,0,0,1,114.5,236.324Z",
    transform: "translate(-76.183 -235.536)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2580",
    "data-name": "Group 2580",
    transform: "translate(7.887 108.345)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2578",
    "data-name": "Group 2578"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M114.5,246.3a.688.688,0,0,1-.17.138L76.354,266.57c-.163.086-.219-.045-.124-.294a1.284,1.284,0,0,1,.464-.606l37.973-20.132c.162-.086.218.045.124.294A1.5,1.5,0,0,1,114.5,246.3Z",
    transform: "translate(-76.183 -245.511)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2579",
    "data-name": "Group 2579",
    transform: "translate(0 2.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M114.5,249.7a.7.7,0,0,1-.17.138L76.354,269.966c-.163.087-.219-.045-.124-.294a1.288,1.288,0,0,1,.464-.606l37.973-20.134c.162-.086.218.046.124.294A1.5,1.5,0,0,1,114.5,249.7Z",
    transform: "translate(-76.183 -248.906)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2583",
    "data-name": "Group 2583",
    transform: "translate(7.887 116.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2581",
    "data-name": "Group 2581"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M114.5,259.669a.707.707,0,0,1-.17.139L76.354,279.94c-.163.086-.219-.046-.124-.294a1.29,1.29,0,0,1,.464-.606l37.973-20.132c.162-.086.218.046.124.294A1.487,1.487,0,0,1,114.5,259.669Z",
    transform: "translate(-76.183 -258.881)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2582",
    "data-name": "Group 2582",
    transform: "translate(0 2.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M114.5,263.065a.7.7,0,0,1-.17.138L76.354,283.336c-.163.087-.219-.045-.124-.294a1.287,1.287,0,0,1,.464-.606L114.666,262.3c.162-.086.218.046.124.294A1.5,1.5,0,0,1,114.5,263.065Z",
    transform: "translate(-76.183 -262.276)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2584",
    "data-name": "Group 2584",
    transform: "translate(60.647 56.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M199.784,164.4,151.7,189.895v5.765l48.085-25.494Z",
    transform: "translate(-151.699 -164.401)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M199.784,164.4,151.7,189.895v5.765l48.085-25.494Z",
    transform: "translate(-151.699 -164.401)",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2585",
    "data-name": "Group 2585",
    transform: "translate(62.633 88.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M158.36,218.861l-3.819,2.024v-4.6l3.819-2.025Zm-3.366,1.3,2.913-1.546v-3.64l-2.913,1.546Z",
    transform: "translate(-154.541 -214.26)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2586",
    "data-name": "Group 2586",
    transform: "translate(62.633 96.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M158.36,232.231l-3.819,2.025v-4.6l3.819-2.025Zm-3.366,1.3,2.913-1.546v-3.64l-2.913,1.546Z",
    transform: "translate(-154.541 -227.63)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2587",
    "data-name": "Group 2587",
    transform: "translate(62.633 105.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M158.36,245.6l-3.819,2.025v-4.6L158.36,241Zm-3.366,1.3,2.913-1.545v-3.64l-2.913,1.546Z",
    transform: "translate(-154.541 -241.001)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2590",
    "data-name": "Group 2590",
    transform: "translate(68.534 67.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2588",
    "data-name": "Group 2588"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M201.3,182.811a.708.708,0,0,1-.17.139l-37.973,20.133c-.162.086-.218-.046-.124-.294a1.283,1.283,0,0,1,.464-.606l37.972-20.133c.163-.087.218.046.124.294A1.513,1.513,0,0,1,201.3,182.811Z",
    transform: "translate(-162.988 -182.023)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2589",
    "data-name": "Group 2589",
    transform: "translate(0 2.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M201.3,186.208a.688.688,0,0,1-.17.138l-37.973,20.132c-.162.086-.218-.045-.124-.294a1.285,1.285,0,0,1,.464-.606l37.972-20.132c.163-.086.218.045.124.294A1.513,1.513,0,0,1,201.3,186.208Z",
    transform: "translate(-162.988 -185.42)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2593",
    "data-name": "Group 2593",
    transform: "translate(68.534 76.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2591",
    "data-name": "Group 2591"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M201.3,196.181a.708.708,0,0,1-.17.139l-37.973,20.133c-.162.086-.218-.046-.124-.294a1.278,1.278,0,0,1,.464-.606l37.972-20.134c.163-.087.218.046.124.294A1.513,1.513,0,0,1,201.3,196.181Z",
    transform: "translate(-162.988 -195.393)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2592",
    "data-name": "Group 2592",
    transform: "translate(0 2.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M201.3,199.579a.708.708,0,0,1-.17.139l-37.973,20.132c-.162.086-.218-.046-.124-.294a1.287,1.287,0,0,1,.464-.606l37.972-20.132c.163-.086.218.046.124.294A1.513,1.513,0,0,1,201.3,199.579Z",
    transform: "translate(-162.988 -198.79)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2596",
    "data-name": "Group 2596",
    transform: "translate(68.534 84.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2594",
    "data-name": "Group 2594"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M201.3,209.551a.708.708,0,0,1-.17.139l-37.973,20.133c-.162.086-.218-.045-.124-.294a1.279,1.279,0,0,1,.464-.606l37.972-20.134c.163-.087.218.046.124.294A1.513,1.513,0,0,1,201.3,209.551Z",
    transform: "translate(-162.988 -208.763)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2595",
    "data-name": "Group 2595",
    transform: "translate(0 2.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M201.3,212.949a.693.693,0,0,1-.17.139l-37.973,20.132c-.162.086-.218-.046-.124-.294a1.287,1.287,0,0,1,.464-.606l37.972-20.132c.163-.086.218.046.124.294A1.513,1.513,0,0,1,201.3,212.949Z",
    transform: "translate(-162.988 -212.16)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2597",
    "data-name": "Group 2597",
    transform: "translate(0 34.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M173.626,131.09,64.894,188.738V194.5l108.732-57.648Z",
    transform: "translate(-64.894 -131.09)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    d: "M173.626,131.09,64.894,188.738V194.5l108.732-57.648Z",
    transform: "translate(-64.894 -131.09)",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2598",
    "data-name": "Group 2598",
    transform: "translate(1.873 73.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M119.5,192.161a.707.707,0,0,1-.17.139l-51.59,27.352c-.162.086-.218-.045-.124-.294a1.28,1.28,0,0,1,.464-.606L119.673,191.4c.163-.086.219.046.124.294A1.487,1.487,0,0,1,119.5,192.161Z",
    transform: "translate(-67.574 -191.373)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2599",
    "data-name": "Group 2599",
    transform: "translate(1.873 49.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M171.862,154.155a.708.708,0,0,1-.17.139L67.744,209.406c-.162.086-.218-.046-.124-.294a1.288,1.288,0,0,1,.464-.606l103.948-55.113c.163-.086.219.046.124.295A1.5,1.5,0,0,1,171.862,154.155Z",
    transform: "translate(-67.574 -153.366)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2600",
    "data-name": "Group 2600",
    transform: "translate(1.873 52.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M171.862,159.107a.688.688,0,0,1-.17.138L67.744,214.358c-.162.086-.218-.046-.124-.294a1.285,1.285,0,0,1,.464-.606l103.948-55.111c.163-.086.219.045.124.294A1.508,1.508,0,0,1,171.862,159.107Z",
    transform: "translate(-67.574 -158.319)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2601",
    "data-name": "Group 2601",
    transform: "translate(1.873 51.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M119.5,157.579a.7.7,0,0,1-.17.138L67.744,185.07c-.162.086-.218-.046-.124-.294a1.279,1.279,0,0,1,.464-.606l51.589-27.352c.163-.086.219.045.124.294A1.5,1.5,0,0,1,119.5,157.579Z",
    transform: "translate(-67.574 -156.791)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2602",
    "data-name": "Group 2602",
    transform: "translate(1.873 27.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M171.862,119.572a.692.692,0,0,1-.17.139L67.744,174.823c-.162.086-.218-.046-.124-.294a1.282,1.282,0,0,1,.464-.606l103.948-55.113c.163-.086.219.046.124.294A1.5,1.5,0,0,1,171.862,119.572Z",
    transform: "translate(-67.574 -118.783)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2603",
    "data-name": "Group 2603",
    transform: "translate(1.873 30.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M171.862,124.525a.707.707,0,0,1-.17.139L67.744,179.775c-.162.086-.218-.045-.124-.294a1.285,1.285,0,0,1,.464-.606l103.948-55.111c.163-.086.219.046.124.294A1.5,1.5,0,0,1,171.862,124.525Z",
    transform: "translate(-67.574 -123.736)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2605",
    "data-name": "Group 2605",
    transform: "translate(0 78.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M186.542,162.038h-.01c-.122-.674-.509-.861-1.009-.543a2.861,2.861,0,0,0-.652.618l-.285.364-55.878,78.012-8.344,10.675a4.987,4.987,0,0,1-4.594,1.581l-7.2-1.572L53.585,232.586a3.043,3.043,0,0,0-1.121-.037,2.107,2.107,0,0,0-.418.121l2.072-1.1,52.713,17.741,6.94,2.274A4.959,4.959,0,0,0,118.367,250l8.344-10.665,56.153-78.377a2.175,2.175,0,0,1,.632-.533l-4.86-2.573,2.038-1.076,3.362,1.777A5.353,5.353,0,0,1,186.542,162.038Z",
    transform: "translate(-42.712 -156.776)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M184.748,302.231l-59.423-17.45a10.233,10.233,0,0,0-12.236,3.459L52.554,370.863l-2.239,1.187-.02.01a1.966,1.966,0,0,1-1.732.178l62.257-85.165a10.263,10.263,0,0,1,12.247-3.468Z",
    transform: "translate(-41.662 -201.957)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M216.152,158.551l-3.362-1.777-2.038,1.075,4.86,2.573.012.009-.008,0a2.174,2.174,0,0,0-.632.533l-56.066,78.25-.283.377.378.112,1.96.577,55.729-77.8.285-.365a2.827,2.827,0,0,1,.652-.617c.5-.318.887-.132,1.009.542h.01A5.356,5.356,0,0,0,216.152,158.551Z",
    transform: "translate(-74.831 -156.774)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2604",
    "data-name": "Group 2604",
    transform: "translate(0.002 70.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M50.676,273.709l-11.988-6.358V362.11a5.141,5.141,0,0,0,2.556,4.066l2.881,1.527a6.121,6.121,0,0,0,5.112,0l1.439-.762Z",
    transform: "translate(-38.688 -267.351)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M50.676,273.709l-11.988-6.358V362.11a5.141,5.141,0,0,0,2.556,4.066l2.881,1.527a6.121,6.121,0,0,0,5.112,0l1.439-.762Z",
    transform: "translate(-38.688 -267.351)",
    fill: "#fff",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M186.018,165.172v92.047a4.512,4.512,0,0,1-.8,2.376,5.311,5.311,0,0,1-1.5,1.544l-.1.046a1.6,1.6,0,0,1-.163.1L52.694,330.611a1.987,1.987,0,0,1-1.763.2,1.424,1.424,0,0,1-.764-1.123,2.757,2.757,0,0,1-.03-.421V237.208a2.18,2.18,0,0,1,2.873-2.077l54.982,18.587,7.2,1.572a4.986,4.986,0,0,0,4.594-1.581l8.344-10.675,55.878-78.012.285-.364C185.243,163.451,186.018,163.676,186.018,165.172Z",
    transform: "translate(-42.136 -159.322)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M186.018,165.172v92.047a4.512,4.512,0,0,1-.8,2.376,5.311,5.311,0,0,1-1.5,1.544l-.1.046a1.6,1.6,0,0,1-.163.1L52.694,330.611a1.987,1.987,0,0,1-1.763.2,1.424,1.424,0,0,1-.764-1.123,2.757,2.757,0,0,1-.03-.421V237.208a2.18,2.18,0,0,1,2.873-2.077l54.982,18.587,7.2,1.572a4.986,4.986,0,0,0,4.594-1.581l8.344-10.675,55.878-78.012.285-.364C185.243,163.451,186.018,163.676,186.018,165.172Z",
    transform: "translate(-42.136 -159.322)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M150.085,283.382c-5.23-1.552-9.789-.148-12.377,3.631l2.241,1.2c2.588-3.8,7.114-5.021,12.38-3.47l56.4,16.617Z",
    transform: "translate(-68.525 -201.93)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M150.085,283.382c-5.23-1.552-9.789-.148-12.377,3.631l2.241,1.2c2.588-3.8,7.114-5.021,12.38-3.47l56.4,16.617Z",
    transform: "translate(-68.525 -201.93)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M217.1,305.508a1.643,1.643,0,0,0,.168-.1l.1-.054a5.206,5.206,0,0,0,1.5-1.536,4.536,4.536,0,0,0,.794-2.337l-57.878-14.226,38.758,27.034Z",
    transform: "translate(-75.778 -203.541)",
    fill: "#ff725e",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M185.562,302.871a5.206,5.206,0,0,1-1.5,1.536l-.1.054L53.035,373.886l-.02.009a1.959,1.959,0,0,1-1.741.181l62.619-85.225a10.325,10.325,0,0,1,12.311-3.469Z",
    transform: "translate(-42.479 -202.593)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M185.562,302.871a5.206,5.206,0,0,1-1.5,1.536l.013,0L53.146,373.835l-.131.06a1.959,1.959,0,0,1-1.741.181l62.619-85.225a10.325,10.325,0,0,1,12.311-3.469l59.359,17.489",
    transform: "translate(-42.479 -202.593)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M39.164,254.076l2.079,1.1a8.632,8.632,0,0,0-.479,2.563v5.95l-2.079-1.1V256.63A8.658,8.658,0,0,1,39.164,254.076Z",
    transform: "translate(-38.685 -191.649)",
    fill: "#fff",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M50.986,271.205l-2.072,1.1-2.1-1.113-5.165-2.732,2.007-1.095Z",
    transform: "translate(-39.579 -196.412)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M51.078,271.241l-7.421-3.875-2.007,1.095,5.165,2.732,2.1,1.113.022-.012a2.169,2.169,0,0,1,.393-.114,3.056,3.056,0,0,1,1.121.037l4.178,1.416,48.014,16.232.731-1.029Z",
    transform: "translate(-39.578 -196.412)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M113.539,290.578,50.926,375.787a1.582,1.582,0,0,1-.794-1.544l0-1.53,61.162-83.3c0-.009.01-.019.02-.028Z",
    transform: "translate(-42.134 -204.306)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M113.539,290.578,50.926,375.787a1.582,1.582,0,0,1-.794-1.544l0-1.53,61.162-83.3c0-.009.01-.019.02-.028Z",
    transform: "translate(-42.134 -204.306)",
    fill: "#fff",
    opacity: 0.3
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Form_2",
    "data-name": "Form 2",
    transform: "translate(57.461 42.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Form-2",
    "data-name": "Form"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paper-2",
    "data-name": "Paper"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1339",
    "data-name": "Path 1339",
    transform: "translate(-79.537 -50.105)",
    fill: "#fafafa",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 82.70970916748047 297.94091796875 C 82.40767669677734 297.94091796875 82.11974334716797 297.8800354003906 81.91970825195312 297.7738647460938 L 80.77433776855469 297.1668090820312 C 80.36964416503906 296.9519958496094 80.01439666748047 296.3952941894531 80.01439666748047 295.9756774902344 L 80.01439666748047 114.7492446899414 C 80.01439666748047 114.32958984375 80.36961364746094 113.7729339599609 80.77458190917969 113.557991027832 L 199.2367706298828 50.75146102905273 C 199.4370269775391 50.64543151855469 199.7253112792969 50.58452606201172 200.027587890625 50.58452606201172 C 200.3296203613281 50.58452606201172 200.6176147460938 50.64540100097656 200.8177337646484 50.75149536132812 L 201.9600219726562 51.35712051391602 C 202.365234375 51.57196426391602 202.720703125 52.12858963012695 202.720703125 52.54827499389648 L 202.720703125 233.7766265869141 C 202.720703125 234.1964874267578 202.3654327392578 234.752685546875 201.9604339599609 234.9669342041016 L 83.50042724609375 297.7737426757812 C 83.30002593994141 297.8800048828125 83.01180267333984 297.94091796875 82.70970916748047 297.94091796875 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 200.0275573730469 51.06192016601562 C 199.7643432617188 51.06192016601562 199.5618286132812 51.1195068359375 199.4603881835938 51.17327880859375 L 80.9984130859375 113.9796447753906 C 80.73031616210938 114.1219482421875 80.49179077148438 114.5285491943359 80.49179077148438 114.7492218017578 L 80.49179077148438 295.9756774902344 C 80.49179077148438 296.1963500976562 80.73031616210938 296.6029663085938 80.99789428710938 296.7449951171875 L 82.1435546875 297.3521728515625 C 82.24494934082031 297.406005859375 82.44696044921875 297.4635620117188 82.70968627929688 297.4635620117188 C 82.97262573242188 297.4635620117188 83.175048828125 297.4058837890625 83.27679443359375 297.3519592285156 L 201.7372436523438 234.5448913574219 C 202.0050201416016 234.4032592773438 202.2433166503906 233.9972839355469 202.2433166503906 233.776611328125 L 202.2433166503906 52.54827880859375 C 202.2433166503906 52.32760620117188 202.0046539306641 51.92111206054688 201.7363891601562 51.77890014648438 L 200.5941162109375 51.17327880859375 C 200.4925842285156 51.11944580078125 200.2904205322266 51.06192016601562 200.0275573730469 51.06192016601562 M 200.0275573730469 50.10711669921875 C 200.3944396972656 50.10711669921875 200.7613220214844 50.18121337890625 201.0413513183594 50.32968139648438 L 202.1836547851562 50.93533325195312 C 202.7439880371094 51.23239135742188 203.1981201171875 51.95416259765625 203.1981201171875 52.54827880859375 L 203.1981201171875 233.776611328125 C 203.1981201171875 234.3700866699219 202.7439880371094 235.0925598144531 202.1836547851562 235.388916015625 L 83.72406005859375 298.1955261230469 C 83.16372680664062 298.4926147460938 82.25550842285156 298.4926147460938 81.69584655761719 298.1955261230469 L 80.55075073242188 297.588623046875 C 79.99111938476562 297.2915649414062 79.5369873046875 296.5697631835938 79.5369873046875 295.9756774902344 L 79.5369873046875 114.7492218017578 C 79.5369873046875 114.1551208496094 79.99111938476562 113.433349609375 80.55075073242188 113.1362915039062 L 199.0131225585938 50.32968139648438 C 199.2930755615234 50.181396484375 199.6603088378906 50.10711669921875 200.0275573730469 50.10711669921875 Z",
    stroke: "none",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M83.483,333.9a2.1,2.1,0,0,1-.374.093l-.195.021a2.919,2.919,0,0,1-.617-.021,1.81,1.81,0,0,1-.6-.194l-1.14-.6a2.032,2.032,0,0,1-1.015-1.613V150.357a1.73,1.73,0,0,1,.3-.917l3.17,1.677a1.845,1.845,0,0,0-.3.918V333.261C82.71,333.77,83.038,334.021,83.483,333.9Z",
    transform: "translate(-79.538 -85.708)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2608",
    "data-name": "Group 2608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2606",
    "data-name": "Group 2606",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M202.184,50.935l-1.142-.606a2.419,2.419,0,0,0-2.028,0L80.551,113.136a2.032,2.032,0,0,0-1.014,1.613v11.743l3.172,1.693L203.2,64.3V52.548A2.032,2.032,0,0,0,202.184,50.935Z",
    transform: "translate(-79.537 -50.107)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2607",
    "data-name": "Group 2607",
    transform: "translate(0.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M203.29,52.266c-.125-.38-.515-.5-.975-.258L83.853,114.815a1.944,1.944,0,0,0-.718.7l-3.17-1.677a1.893,1.893,0,0,1,.719-.7L199.146,50.33a2.376,2.376,0,0,1,2.021,0l1.148.6A2.067,2.067,0,0,1,203.29,52.266Z",
    transform: "translate(-79.965 -50.104)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M79.541,150.352v11.753l3.169,1.68V152.03a1.843,1.843,0,0,1,.3-.917l-3.17-1.677A1.73,1.73,0,0,0,79.541,150.352Z",
    transform: "translate(-79.538 -85.706)",
    opacity: 0.15
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Forms-2",
    "data-name": "Forms",
    transform: "translate(8.733 27.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2611",
    "data-name": "Group 2611",
    transform: "translate(0.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2609",
    "data-name": "Group 2609",
    transform: "translate(70.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M236.722,92.331l-25.371,13.451v2.242l25.371-13.451Z",
    transform: "translate(-198.666 -92.331)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M231.251,99.32,193.195,119.5v2.242l38.056-20.176Z",
    transform: "translate(-193.195 -94.836)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M233.074,106.308l-33.828,17.935v2.242l33.828-17.935Z",
    transform: "translate(-195.018 -97.34)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2610",
    "data-name": "Group 2610",
    transform: "translate(0 36.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M104.047,172.17a.344.344,0,0,1,.377-.006.427.427,0,0,1,.159.377v2.575a1.1,1.1,0,0,1-.159.546.965.965,0,0,1-.377.395l-3.493,1.852v12.464a1.107,1.107,0,0,1-.158.546.98.98,0,0,1-.377.394l-2.6,1.379a.346.346,0,0,1-.377.006.429.429,0,0,1-.158-.379V179.855l-3.493,1.852a.343.343,0,0,1-.377.006.428.428,0,0,1-.159-.378V178.76a1.093,1.093,0,0,1,.159-.545.967.967,0,0,1,.377-.394Z",
    transform: "translate(-92.855 -157.77)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M117.045,165.3c.265-.141.467-.158.606-.055a.8.8,0,0,1,.288.382l4.326,13.013a.937.937,0,0,1,.08.323.889.889,0,0,1-.129.444.794.794,0,0,1-.308.321l-2.5,1.325c-.266.142-.454.173-.567.095a.476.476,0,0,1-.208-.291l-.555-1.723-5.279,2.8-.555,2.311a1.71,1.71,0,0,1-.209.512,1.356,1.356,0,0,1-.565.507l-2.5,1.326a.282.282,0,0,1-.308.005.352.352,0,0,1-.129-.309,1.768,1.768,0,0,1,.08-.407l4.326-17.6a2.982,2.982,0,0,1,.287-.686,1.449,1.449,0,0,1,.606-.588Zm-3.214,12.321,3.214-1.7-1.606-4.979Z",
    transform: "translate(-97.579 -155.285)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M135.733,165.2l-2.54,5.72a4.385,4.385,0,0,1-.268.532,1.35,1.35,0,0,1-.545.458l-3.017,1.6a.282.282,0,0,1-.308.006.349.349,0,0,1-.129-.309.832.832,0,0,1,.01-.115,1.312,1.312,0,0,1,.05-.184l4.585-10.278-4.385-5.231a.493.493,0,0,1-.059-.236.894.894,0,0,1,.129-.445.789.789,0,0,1,.308-.32l3-1.589c.266-.14.457-.16.576-.062s.2.175.258.228l2.4,2.833,2.321-5.337c.053-.108.14-.277.259-.5a1.336,1.336,0,0,1,.576-.549l3.036-1.609a.28.28,0,0,1,.308-.006.353.353,0,0,1,.129.309.972.972,0,0,1-.059.3l-4.406,9.99,4.545,5.34a.522.522,0,0,1,.048.133.5.5,0,0,1,.011.1.9.9,0,0,1-.13.445.787.787,0,0,1-.307.32l-3.018,1.6c-.265.141-.446.18-.545.119a1,1,0,0,1-.268-.248Z",
    transform: "translate(-103.725 -149.759)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2621",
    "data-name": "Group 2621",
    transform: "translate(0 92.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2612",
    "data-name": "Group 2612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M200.768,236.987,92.036,294.635V300.4l108.732-57.648Z",
    transform: "translate(-92.036 -236.987)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M200.768,236.987,92.036,294.635V300.4l108.732-57.648Z",
    transform: "translate(-92.036 -236.987)",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M92.705,303.8,200.1,246.862v7.625L92.705,311.424V303.8m-.669-.18v8.693l108.731-57.647v-8.695L92.036,303.62Z",
    transform: "translate(-92.036 -240.207)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2613",
    "data-name": "Group 2613",
    transform: "translate(72.224 24.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M195.411,284.62l.669-.622v-8.1l-.669.622Z",
    transform: "translate(-195.411 -275.901)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2614",
    "data-name": "Group 2614",
    transform: "translate(36.367 43.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M144.089,314.226l.669-.622v-8.142l-.669.622Z",
    transform: "translate(-144.089 -305.462)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M92.705,316.518,200.1,259.58V267.2L92.705,324.142v-7.624m-.669-.18v8.694l108.731-57.648V258.69L92.036,316.338Z",
    transform: "translate(-92.036 -244.766)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2615",
    "data-name": "Group 2615",
    transform: "translate(72.224 33.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M195.411,297.337l.669-.622v-8.1l-.669.622Z",
    transform: "translate(-195.411 -288.618)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2616",
    "data-name": "Group 2616",
    transform: "translate(36.367 52.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M144.089,326.943l.669-.622v-8.142l-.669.622Z",
    transform: "translate(-144.089 -318.179)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M92.705,329.236,200.1,272.3v7.624L92.705,336.859v-7.623m-.669-.18v8.693L200.767,280.1v-8.694L92.036,329.055Z",
    transform: "translate(-92.036 -249.324)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2617",
    "data-name": "Group 2617",
    transform: "translate(72.224 41.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M195.411,310.055l.669-.622v-8.1l-.669.622Z",
    transform: "translate(-195.411 -301.335)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2618",
    "data-name": "Group 2618",
    transform: "translate(36.367 60.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M144.089,339.66l.669-.622V330.9l-.669.622Z",
    transform: "translate(-144.089 -330.896)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M92.705,341.953,200.1,285.014v7.624L92.705,349.576v-7.623m-.669-.18v8.693l108.731-57.648v-8.694L92.036,341.772Z",
    transform: "translate(-92.036 -253.882)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2619",
    "data-name": "Group 2619",
    transform: "translate(72.224 49.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M195.411,322.772l.669-.622v-8.1l-.669.622Z",
    transform: "translate(-195.411 -314.052)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2620",
    "data-name": "Group 2620",
    transform: "translate(36.367 68.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M144.089,352.378l.669-.622v-8.142l-.669.622Z",
    transform: "translate(-144.089 -343.614)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M92.705,386.12l35.7-18.936v10.111l-35.7,18.937V386.12m-.669-.354V397.3l37.037-19.647v-11.53L92.036,385.766Z",
    transform: "translate(-92.036 -190.461)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M223.973,316.73l-54.93,29.123v4.854l54.93-29.122Z",
    transform: "translate(-115.242 -172.759)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2622",
    "data-name": "Group 2622",
    transform: "translate(0 88.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M140.121,230.208,92.036,255.7v5.765l48.085-25.494Z",
    transform: "translate(-92.036 -230.208)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M140.121,230.208,92.036,255.7v5.765l48.085-25.494Z",
    transform: "translate(-92.036 -230.208)",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2623",
    "data-name": "Group 2623",
    transform: "translate(1.986 120.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M98.7,284.668l-3.82,2.025v-4.6l3.82-2.025Zm-3.367,1.3,2.913-1.546v-3.64l-2.913,1.546Z",
    transform: "translate(-94.878 -280.067)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2624",
    "data-name": "Group 2624",
    transform: "translate(1.986 129.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M98.7,298.038l-3.82,2.025v-4.6l3.82-2.025Zm-3.367,1.3,2.913-1.546v-3.64L95.331,295.7Z",
    transform: "translate(-94.878 -293.437)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2625",
    "data-name": "Group 2625",
    transform: "translate(1.986 137.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M98.7,311.408l-3.82,2.025v-4.6l3.82-2.025Zm-3.367,1.3,2.913-1.546v-3.64l-2.913,1.546Z",
    transform: "translate(-94.878 -306.807)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2628",
    "data-name": "Group 2628",
    transform: "translate(7.887 99.767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2626",
    "data-name": "Group 2626"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M141.637,248.62a.708.708,0,0,1-.17.139L103.5,268.89c-.163.086-.219-.046-.124-.294a1.283,1.283,0,0,1,.464-.606l37.972-20.132c.163-.086.219.046.124.294A1.487,1.487,0,0,1,141.637,248.62Z",
    transform: "translate(-103.325 -247.831)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2627",
    "data-name": "Group 2627",
    transform: "translate(0 2.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M141.637,252.015a.688.688,0,0,1-.17.138L103.5,272.286c-.163.087-.219-.045-.124-.294a1.283,1.283,0,0,1,.464-.606l37.972-20.134c.163-.086.219.046.124.294A1.489,1.489,0,0,1,141.637,252.015Z",
    transform: "translate(-103.325 -251.226)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2631",
    "data-name": "Group 2631",
    transform: "translate(7.887 108.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2629",
    "data-name": "Group 2629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M141.637,261.99a.7.7,0,0,1-.17.138L103.5,282.26c-.163.086-.219-.046-.124-.294a1.283,1.283,0,0,1,.464-.606l37.972-20.132c.163-.086.219.046.124.294A1.5,1.5,0,0,1,141.637,261.99Z",
    transform: "translate(-103.325 -261.201)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2630",
    "data-name": "Group 2630",
    transform: "translate(0 2.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M141.637,265.385a.689.689,0,0,1-.17.138L103.5,285.657c-.163.087-.219-.046-.124-.294a1.286,1.286,0,0,1,.464-.606l37.972-20.133c.163-.086.219.045.124.294A1.5,1.5,0,0,1,141.637,265.385Z",
    transform: "translate(-103.325 -264.597)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2634",
    "data-name": "Group 2634",
    transform: "translate(7.887 116.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2632",
    "data-name": "Group 2632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M141.637,275.36a.7.7,0,0,1-.17.138L103.5,295.63c-.163.086-.219-.046-.124-.294a1.284,1.284,0,0,1,.464-.606L141.807,274.6c.163-.087.219.045.124.294A1.5,1.5,0,0,1,141.637,275.36Z",
    transform: "translate(-103.325 -274.571)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2633",
    "data-name": "Group 2633",
    transform: "translate(0 2.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M141.637,278.756a.708.708,0,0,1-.17.139L103.5,299.027c-.163.087-.219-.046-.124-.294a1.286,1.286,0,0,1,.464-.606l37.972-20.133c.163-.086.219.046.124.294A1.488,1.488,0,0,1,141.637,278.756Z",
    transform: "translate(-103.325 -277.967)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2635",
    "data-name": "Group 2635",
    transform: "translate(60.647 56.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M226.926,180.091,178.84,205.585v5.765l48.085-25.494Z",
    transform: "translate(-178.84 -180.091)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M226.926,180.091,178.84,205.585v5.765l48.085-25.494Z",
    transform: "translate(-178.84 -180.091)",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2636",
    "data-name": "Group 2636",
    transform: "translate(62.632 88.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M185.5,234.552l-3.82,2.025v-4.6l3.82-2.025Zm-3.366,1.3,2.913-1.545v-3.64l-2.913,1.545Z",
    transform: "translate(-181.682 -229.951)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2637",
    "data-name": "Group 2637",
    transform: "translate(62.632 96.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M185.5,247.922l-3.82,2.025v-4.6l3.82-2.025Zm-3.366,1.3,2.913-1.546v-3.64l-2.913,1.545Z",
    transform: "translate(-181.682 -243.321)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2638",
    "data-name": "Group 2638",
    transform: "translate(62.632 105.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M185.5,261.292l-3.82,2.025v-4.6l3.82-2.025Zm-3.366,1.3,2.913-1.546v-3.64l-2.913,1.546Z",
    transform: "translate(-181.682 -256.691)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2641",
    "data-name": "Group 2641",
    transform: "translate(68.534 67.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2639",
    "data-name": "Group 2639"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M228.442,198.5a.7.7,0,0,1-.17.138L190.3,218.773c-.163.086-.218-.045-.124-.294a1.28,1.28,0,0,1,.465-.606l37.972-20.133c.162-.087.218.045.124.294A1.507,1.507,0,0,1,228.442,198.5Z",
    transform: "translate(-190.13 -197.713)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2640",
    "data-name": "Group 2640",
    transform: "translate(0 2.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M228.442,201.9a.693.693,0,0,1-.17.139L190.3,222.169c-.163.086-.218-.046-.124-.295a1.288,1.288,0,0,1,.465-.606l37.972-20.132c.162-.086.218.046.124.294A1.5,1.5,0,0,1,228.442,201.9Z",
    transform: "translate(-190.13 -201.11)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2644",
    "data-name": "Group 2644",
    transform: "translate(68.534 76.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2642",
    "data-name": "Group 2642"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M228.442,211.872a.689.689,0,0,1-.17.138L190.3,232.144c-.163.086-.218-.046-.124-.294a1.282,1.282,0,0,1,.465-.606l37.972-20.133c.162-.087.218.045.124.294A1.512,1.512,0,0,1,228.442,211.872Z",
    transform: "translate(-190.13 -211.083)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2643",
    "data-name": "Group 2643",
    transform: "translate(0 2.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M228.442,215.269a.7.7,0,0,1-.17.138L190.3,235.539c-.163.086-.218-.046-.124-.294a1.288,1.288,0,0,1,.465-.606l37.972-20.132c.162-.086.218.046.124.295A1.508,1.508,0,0,1,228.442,215.269Z",
    transform: "translate(-190.13 -214.48)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2647",
    "data-name": "Group 2647",
    transform: "translate(68.534 84.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2645",
    "data-name": "Group 2645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M228.442,225.242a.708.708,0,0,1-.17.139L190.3,245.514c-.163.086-.218-.046-.124-.294a1.285,1.285,0,0,1,.465-.606l37.972-20.133c.162-.087.218.046.124.294A1.5,1.5,0,0,1,228.442,225.242Z",
    transform: "translate(-190.13 -224.454)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2646",
    "data-name": "Group 2646",
    transform: "translate(0 2.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M228.442,228.639a.688.688,0,0,1-.17.138L190.3,248.91c-.163.086-.218-.045-.124-.294a1.283,1.283,0,0,1,.465-.606l37.972-20.132c.162-.086.218.045.124.294A1.5,1.5,0,0,1,228.442,228.639Z",
    transform: "translate(-190.13 -227.851)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2648",
    "data-name": "Group 2648",
    transform: "translate(0 34.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M200.768,146.78,92.036,204.428v5.765l108.732-57.648Z",
    transform: "translate(-92.036 -146.78)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M200.768,146.78,92.036,204.428v5.765l108.732-57.648Z",
    transform: "translate(-92.036 -146.78)",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2649",
    "data-name": "Group 2649",
    transform: "translate(1.872 73.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M146.645,207.852a.688.688,0,0,1-.17.138l-51.59,27.353c-.163.086-.218-.046-.124-.295a1.29,1.29,0,0,1,.464-.606l51.59-27.352c.163-.086.219.045.124.295A1.507,1.507,0,0,1,146.645,207.852Z",
    transform: "translate(-94.716 -207.064)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2650",
    "data-name": "Group 2650",
    transform: "translate(1.872 49.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M199,169.845a.689.689,0,0,1-.17.138L94.886,225.1c-.163.086-.218-.046-.124-.294a1.3,1.3,0,0,1,.464-.606l103.948-55.112c.163-.086.218.045.124.294A1.523,1.523,0,0,1,199,169.845Z",
    transform: "translate(-94.716 -169.057)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2651",
    "data-name": "Group 2651",
    transform: "translate(1.872 52.403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M199,174.8a.709.709,0,0,1-.17.139L94.886,230.048c-.163.086-.218-.045-.124-.294a1.294,1.294,0,0,1,.464-.606l103.948-55.112c.163-.086.218.046.124.294A1.513,1.513,0,0,1,199,174.8Z",
    transform: "translate(-94.716 -174.009)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2652",
    "data-name": "Group 2652",
    transform: "translate(1.872 51.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M146.645,173.27a.707.707,0,0,1-.17.139L94.886,200.76c-.163.086-.218-.045-.124-.294a1.287,1.287,0,0,1,.464-.606l51.59-27.352c.163-.086.219.046.124.294A1.5,1.5,0,0,1,146.645,173.27Z",
    transform: "translate(-94.716 -172.481)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2653",
    "data-name": "Group 2653",
    transform: "translate(1.872 27.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M199,135.263a.709.709,0,0,1-.17.139L94.886,190.513c-.163.086-.218-.045-.124-.294a1.289,1.289,0,0,1,.464-.606L199.174,134.5c.163-.086.218.046.124.294A1.512,1.512,0,0,1,199,135.263Z",
    transform: "translate(-94.716 -134.474)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2654",
    "data-name": "Group 2654",
    transform: "translate(1.872 30.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M199,140.215a.69.69,0,0,1-.17.138L94.886,195.465c-.163.086-.218-.046-.124-.294a1.291,1.291,0,0,1,.464-.606l103.948-55.111c.163-.086.218.045.124.294A1.516,1.516,0,0,1,199,140.215Z",
    transform: "translate(-94.716 -139.427)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Form_1",
    "data-name": "Form 1",
    transform: "translate(76.433 52.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Form-3",
    "data-name": "Form",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paper-3",
    "data-name": "Paper"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1396",
    "data-name": "Path 1396",
    transform: "translate(-106.691 -65.764)",
    fill: "#fafafa",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 109.8643264770508 313.599853515625 C 109.5623245239258 313.599853515625 109.2743911743164 313.5389404296875 109.0743560791016 313.4328002929688 L 107.9290161132812 312.8257141113281 C 107.5238571166992 312.6109008789062 107.1684188842773 312.0542907714844 107.1684188842773 311.6345825195312 L 107.1684188842773 130.407470703125 C 107.1684188842773 129.9876403808594 107.5237045288086 129.4314117431641 107.9287033081055 129.2171630859375 L 226.3907928466797 66.41032409667969 C 226.5911712646484 66.30410003662109 226.87939453125 66.2431640625 227.1815185546875 66.2431640625 C 227.4835815429688 66.2431640625 227.7715454101562 66.30406951904297 227.9715728759766 66.41022491455078 L 229.1148529052734 67.01603698730469 C 229.5196685791016 67.23047637939453 229.8747253417969 67.78675842285156 229.8747253417969 68.20651245117188 L 229.8747253417969 249.4348907470703 C 229.8747253417969 249.8545379638672 229.5195159912109 250.4111938476562 229.1145477294922 250.6261291503906 L 110.6544494628906 313.4327087402344 C 110.454231262207 313.5389404296875 110.1663284301758 313.599853515625 109.8643264770508 313.599853515625 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 227.1815185546875 66.72055053710938 C 226.9185485839844 66.72055053710938 226.7161102294922 66.77816772460938 226.6144409179688 66.83206176757812 L 108.1519165039062 129.6391754150391 C 107.8841094970703 129.7808380126953 107.6458129882812 130.1868133544922 107.6458129882812 130.407470703125 L 107.6458129882812 311.6345825195312 C 107.6458129882812 311.8552856445312 107.8844451904297 312.2617492675781 108.1526031494141 312.4038696289062 L 109.2982482910156 313.0111083984375 C 109.3996429443359 313.0649108886719 109.6015777587891 313.1224365234375 109.8643035888672 313.1224365234375 C 110.1270141601562 313.1224365234375 110.3289489746094 313.0649108886719 110.4307708740234 313.0108642578125 L 228.8907470703125 250.2044372558594 C 229.1588134765625 250.0621490478516 229.3973388671875 249.6555786132812 229.3973388671875 249.4348754882812 L 229.3973388671875 68.20648193359375 C 229.3973388671875 67.98580932617188 229.1591796875 67.57974243164062 228.8913116455078 67.4378662109375 L 227.747802734375 66.8319091796875 C 227.6463317871094 66.778076171875 227.4443054199219 66.72055053710938 227.1815185546875 66.72055053710938 M 227.1815185546875 65.7657470703125 C 227.548583984375 65.7657470703125 227.9155578613281 65.83999633789062 228.1953735351562 65.98849487304688 L 229.33837890625 66.59420776367188 C 229.8980102539062 66.89056396484375 230.3521423339844 67.613037109375 230.3521423339844 68.20648193359375 L 230.3521423339844 249.4348754882812 C 230.3521423339844 250.0289764404297 229.8980102539062 250.7507781982422 229.33837890625 251.0478057861328 L 110.8780364990234 313.8544311523438 C 110.3184356689453 314.1515197753906 109.4101715087891 314.1515197753906 108.8505401611328 313.8544311523438 L 107.7054443359375 313.2474975585938 C 107.1451110839844 312.9504699707031 106.6910095214844 312.22802734375 106.6910095214844 311.6345825195312 L 106.6910095214844 130.407470703125 C 106.6910095214844 129.8140106201172 107.1451110839844 129.0915679931641 107.7054443359375 128.7951812744141 L 226.1671752929688 65.98849487304688 C 226.4473266601562 65.83999633789062 226.8144683837891 65.7657470703125 227.1815185546875 65.7657470703125 Z",
    stroke: "none",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M110.638,349.558a2.006,2.006,0,0,1-.375.093l-.195.022a2.968,2.968,0,0,1-.617-.022,2.012,2.012,0,0,1-.374-.093,2.139,2.139,0,0,1-.226-.1l-1.14-.6a2.033,2.033,0,0,1-1.015-1.613V166.016a1.731,1.731,0,0,1,.3-.917l3.169,1.677a1.842,1.842,0,0,0-.3.917V348.92C109.865,349.429,110.192,349.68,110.638,349.558Z",
    transform: "translate(-106.692 -101.367)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2657",
    "data-name": "Group 2657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2655",
    "data-name": "Group 2655",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M229.338,66.594l-1.142-.606a2.419,2.419,0,0,0-2.028,0L107.705,128.8a2.03,2.03,0,0,0-1.014,1.612v11.744l3.173,1.693L230.352,79.962V68.206A2.031,2.031,0,0,0,229.338,66.594Z",
    transform: "translate(-106.691 -65.766)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M229.338,66.594l-1.142-.606a2.419,2.419,0,0,0-2.028,0L107.705,128.8a2.03,2.03,0,0,0-1.014,1.612v11.744l3.173,1.693L230.352,79.962V68.206A2.031,2.031,0,0,0,229.338,66.594Z",
    transform: "translate(-106.691 -65.766)",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2656",
    "data-name": "Group 2656",
    transform: "translate(0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M230.445,67.924c-.125-.38-.515-.5-.976-.258L111.007,130.474a1.95,1.95,0,0,0-.718.7l-3.169-1.678a1.894,1.894,0,0,1,.718-.695L226.3,65.989a2.377,2.377,0,0,1,2.022,0l1.147.6A2.069,2.069,0,0,1,230.445,67.924Z",
    transform: "translate(-107.12 -65.763)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M230.445,67.924c-.125-.38-.515-.5-.976-.258L111.007,130.474a1.95,1.95,0,0,0-.718.7l-3.169-1.678a1.894,1.894,0,0,1,.718-.695L226.3,65.989a2.377,2.377,0,0,1,2.022,0l1.147.6A2.069,2.069,0,0,1,230.445,67.924Z",
    transform: "translate(-107.12 -65.763)",
    fill: "#fff",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M106.7,166.01v11.753l3.17,1.68V167.688a1.842,1.842,0,0,1,.3-.917l-3.169-1.678A1.731,1.731,0,0,0,106.7,166.01Z",
    transform: "translate(-106.692 -101.365)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Forms-3",
    "data-name": "Forms",
    transform: "translate(8.733 27.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2660",
    "data-name": "Group 2660",
    transform: "translate(0.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2658",
    "data-name": "Group 2658",
    transform: "translate(70.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M263.877,107.989l-25.371,13.451v2.242l25.371-13.451Z",
    transform: "translate(-225.82 -107.989)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M258.405,114.978l-38.056,20.177V137.4L258.4,117.221Z",
    transform: "translate(-220.349 -110.494)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M260.229,121.966,226.4,139.9v2.242l33.828-17.935Z",
    transform: "translate(-222.173 -112.999)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2659",
    "data-name": "Group 2659",
    transform: "translate(0 36.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M131.2,187.828a.346.346,0,0,1,.377-.006.429.429,0,0,1,.159.378v2.575a1.1,1.1,0,0,1-.159.546.971.971,0,0,1-.377.394l-3.493,1.853v12.463a1.1,1.1,0,0,1-.158.546.971.971,0,0,1-.377.394l-2.6,1.379a.344.344,0,0,1-.377.006.426.426,0,0,1-.158-.379V195.514l-3.493,1.852a.342.342,0,0,1-.377.006.426.426,0,0,1-.158-.378v-2.576a1.092,1.092,0,0,1,.158-.545.977.977,0,0,1,.377-.395Z",
    transform: "translate(-120.01 -173.429)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M144.2,180.956q.4-.211.606-.054a.811.811,0,0,1,.288.382L149.42,194.3a.944.944,0,0,1,.08.323.893.893,0,0,1-.129.445.793.793,0,0,1-.307.321l-2.5,1.325c-.265.142-.454.173-.566.094a.472.472,0,0,1-.208-.291l-.555-1.723-5.279,2.8L139.4,199.9a1.743,1.743,0,0,1-.209.512,1.358,1.358,0,0,1-.566.506l-2.5,1.326a.282.282,0,0,1-.308.006.351.351,0,0,1-.129-.309,1.793,1.793,0,0,1,.079-.406l4.327-17.6a2.98,2.98,0,0,1,.286-.687,1.449,1.449,0,0,1,.606-.588Zm-3.215,12.322,3.215-1.7-1.607-4.979Z",
    transform: "translate(-124.734 -170.944)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M162.888,180.856l-2.54,5.72a4.282,4.282,0,0,1-.269.531,1.338,1.338,0,0,1-.544.458l-3.018,1.6a.281.281,0,0,1-.307.006.35.35,0,0,1-.129-.309.844.844,0,0,1,.01-.115,1.247,1.247,0,0,1,.049-.184l4.585-10.279-4.385-5.231a.5.5,0,0,1-.059-.235.891.891,0,0,1,.129-.445.79.79,0,0,1,.307-.321l3-1.588c.265-.141.456-.16.576-.063s.205.176.258.228l2.4,2.833,2.321-5.337c.053-.108.14-.277.258-.5a1.335,1.335,0,0,1,.576-.548l3.035-1.609a.279.279,0,0,1,.308-.006.351.351,0,0,1,.129.309.944.944,0,0,1-.059.3l-4.406,9.99,4.545,5.341a.523.523,0,0,1,.049.132.549.549,0,0,1,.01.1.893.893,0,0,1-.129.445.8.8,0,0,1-.307.321L166.26,184c-.265.141-.446.18-.546.119a.993.993,0,0,1-.268-.247Z",
    transform: "translate(-130.879 -165.418)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2670",
    "data-name": "Group 2670",
    transform: "translate(0 92.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2661",
    "data-name": "Group 2661",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M227.922,252.645,119.191,310.293v5.765L227.922,258.41Z",
    transform: "translate(-119.191 -252.645)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    d: "M227.922,252.645,119.191,310.293v5.765L227.922,258.41Z",
    transform: "translate(-119.191 -252.645)",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M119.859,319.459l107.394-56.938v7.624L119.859,327.083v-7.624m-.669-.18v8.693l108.732-57.648v-8.694L119.19,319.279Z",
    transform: "translate(-119.19 -255.866)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2662",
    "data-name": "Group 2662",
    transform: "translate(72.224 24.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M222.565,300.279l.669-.622v-8.1l-.669.622Z",
    transform: "translate(-222.565 -291.559)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2663",
    "data-name": "Group 2663",
    transform: "translate(36.367 43.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M171.243,329.884l.669-.622V321.12l-.669.622Z",
    transform: "translate(-171.243 -321.12)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M119.859,332.177l107.394-56.939v7.624L119.859,339.8v-7.623m-.669-.18v8.694l108.732-57.648v-8.694L119.19,332Z",
    transform: "translate(-119.19 -260.424)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2664",
    "data-name": "Group 2664",
    transform: "translate(72.224 33.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M222.565,313l.669-.622v-8.1l-.669.622Z",
    transform: "translate(-222.565 -304.276)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2665",
    "data-name": "Group 2665",
    transform: "translate(36.367 52.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M171.243,342.6l.669-.622v-8.142l-.669.622Z",
    transform: "translate(-171.243 -333.838)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M119.859,344.894l107.394-56.938v7.624L119.859,352.517v-7.623m-.669-.18v8.694L227.922,295.76v-8.695L119.19,344.713Z",
    transform: "translate(-119.19 -264.982)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2666",
    "data-name": "Group 2666",
    transform: "translate(72.224 41.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M222.565,325.713l.669-.622v-8.1l-.669.622Z",
    transform: "translate(-222.565 -316.994)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2667",
    "data-name": "Group 2667",
    transform: "translate(36.367 60.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M171.243,355.319l.669-.622v-8.142l-.669.622Z",
    transform: "translate(-171.243 -346.555)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M119.859,357.611l107.394-56.938V308.3L119.859,365.235v-7.624m-.669-.18v8.694l108.732-57.648v-8.694L119.19,357.431Z",
    transform: "translate(-119.19 -269.54)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2668",
    "data-name": "Group 2668",
    transform: "translate(72.224 49.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M222.565,338.431l.669-.622v-8.1l-.669.622Z",
    transform: "translate(-222.565 -329.711)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2669",
    "data-name": "Group 2669",
    transform: "translate(36.367 68.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M171.243,368.036l.669-.622v-8.142l-.669.622Z",
    transform: "translate(-171.243 -359.272)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M119.859,401.779l35.7-18.936v10.111l-35.7,18.937V401.779m-.669-.355v11.531l37.037-19.647V381.778L119.19,401.424Z",
    transform: "translate(-119.19 -206.119)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M251.128,332.388,196.2,361.511v4.854l54.93-29.122Z",
    transform: "translate(-142.396 -188.417)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2671",
    "data-name": "Group 2671",
    transform: "translate(0 88.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M167.276,245.866,119.191,271.36v5.765l48.085-25.494Z",
    transform: "translate(-119.191 -245.866)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M167.276,245.866,119.191,271.36v5.765l48.085-25.494Z",
    transform: "translate(-119.191 -245.866)",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2672",
    "data-name": "Group 2672",
    transform: "translate(1.986 120.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M125.852,300.327l-3.819,2.025v-4.6l3.819-2.025Zm-3.366,1.3,2.913-1.546v-3.64l-2.913,1.546Z",
    transform: "translate(-122.033 -295.726)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2673",
    "data-name": "Group 2673",
    transform: "translate(1.986 129.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M125.852,313.7l-3.819,2.025v-4.6l3.819-2.025Zm-3.366,1.3,2.913-1.546v-3.64l-2.913,1.546Z",
    transform: "translate(-122.033 -309.096)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2674",
    "data-name": "Group 2674",
    transform: "translate(1.986 137.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    d: "M125.852,327.067l-3.819,2.025v-4.6l3.819-2.025Zm-3.366,1.3,2.913-1.546v-3.64l-2.913,1.546Z",
    transform: "translate(-122.033 -322.466)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2677",
    "data-name": "Group 2677",
    transform: "translate(7.888 99.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2675",
    "data-name": "Group 2675"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M168.792,264.278a.7.7,0,0,1-.17.138L130.65,284.548c-.163.086-.218-.045-.124-.294a1.279,1.279,0,0,1,.465-.606l37.972-20.133c.163-.086.219.046.124.294A1.51,1.51,0,0,1,168.792,264.278Z",
    transform: "translate(-130.48 -263.489)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2676",
    "data-name": "Group 2676",
    transform: "translate(0 2.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M168.792,267.674a.72.72,0,0,1-.17.139L130.65,287.945c-.163.087-.218-.045-.124-.294a1.287,1.287,0,0,1,.465-.606l37.972-20.133c.163-.086.219.046.124.294A1.5,1.5,0,0,1,168.792,267.674Z",
    transform: "translate(-130.48 -266.885)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2680",
    "data-name": "Group 2680",
    transform: "translate(7.888 108.345)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2678",
    "data-name": "Group 2678"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M168.792,277.648a.7.7,0,0,1-.17.138L130.65,297.919c-.163.087-.218-.045-.124-.294a1.28,1.28,0,0,1,.465-.606l37.972-20.132c.163-.086.219.045.124.294A1.507,1.507,0,0,1,168.792,277.648Z",
    transform: "translate(-130.48 -276.86)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2679",
    "data-name": "Group 2679",
    transform: "translate(0 2.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    d: "M168.792,281.044a.716.716,0,0,1-.17.138L130.65,301.315c-.163.087-.218-.045-.124-.294a1.285,1.285,0,0,1,.465-.606l37.972-20.134c.163-.086.219.046.124.294A1.509,1.509,0,0,1,168.792,281.044Z",
    transform: "translate(-130.48 -280.255)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2683",
    "data-name": "Group 2683",
    transform: "translate(7.888 116.923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2681",
    "data-name": "Group 2681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M168.792,291.019a.721.721,0,0,1-.17.139L130.65,311.289c-.163.086-.218-.046-.124-.294a1.287,1.287,0,0,1,.465-.606l37.972-20.132c.163-.086.219.046.124.295A1.5,1.5,0,0,1,168.792,291.019Z",
    transform: "translate(-130.48 -290.23)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2682",
    "data-name": "Group 2682",
    transform: "translate(0 2.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M168.792,294.414a.717.717,0,0,1-.17.138L130.65,314.685c-.163.087-.218-.045-.124-.294a1.284,1.284,0,0,1,.465-.606l37.972-20.134c.163-.086.219.046.124.294A1.51,1.51,0,0,1,168.792,294.414Z",
    transform: "translate(-130.48 -293.625)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2684",
    "data-name": "Group 2684",
    transform: "translate(60.647 56.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M254.08,195.75l-48.085,25.494v5.765l48.085-25.494Z",
    transform: "translate(-205.995 -195.75)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M254.08,195.75l-48.085,25.494v5.765l48.085-25.494Z",
    transform: "translate(-205.995 -195.75)",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2685",
    "data-name": "Group 2685",
    transform: "translate(62.633 88.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M212.656,250.21l-3.819,2.025v-4.6l3.819-2.025Zm-3.366,1.3,2.913-1.546v-3.64l-2.913,1.546Z",
    transform: "translate(-208.837 -245.609)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2686",
    "data-name": "Group 2686",
    transform: "translate(62.633 96.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M212.656,263.58l-3.819,2.025V261l3.819-2.025Zm-3.366,1.3,2.913-1.546V259.7l-2.913,1.546Z",
    transform: "translate(-208.837 -258.979)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2687",
    "data-name": "Group 2687",
    transform: "translate(62.633 105.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M212.656,276.951l-3.819,2.025v-4.6l3.819-2.025Zm-3.366,1.3,2.913-1.545v-3.64l-2.913,1.546Z",
    transform: "translate(-208.837 -272.35)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2690",
    "data-name": "Group 2690",
    transform: "translate(68.534 67.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2688",
    "data-name": "Group 2688"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M255.6,214.16a.707.707,0,0,1-.17.139l-37.972,20.133c-.163.086-.219-.046-.124-.295a1.288,1.288,0,0,1,.464-.606L255.766,213.4c.163-.087.219.046.124.294A1.5,1.5,0,0,1,255.6,214.16Z",
    transform: "translate(-217.284 -213.372)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2689",
    "data-name": "Group 2689",
    transform: "translate(0 2.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M255.6,217.557a.687.687,0,0,1-.17.138l-37.972,20.132c-.163.086-.219-.045-.124-.294a1.289,1.289,0,0,1,.464-.606L255.766,216.8c.163-.086.219.045.124.294A1.5,1.5,0,0,1,255.6,217.557Z",
    transform: "translate(-217.284 -216.769)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2693",
    "data-name": "Group 2693",
    transform: "translate(68.534 76.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2691",
    "data-name": "Group 2691"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M255.6,227.53a.707.707,0,0,1-.17.139L217.455,247.8c-.163.086-.219-.045-.124-.294a1.288,1.288,0,0,1,.464-.606l37.972-20.133c.163-.087.219.046.124.294A1.5,1.5,0,0,1,255.6,227.53Z",
    transform: "translate(-217.284 -226.742)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2692",
    "data-name": "Group 2692",
    transform: "translate(0 2.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M255.6,230.928a.707.707,0,0,1-.17.139L217.455,251.2c-.163.086-.219-.046-.124-.294a1.288,1.288,0,0,1,.464-.606l37.972-20.132c.163-.086.219.046.124.294A1.5,1.5,0,0,1,255.6,230.928Z",
    transform: "translate(-217.284 -230.139)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2696",
    "data-name": "Group 2696",
    transform: "translate(68.534 84.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2694",
    "data-name": "Group 2694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    d: "M255.6,240.9a.718.718,0,0,1-.17.138l-37.972,20.133c-.163.086-.219-.045-.124-.294a1.283,1.283,0,0,1,.464-.606l37.972-20.134c.163-.087.219.046.124.294A1.509,1.509,0,0,1,255.6,240.9Z",
    transform: "translate(-217.284 -240.112)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2695",
    "data-name": "Group 2695",
    transform: "translate(0 2.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M255.6,244.3a.707.707,0,0,1-.17.139l-37.972,20.132c-.163.086-.219-.046-.124-.294a1.292,1.292,0,0,1,.464-.606l37.972-20.132c.163-.086.219.046.124.294A1.5,1.5,0,0,1,255.6,244.3Z",
    transform: "translate(-217.284 -243.509)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2697",
    "data-name": "Group 2697",
    transform: "translate(0 34.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M227.922,162.439,119.191,220.087v5.765L227.922,168.2Z",
    transform: "translate(-119.191 -162.439)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M227.922,162.439,119.191,220.087v5.765L227.922,168.2Z",
    transform: "translate(-119.191 -162.439)",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2698",
    "data-name": "Group 2698",
    transform: "translate(1.873 73.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M173.8,223.51a.707.707,0,0,1-.17.139L122.041,251c-.163.086-.219-.045-.124-.294a1.28,1.28,0,0,1,.464-.606l51.59-27.353c.162-.086.218.046.124.294A1.512,1.512,0,0,1,173.8,223.51Z",
    transform: "translate(-121.87 -222.722)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2699",
    "data-name": "Group 2699",
    transform: "translate(1.873 49.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M226.158,185.5a.707.707,0,0,1-.17.139L122.041,240.754c-.163.086-.219-.045-.124-.294a1.288,1.288,0,0,1,.464-.606l103.948-55.113c.163-.086.219.046.124.294A1.487,1.487,0,0,1,226.158,185.5Z",
    transform: "translate(-121.87 -184.715)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2700",
    "data-name": "Group 2700",
    transform: "translate(1.873 52.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M226.158,190.456a.688.688,0,0,1-.17.138L122.041,245.707c-.163.086-.219-.046-.124-.294a1.285,1.285,0,0,1,.464-.606l103.948-55.111c.163-.086.219.045.124.294A1.494,1.494,0,0,1,226.158,190.456Z",
    transform: "translate(-121.87 -189.668)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2701",
    "data-name": "Group 2701",
    transform: "translate(1.873 51.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M173.8,188.928a.7.7,0,0,1-.17.138l-51.589,27.353c-.163.086-.219-.046-.124-.294a1.276,1.276,0,0,1,.464-.606l51.59-27.352c.162-.086.218.045.124.294A1.523,1.523,0,0,1,173.8,188.928Z",
    transform: "translate(-121.87 -188.14)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2702",
    "data-name": "Group 2702",
    transform: "translate(1.873 27.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M226.158,150.921a.7.7,0,0,1-.17.138L122.041,206.172c-.163.086-.219-.046-.124-.294a1.282,1.282,0,0,1,.464-.606l103.948-55.113c.163-.086.219.046.124.294A1.5,1.5,0,0,1,226.158,150.921Z",
    transform: "translate(-121.87 -150.132)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2703",
    "data-name": "Group 2703",
    transform: "translate(1.873 30.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M226.158,155.874a.707.707,0,0,1-.17.139L122.041,211.124c-.163.086-.219-.045-.124-.294a1.279,1.279,0,0,1,.464-.606l103.948-55.112c.163-.086.219.046.124.294A1.487,1.487,0,0,1,226.158,155.874Z",
    transform: "translate(-121.87 -155.085)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_2",
    "data-name": "Speech Bubble 2",
    transform: "translate(39.655 28.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble-2",
    "data-name": "Speech Bubble"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M90.037,47a14.889,14.889,0,0,1-4.569,10.645l-1.4,1.228A17.806,17.806,0,0,1,73.1,62.6c-9.355.012-16.977-6.965-16.989-15.556a14.786,14.786,0,0,1,4.026-10.081l1.338-1.292a17.726,17.726,0,0,1,11.575-4.229C82.4,31.433,90.024,38.409,90.037,47Z",
    transform: "translate(-54.67 -30.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M72.424,29.387C62.276,29.4,54.03,36.995,54.05,46.312c.013,8.36,6.671,15.307,15.366,16.637l2.074,4.893a1.106,1.106,0,0,0,1.993,0l2.058-4.9c8.691-1.355,15.326-8.32,15.311-16.677C90.838,36.945,82.571,29.374,72.424,29.387ZM89.417,46.263a14.889,14.889,0,0,1-4.569,10.645l-1.4,1.228a17.806,17.806,0,0,1-10.966,3.729C63.122,61.876,55.5,54.9,55.488,46.309a14.786,14.786,0,0,1,4.026-10.081l1.338-1.292a17.726,17.726,0,0,1,11.575-4.229C81.782,30.7,89.4,37.672,89.417,46.263Z",
    transform: "translate(-54.05 -29.387)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M90.037,47a14.889,14.889,0,0,1-4.569,10.645l-1.4,1.228A17.806,17.806,0,0,1,73.1,62.6c-9.355.012-16.977-6.965-16.989-15.556a14.786,14.786,0,0,1,4.026-10.081l1.338-1.292a17.726,17.726,0,0,1,11.575-4.229C82.4,31.433,90.024,38.409,90.037,47Z",
    transform: "translate(-54.67 -30.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2704",
    "data-name": "Group 2704",
    transform: "translate(10.255 5.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M83.42,56.195a8.309,8.309,0,0,1-4.646,1.917v2.745H75.542V58.211a18.281,18.281,0,0,1-3.824-.631,11.509,11.509,0,0,1-2.99-1.249l1.751-3.611a11.8,11.8,0,0,0,2.935,1.236,12.079,12.079,0,0,0,3.286.47q3.07,0,3.07-1.41a1.18,1.18,0,0,0-.875-1.1,17.28,17.28,0,0,0-2.814-.755,28.763,28.763,0,0,1-3.555-.9,6.022,6.022,0,0,1-2.451-1.546,3.965,3.965,0,0,1-1.023-2.869A4.766,4.766,0,0,1,70.721,42.2a8.335,8.335,0,0,1,4.821-1.867V37.608h3.232V40.28a16.974,16.974,0,0,1,2.949.494,11.468,11.468,0,0,1,2.519.965L82.6,45.374a11.73,11.73,0,0,0-5.225-1.336,4.7,4.7,0,0,0-2.316.433A1.284,1.284,0,0,0,74.33,45.6q0,.693.862,1.039a16.608,16.608,0,0,0,2.774.717,27.94,27.94,0,0,1,3.569.9,6.211,6.211,0,0,1,2.451,1.533,3.892,3.892,0,0,1,1.037,2.856A4.7,4.7,0,0,1,83.42,56.195Z",
    transform: "translate(-68.728 -37.608)",
    fill: "#ff725e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Coins",
    transform: "translate(113.328 245.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Coins-2",
    "data-name": "Coins",
    transform: "translate(38.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Coin",
    transform: "translate(6.236 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2710",
    "data-name": "Group 2710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2705",
    "data-name": "Group 2705",
    transform: "translate(0 3.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M268.362,400.608a14.565,14.565,0,0,0-5.554-4.717c-9.081-4.815-23.8-4.815-32.886,0a14.562,14.562,0,0,0-5.555,4.717h-1.256v4.363h.017c.167,3.033,2.428,6.04,6.794,8.355,9.081,4.815,23.8,4.815,32.886,0,4.367-2.315,6.644-5.322,6.811-8.355h0v-4.363Z",
    transform: "translate(-223.111 -392.279)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M268.362,400.608a14.565,14.565,0,0,0-5.554-4.717c-9.081-4.815-23.8-4.815-32.886,0a14.562,14.562,0,0,0-5.555,4.717h-1.256v4.363h.017c.167,3.033,2.428,6.04,6.794,8.355,9.081,4.815,23.8,4.815,32.886,0,4.367-2.315,6.644-5.322,6.811-8.355h0v-4.363Z",
    transform: "translate(-223.111 -392.279)",
    opacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M246.367,392.279a36.04,36.04,0,0,0-16.444,3.611,14.563,14.563,0,0,0-5.555,4.717h-1.256v4.363h.016c.168,3.033,2.429,6.041,6.8,8.355a36.041,36.041,0,0,0,16.444,3.611Z",
    transform: "translate(-223.111 -392.279)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M233.665,395.4a26.435,26.435,0,0,0-3.743,1.61,14.563,14.563,0,0,0-5.555,4.717h-1.256v4.363h.016c.168,3.033,2.429,6.041,6.8,8.355a26.421,26.421,0,0,0,3.743,1.61Z",
    transform: "translate(-223.111 -393.397)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M274.573,395.4a26.505,26.505,0,0,1,3.743,1.61,14.566,14.566,0,0,1,5.554,4.717h1.256v4.363h0c-.167,3.033-2.444,6.041-6.811,8.355a26.491,26.491,0,0,1-3.743,1.61Z",
    transform: "translate(-238.619 -393.397)",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2709",
    "data-name": "Group 2709",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2707",
    "data-name": "Group 2707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2706",
    "data-name": "Group 2706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M229.922,389.658c-9.081,4.815-9.08,12.621,0,17.436,7.946,4.213,20.211,4.74,29.237,1.58h0l.361-.128a26.257,26.257,0,0,0,3.287-1.451c7.573-4.015,8.831-10.11,3.772-14.816l0,0a17.622,17.622,0,0,0-3.77-2.617C253.728,384.843,239,384.843,229.922,389.658Z",
    transform: "translate(-223.111 -386.047)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M229.922,389.658c-9.081,4.815-9.08,12.621,0,17.436,7.946,4.213,20.211,4.74,29.237,1.58h0l.361-.128a26.257,26.257,0,0,0,3.287-1.451c7.573-4.015,8.831-10.11,3.772-14.816l0,0a17.622,17.622,0,0,0-3.77-2.617C253.728,384.843,239,384.843,229.922,389.658Z",
    transform: "translate(-223.111 -386.047)",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2708",
    "data-name": "Group 2708",
    transform: "translate(0 2.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M282.284,395.758a8.892,8.892,0,0,1,2.433,7.607c-.8,4.237-7.265,7.8-9.492,8.661a26.258,26.258,0,0,0,3.287-1.451C286.085,406.559,287.343,400.464,282.284,395.758Z",
    transform: "translate(-238.816 -391.688)",
    fill: "#f5f5f5",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M226.15,405.681a8.89,8.89,0,0,1-2.433-7.606c.8-4.237,7.265-7.8,9.493-8.661a26.222,26.222,0,0,0-3.288,1.451C222.35,394.88,221.091,400.975,226.15,405.681Z",
    transform: "translate(-223.112 -389.414)",
    fill: "#f5f5f5",
    opacity: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2717",
    "data-name": "Group 2717",
    transform: "translate(1.645 0.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2711",
    "data-name": "Group 2711"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M231.8,406.938c-8.442-4.476-8.442-11.732,0-16.208s22.129-4.476,30.57,0,8.442,11.732,0,16.208S240.241,411.414,231.8,406.938Z",
    transform: "translate(-225.466 -387.374)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M231.8,406.938c-8.442-4.476-8.442-11.732,0-16.208s22.129-4.476,30.57,0,8.442,11.732,0,16.208S240.241,411.414,231.8,406.938Z",
    transform: "translate(-225.466 -387.374)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M226.449,403.857c-1.738-2.949-1.171-6.2,1.7-8.958a14.185,14.185,0,0,1,1.831-1.473,18.651,18.651,0,0,1,1.75-1.059c.345-.185.7-.362,1.065-.53-.9,1.358-.569,2.812,4.522,3.085,9.963.535-2.662,9.278-2.662,9.278S228.229,401.352,226.449,403.857Z",
    transform: "translate(-225.466 -388.974)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M227.545,403.582c-1.5-.154-2.236-1.566-1.655-3.154a3.927,3.927,0,0,1,3.759-2.6c1.5.154,2.236,1.566,1.655,3.154A3.926,3.926,0,0,1,227.545,403.582Z",
    transform: "translate(-225.534 -391.117)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M249.977,408.982c.49-3.4,16.663-12.8,16.663-12.8s3.587-1.321,2.4-3.624a18.851,18.851,0,0,1,1.73,1.027q.561.371,1.051.764c4.814,3.828,4.821,8.858,0,12.691-.326.26-.677.516-1.049.765-.5.332-1.028.651-1.6.958-.549.3-1.122.569-1.714.824-.472.2-.961.4-1.457.577s-1,.346-1.516.5a34.137,34.137,0,0,1-4.825,1.065c-.36.053-.723.1-1.085.144a40.594,40.594,0,0,1-4.825.278,39.806,39.806,0,0,1-5.9-.445S250.44,411.217,249.977,408.982Z",
    transform: "translate(-232.207 -389.231)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M249.977,408.982c.49-3.4,16.663-12.8,16.663-12.8s3.587-1.321,2.4-3.624a18.851,18.851,0,0,1,1.73,1.027q.561.371,1.051.764c4.814,3.828,4.821,8.858,0,12.691-.326.26-.677.516-1.049.765-.5.332-1.028.651-1.6.958-.549.3-1.122.569-1.714.824-.472.2-.961.4-1.457.577s-1,.346-1.516.5a34.137,34.137,0,0,1-4.825,1.065c-.36.053-.723.1-1.085.144a40.594,40.594,0,0,1-4.825.278,39.806,39.806,0,0,1-5.9-.445S250.44,411.217,249.977,408.982Z",
    transform: "translate(-232.207 -389.231)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M260.859,394.429c6.033,3.2,6.277,8.3.736,11.656-.235.142-.482.283-.738.419-6.289,3.334-16.483,3.334-22.772,0s-6.291-8.74,0-12.075c.256-.136.522-.267.79-.391C245.2,391.1,254.826,391.231,260.859,394.429Z",
    transform: "translate(-227.847 -389.006)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M260.859,394.429c6.033,3.2,6.277,8.3.736,11.656-.235.142-.482.283-.738.419-6.289,3.334-16.483,3.334-22.772,0s-6.291-8.74,0-12.075c.256-.136.522-.267.79-.391C245.2,391.1,254.826,391.231,260.859,394.429Z",
    transform: "translate(-227.847 -389.006)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 15.393,
    cy: 8.161,
    rx: 15.393,
    ry: 8.161,
    transform: "translate(6.223 3.298)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 15.393,
    cy: 8.161,
    rx: 15.393,
    ry: 8.161,
    transform: "translate(6.223 3.298)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M260.716,398.454c-6.011-3.187-15.758-3.187-21.77,0-2.458,1.3-3.91,2.938-4.358,4.633.448,1.694,1.9,3.329,4.358,4.632,6.012,3.187,15.758,3.187,21.77,0,2.459-1.3,3.91-2.938,4.358-4.632C264.626,401.391,263.175,399.757,260.716,398.454Z",
    transform: "translate(-228.215 -390.488)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M260.716,398.454c-6.011-3.187-15.758-3.187-21.77,0-2.458,1.3-3.91,2.938-4.358,4.633.448,1.694,1.9,3.329,4.358,4.632,6.012,3.187,15.758,3.187,21.77,0,2.459-1.3,3.91-2.938,4.358-4.632C264.626,401.391,263.175,399.757,260.716,398.454Z",
    transform: "translate(-228.215 -390.488)",
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M261.768,404.76c0-.275,0-1.4,0-1.687-.006-.692-.522-1.363-1.643-1.966a.3.3,0,0,0-.039-.022,8.528,8.528,0,0,0-6.106-.513l-.016,0c-.809.187-1.578.429-2.278.649a24.041,24.041,0,0,1-2.445.7l0,0a4.686,4.686,0,0,1-1.162.1,2.666,2.666,0,0,1-.963-.234l.076-.049c.075-.046.157-.092.242-.137a5.746,5.746,0,0,1,.645-.294,4.828,4.828,0,0,1,3.422-.071l1.974-1.829V397.73a10.188,10.188,0,0,0-5.4-.18,11.793,11.793,0,0,0-1.716.545l-1.973-1.046-2.356,1.249v1.677l.807.428a1.7,1.7,0,0,0-.347.978c0,.279,0,1.393,0,1.674,0,.694.541,1.361,1.677,1.963a7.354,7.354,0,0,0,3.252.86h0c.215.008.435.006.65,0a13.86,13.86,0,0,0,3.493-.693c.231-.071.457-.144.68-.216l-1.986,1.83v1.678a10.476,10.476,0,0,0,7.611-.3l1.949,1.033,2.355-1.249V406.28l-.809-.429A1.851,1.851,0,0,0,261.768,404.76Zm-4.967-.144a5.237,5.237,0,0,1-.547.251,5.481,5.481,0,0,1-3.851.052c1.844-.6,3.384-1.12,4.7-.478C257.008,404.5,256.91,404.558,256.8,404.616Z",
    transform: "translate(-230.458 -390.842)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2716",
    "data-name": "Group 2716",
    transform: "translate(11.574 6.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2713",
    "data-name": "Group 2713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2712",
    "data-name": "Group 2712"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M253.983,400.571l-.016,0c-.809.187-1.578.429-2.278.649a24.041,24.041,0,0,1-2.445.7l0,0a4.686,4.686,0,0,1-1.162.1,2.642,2.642,0,0,1-1.12-.307c-.758-.4-.868-.99.233-1.654.075-.046.157-.091.242-.137a5.746,5.746,0,0,1,.645-.294,4.825,4.825,0,0,1,3.422-.071l1.974-1.829a10.188,10.188,0,0,0-5.4-.18,11.793,11.793,0,0,0-1.716.545l-1.973-1.046-2.356,1.249,1.951,1.034-.018.014c-1.98,1.381-2.021,2.815.207,4a7.354,7.354,0,0,0,3.252.86h0c.215.008.435.006.65,0a13.863,13.863,0,0,0,3.493-.693c2.26-.694,4.091-1.512,5.614-.705,1.02.541.738,1.221-.382,1.815a5.237,5.237,0,0,1-.547.251,5.474,5.474,0,0,1-3.922.026l-2.069,1.906a10.473,10.473,0,0,0,7.611-.3l1.949,1.033,2.355-1.249-1.949-1.034c1.96-1.392,2.185-2.908-.1-4.139a.3.3,0,0,0-.039-.022A8.528,8.528,0,0,0,253.983,400.571Z",
    transform: "translate(-242.032 -397.049)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2714",
    "data-name": "Group 2714",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M253.983,400.571l-.016,0c-.809.187-1.578.429-2.278.649a24.041,24.041,0,0,1-2.445.7l0,0a4.686,4.686,0,0,1-1.162.1,2.642,2.642,0,0,1-1.12-.307c-.758-.4-.868-.99.233-1.654.075-.046.157-.091.242-.137a5.746,5.746,0,0,1,.645-.294,4.825,4.825,0,0,1,3.422-.071l1.974-1.829a10.188,10.188,0,0,0-5.4-.18,11.793,11.793,0,0,0-1.716.545l-1.973-1.046-2.356,1.249,1.951,1.034-.018.014c-1.98,1.381-2.021,2.815.207,4a7.354,7.354,0,0,0,3.252.86h0c.215.008.435.006.65,0a13.863,13.863,0,0,0,3.493-.693c2.26-.694,4.091-1.512,5.614-.705,1.02.541.738,1.221-.382,1.815a5.237,5.237,0,0,1-.547.251,5.474,5.474,0,0,1-3.922.026l-2.069,1.906a10.473,10.473,0,0,0,7.611-.3l1.949,1.033,2.355-1.249-1.949-1.034c1.96-1.392,2.185-2.908-.1-4.139a.3.3,0,0,0-.039-.022A8.528,8.528,0,0,0,253.983,400.571Z",
    transform: "translate(-242.032 -397.049)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2715",
    "data-name": "Group 2715",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M242.034,398.3l2.378-.99,1.951.787-1.973-1.046Z",
    transform: "translate(-242.034 -397.049)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M250.293,397.742a11.969,11.969,0,0,1,5.063.157l-1.367,1.782,1.974-1.828A10.2,10.2,0,0,0,250.293,397.742Z",
    transform: "translate(-244.523 -397.173)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M265.243,402.869a.3.3,0,0,1,.038.022c2.289,1.231,2.063,2.747.1,4.139,1.736-1.737,1.423-2.948-.463-3.948a9.623,9.623,0,0,0-5.784-.726A8.528,8.528,0,0,1,265.243,402.869Z",
    transform: "translate(-247.188 -398.834)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M267.9,409.825l1.494,1.055-1.9,1.228,2.356-1.249Z",
    transform: "translate(-249.707 -401.628)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M259.8,409.234a5.481,5.481,0,0,1-3.754.3l-2.237,1.631,2.069-1.906A5.474,5.474,0,0,0,259.8,409.234Z",
    transform: "translate(-245.584 -401.417)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M250.989,403.6a3.3,3.3,0,0,1-2.82-.246c-.681-.538-.244-1.114.772-1.614-1.1.664-.991,1.252-.233,1.654a2.641,2.641,0,0,0,1.12.307A4.686,4.686,0,0,0,250.989,403.6Z",
    transform: "translate(-243.783 -398.732)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M244.163,400.63c-.167.135-1.585,1.349-.959,2.562.665,1.294,2.744,2.125,4.42,2.292h0a7.355,7.355,0,0,1-3.252-.86C242.142,403.445,242.183,402.011,244.163,400.63Z",
    transform: "translate(-242.231 -398.333)",
    fill: "#f5f5f5",
    opacity: 0.45
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Coin-2",
    "data-name": "Coin",
    transform: "translate(8.291 5.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2723",
    "data-name": "Group 2723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2718",
    "data-name": "Group 2718",
    transform: "translate(0 3.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M271.3,390.889a14.571,14.571,0,0,0-5.554-4.717c-9.082-4.815-23.805-4.815-32.887,0a14.571,14.571,0,0,0-5.554,4.717h-1.256v4.363h.016c.168,3.033,2.428,6.04,6.794,8.355,9.082,4.814,23.8,4.814,32.887,0,4.367-2.315,6.644-5.323,6.811-8.356h0v-4.363Z",
    transform: "translate(-226.052 -382.561)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M271.3,390.889a14.571,14.571,0,0,0-5.554-4.717c-9.082-4.815-23.805-4.815-32.887,0a14.571,14.571,0,0,0-5.554,4.717h-1.256v4.363h.016c.168,3.033,2.428,6.04,6.794,8.355,9.082,4.814,23.8,4.814,32.887,0,4.367-2.315,6.644-5.323,6.811-8.356h0v-4.363Z",
    transform: "translate(-226.052 -382.561)",
    opacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M249.307,382.562a36.037,36.037,0,0,0-16.444,3.611,14.571,14.571,0,0,0-5.554,4.717h-1.256v4.363h.016c.168,3.033,2.428,6.04,6.794,8.355a36.053,36.053,0,0,0,16.444,3.611Z",
    transform: "translate(-226.052 -382.561)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M236.606,385.681a26.549,26.549,0,0,0-3.743,1.61,14.571,14.571,0,0,0-5.554,4.717h-1.256v4.363h.016c.168,3.033,2.428,6.04,6.794,8.355a26.617,26.617,0,0,0,3.743,1.61Z",
    transform: "translate(-226.052 -383.679)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M277.513,385.681a26.62,26.62,0,0,1,3.743,1.61,14.572,14.572,0,0,1,5.554,4.717h1.256v4.363h0c-.168,3.033-2.444,6.04-6.811,8.356a26.613,26.613,0,0,1-3.743,1.61Z",
    transform: "translate(-241.559 -383.679)",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2722",
    "data-name": "Group 2722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2720",
    "data-name": "Group 2720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2719",
    "data-name": "Group 2719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M232.862,379.94c-9.082,4.815-9.08,12.622,0,17.436,7.946,4.213,20.211,4.74,29.237,1.581h0l.361-.129a26.075,26.075,0,0,0,3.287-1.451c7.573-4.015,8.832-10.109,3.773-14.816l0,0a17.655,17.655,0,0,0-3.771-2.617C256.668,375.126,241.944,375.126,232.862,379.94Z",
    transform: "translate(-226.051 -376.329)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M232.862,379.94c-9.082,4.815-9.08,12.622,0,17.436,7.946,4.213,20.211,4.74,29.237,1.581h0l.361-.129a26.075,26.075,0,0,0,3.287-1.451c7.573-4.015,8.832-10.109,3.773-14.816l0,0a17.655,17.655,0,0,0-3.771-2.617C256.668,375.126,241.944,375.126,232.862,379.94Z",
    transform: "translate(-226.051 -376.329)",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2721",
    "data-name": "Group 2721",
    transform: "translate(0.001 2.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M285.225,386.04a8.893,8.893,0,0,1,2.432,7.607c-.8,4.237-7.265,7.8-9.492,8.661a26.077,26.077,0,0,0,3.287-1.451C289.026,396.841,290.284,390.747,285.225,386.04Z",
    transform: "translate(-241.756 -381.97)",
    fill: "#f5f5f5",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M229.091,395.963a8.892,8.892,0,0,1-2.432-7.607c.8-4.237,7.265-7.8,9.492-8.661a26.212,26.212,0,0,0-3.287,1.451C225.291,385.162,224.032,391.257,229.091,395.963Z",
    transform: "translate(-226.053 -379.696)",
    fill: "#f5f5f5",
    opacity: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2730",
    "data-name": "Group 2730",
    transform: "translate(0.867 0.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2724",
    "data-name": "Group 2724",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M234.74,397.22c-8.442-4.475-8.442-11.732,0-16.208s22.129-4.476,30.57,0,8.441,11.732,0,16.208S243.181,401.7,234.74,397.22Z",
    transform: "translate(-227.629 -377.656)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M234.74,397.22c-8.442-4.475-8.442-11.732,0-16.208s22.129-4.476,30.57,0,8.441,11.732,0,16.208S243.181,401.7,234.74,397.22Z",
    transform: "translate(-227.629 -377.656)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M229.389,394.139c-1.738-2.949-1.17-6.2,1.7-8.958a14.187,14.187,0,0,1,1.831-1.473,18.909,18.909,0,0,1,1.749-1.059c.346-.185.7-.362,1.065-.53-.9,1.358-.569,2.813,4.522,3.085,9.963.535-2.663,9.278-2.663,9.278S231.17,391.635,229.389,394.139Z",
    transform: "translate(-227.628 -379.256)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M3.086-.077C4.879,0,6.378,1.172,6.434,2.548S5.08,4.98,3.287,4.905-.006,3.656-.061,2.28,1.292-.151,3.086-.077Z",
    transform: "matrix(0.599, -0.801, 0.801, 0.599, 0, 10.696)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M252.918,399.265c.49-3.4,16.663-12.8,16.663-12.8s3.586-1.322,2.4-3.624a18.8,18.8,0,0,1,1.73,1.027q.561.372,1.051.764c4.814,3.828,4.821,8.858,0,12.691-.326.26-.677.516-1.049.765-.5.332-1.029.651-1.6.959-.548.3-1.121.568-1.713.824-.472.205-.961.4-1.457.577s-1,.347-1.516.5a34.15,34.15,0,0,1-4.825,1.064c-.36.053-.724.1-1.085.144a40.6,40.6,0,0,1-4.825.278,39.8,39.8,0,0,1-5.9-.445S253.381,401.5,252.918,399.265Z",
    transform: "translate(-234.37 -379.513)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M252.918,399.265c.49-3.4,16.663-12.8,16.663-12.8s3.586-1.322,2.4-3.624a18.8,18.8,0,0,1,1.73,1.027q.561.372,1.051.764c4.814,3.828,4.821,8.858,0,12.691-.326.26-.677.516-1.049.765-.5.332-1.029.651-1.6.959-.548.3-1.121.568-1.713.824-.472.205-.961.4-1.457.577s-1,.347-1.516.5a34.15,34.15,0,0,1-4.825,1.064c-.36.053-.724.1-1.085.144a40.6,40.6,0,0,1-4.825.278,39.8,39.8,0,0,1-5.9-.445S253.381,401.5,252.918,399.265Z",
    transform: "translate(-234.37 -379.513)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M263.8,384.711c6.033,3.2,6.277,8.3.736,11.656-.235.142-.482.284-.738.419-6.289,3.335-16.483,3.335-22.772,0s-6.292-8.74,0-12.075c.256-.135.523-.267.791-.391C248.14,381.382,257.767,381.513,263.8,384.711Z",
    transform: "translate(-230.009 -379.288)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M263.8,384.711c6.033,3.2,6.277,8.3.736,11.656-.235.142-.482.284-.738.419-6.289,3.335-16.483,3.335-22.772,0s-6.292-8.74,0-12.075c.256-.135.523-.267.791-.391C248.14,381.382,257.767,381.513,263.8,384.711Z",
    transform: "translate(-230.009 -379.288)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 15.393,
    cy: 8.161,
    rx: 15.393,
    ry: 8.161,
    transform: "translate(7.001 3.299)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 15.393,
    cy: 8.161,
    rx: 15.393,
    ry: 8.161,
    transform: "translate(7.001 3.299)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M263.657,388.736c-6.011-3.187-15.758-3.187-21.769,0-2.459,1.3-3.91,2.938-4.358,4.633.448,1.7,1.9,3.329,4.358,4.633,6.011,3.187,15.758,3.187,21.769,0,2.459-1.3,3.91-2.938,4.358-4.633C267.567,391.674,266.116,390.04,263.657,388.736Z",
    transform: "translate(-230.378 -380.771)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M263.657,388.736c-6.011-3.187-15.758-3.187-21.769,0-2.459,1.3-3.91,2.938-4.358,4.633.448,1.7,1.9,3.329,4.358,4.633,6.011,3.187,15.758,3.187,21.769,0,2.459-1.3,3.91-2.938,4.358-4.633C267.567,391.674,266.116,390.04,263.657,388.736Z",
    transform: "translate(-230.378 -380.771)",
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M264.709,395.042c0-.275,0-1.4,0-1.687-.006-.692-.522-1.363-1.643-1.966l-.038-.022a8.524,8.524,0,0,0-6.106-.513l-.016,0c-.809.187-1.578.429-2.278.65a24,24,0,0,1-2.445.695l0,0a4.659,4.659,0,0,1-1.163.1,2.638,2.638,0,0,1-.963-.234c.026-.017.05-.033.077-.049.075-.047.156-.092.242-.137a5.624,5.624,0,0,1,.644-.294,4.827,4.827,0,0,1,3.423-.071l1.974-1.829v-1.678a10.182,10.182,0,0,0-5.4-.18,11.807,11.807,0,0,0-1.715.545l-1.974-1.046-2.355,1.249v1.678l.807.428a1.689,1.689,0,0,0-.347.978c0,.278,0,1.393,0,1.674,0,.694.541,1.361,1.677,1.964a7.353,7.353,0,0,0,3.252.86h0c.216.009.435.007.65,0a13.863,13.863,0,0,0,3.494-.693c.231-.071.457-.143.68-.215L253.2,397.08v1.678a10.471,10.471,0,0,0,7.612-.3l1.949,1.034,2.356-1.249v-1.678l-.809-.429A1.853,1.853,0,0,0,264.709,395.042Zm-4.967-.144a5.225,5.225,0,0,1-.547.251,5.484,5.484,0,0,1-3.851.053c1.844-.6,3.384-1.12,4.7-.479C259.949,394.782,259.851,394.84,259.743,394.9Z",
    transform: "translate(-232.62 -381.124)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2729",
    "data-name": "Group 2729",
    transform: "translate(12.353 6.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2726",
    "data-name": "Group 2726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2725",
    "data-name": "Group 2725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M256.924,390.854l-.016,0c-.809.187-1.578.429-2.278.65a24,24,0,0,1-2.445.695l0,0a4.659,4.659,0,0,1-1.163.1A2.634,2.634,0,0,1,249.9,392c-.758-.4-.868-.991.234-1.654.075-.047.156-.092.242-.137a5.68,5.68,0,0,1,.644-.294,4.827,4.827,0,0,1,3.423-.071l1.974-1.829a10.182,10.182,0,0,0-5.4-.18,11.807,11.807,0,0,0-1.715.545l-1.974-1.046-2.355,1.249,1.951,1.034a.119.119,0,0,1-.018.014c-1.979,1.381-2.02,2.815.207,4a7.344,7.344,0,0,0,3.252.86h0c.216.009.435.006.65,0a13.866,13.866,0,0,0,3.494-.693c2.26-.694,4.091-1.512,5.614-.7,1.02.541.738,1.22-.382,1.814a5.225,5.225,0,0,1-.547.251,5.47,5.47,0,0,1-3.922.026L253.2,397.08a10.471,10.471,0,0,0,7.612-.3l1.949,1.034,2.356-1.249-1.949-1.033c1.96-1.392,2.185-2.909-.1-4.139l-.038-.022A8.524,8.524,0,0,0,256.924,390.854Z",
    transform: "translate(-244.973 -387.331)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2727",
    "data-name": "Group 2727",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M256.924,390.854l-.016,0c-.809.187-1.578.429-2.278.65a24,24,0,0,1-2.445.695l0,0a4.659,4.659,0,0,1-1.163.1A2.634,2.634,0,0,1,249.9,392c-.758-.4-.868-.991.234-1.654.075-.047.156-.092.242-.137a5.68,5.68,0,0,1,.644-.294,4.827,4.827,0,0,1,3.423-.071l1.974-1.829a10.182,10.182,0,0,0-5.4-.18,11.807,11.807,0,0,0-1.715.545l-1.974-1.046-2.355,1.249,1.951,1.034a.119.119,0,0,1-.018.014c-1.979,1.381-2.02,2.815.207,4a7.344,7.344,0,0,0,3.252.86h0c.216.009.435.006.65,0a13.866,13.866,0,0,0,3.494-.693c2.26-.694,4.091-1.512,5.614-.7,1.02.541.738,1.22-.382,1.814a5.225,5.225,0,0,1-.547.251,5.47,5.47,0,0,1-3.922.026L253.2,397.08a10.471,10.471,0,0,0,7.612-.3l1.949,1.034,2.356-1.249-1.949-1.033c1.96-1.392,2.185-2.909-.1-4.139l-.038-.022A8.524,8.524,0,0,0,256.924,390.854Z",
    transform: "translate(-244.973 -387.331)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2728",
    "data-name": "Group 2728",
    transform: "translate(0.001 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M244.974,388.581l2.378-.99,1.951.787-1.973-1.046Z",
    transform: "translate(-244.974 -387.332)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M253.234,388.025a11.964,11.964,0,0,1,5.062.157l-1.367,1.783,1.973-1.828A10.182,10.182,0,0,0,253.234,388.025Z",
    transform: "translate(-247.463 -387.455)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M268.184,393.151l.038.022c2.288,1.231,2.063,2.747.1,4.139,1.735-1.737,1.423-2.949-.463-3.948a9.614,9.614,0,0,0-5.784-.726A8.524,8.524,0,0,1,268.184,393.151Z",
    transform: "translate(-250.128 -389.116)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M270.845,400.108l1.494,1.054-1.9,1.228,2.356-1.249Z",
    transform: "translate(-252.648 -391.911)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M262.746,399.516a5.483,5.483,0,0,1-3.754.3l-2.238,1.63,2.069-1.905A5.47,5.47,0,0,0,262.746,399.516Z",
    transform: "translate(-248.524 -391.699)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M253.93,393.885a3.3,3.3,0,0,1-2.821-.245c-.68-.538-.244-1.114.773-1.614-1.1.663-.992,1.252-.234,1.654a2.634,2.634,0,0,0,1.12.307A4.662,4.662,0,0,0,253.93,393.885Z",
    transform: "translate(-246.724 -389.014)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M247.1,390.912c-.166.136-1.585,1.349-.959,2.563.665,1.294,2.743,2.125,4.42,2.292h0a7.345,7.345,0,0,1-3.252-.86C245.083,393.727,245.124,392.293,247.1,390.912Z",
    transform: "translate(-245.172 -388.615)",
    fill: "#f5f5f5",
    opacity: 0.45
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Coin-3",
    "data-name": "Coin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2736",
    "data-name": "Group 2736",
    transform: "translate(5.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2731",
    "data-name": "Group 2731",
    transform: "translate(0 3.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M266.977,381.9a14.571,14.571,0,0,0-5.554-4.717c-9.082-4.815-23.805-4.815-32.886,0a14.568,14.568,0,0,0-5.555,4.717h-1.256v4.363h.016c.168,3.033,2.428,6.04,6.8,8.355,9.08,4.815,23.8,4.815,32.886,0,4.367-2.315,6.644-5.322,6.811-8.355h0V381.9Z",
    transform: "translate(-221.726 -373.574)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M266.977,381.9a14.571,14.571,0,0,0-5.554-4.717c-9.082-4.815-23.805-4.815-32.886,0a14.568,14.568,0,0,0-5.555,4.717h-1.256v4.363h.016c.168,3.033,2.428,6.04,6.8,8.355,9.08,4.815,23.8,4.815,32.886,0,4.367-2.315,6.644-5.322,6.811-8.355h0V381.9Z",
    transform: "translate(-221.726 -373.574)",
    opacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M244.982,373.574a36.04,36.04,0,0,0-16.444,3.611,14.568,14.568,0,0,0-5.555,4.717h-1.256v4.363h.016c.168,3.033,2.428,6.04,6.8,8.355a36.041,36.041,0,0,0,16.444,3.611Z",
    transform: "translate(-221.726 -373.574)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M232.28,376.694a26.425,26.425,0,0,0-3.743,1.61,14.568,14.568,0,0,0-5.555,4.717h-1.256v4.363h.016c.168,3.033,2.428,6.04,6.8,8.355a26.425,26.425,0,0,0,3.743,1.61Z",
    transform: "translate(-221.726 -374.692)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M273.187,376.694a26.539,26.539,0,0,1,3.743,1.61,14.57,14.57,0,0,1,5.554,4.717h1.256v4.363h0c-.168,3.033-2.444,6.041-6.811,8.356a26.545,26.545,0,0,1-3.743,1.609Z",
    transform: "translate(-237.233 -374.692)",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2735",
    "data-name": "Group 2735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2733",
    "data-name": "Group 2733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2732",
    "data-name": "Group 2732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M228.536,370.953c-9.081,4.815-9.08,12.621,0,17.436,7.946,4.213,20.211,4.74,29.237,1.58h0l.36-.128a26.168,26.168,0,0,0,3.287-1.451c7.573-4.015,8.832-10.109,3.773-14.816l0,0a17.655,17.655,0,0,0-3.771-2.617C252.343,366.139,237.618,366.139,228.536,370.953Z",
    transform: "translate(-221.726 -367.342)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M228.536,370.953c-9.081,4.815-9.08,12.621,0,17.436,7.946,4.213,20.211,4.74,29.237,1.58h0l.36-.128a26.168,26.168,0,0,0,3.287-1.451c7.573-4.015,8.832-10.109,3.773-14.816l0,0a17.655,17.655,0,0,0-3.771-2.617C252.343,366.139,237.618,366.139,228.536,370.953Z",
    transform: "translate(-221.726 -367.342)",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2734",
    "data-name": "Group 2734",
    transform: "translate(0 2.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M280.9,377.053a8.892,8.892,0,0,1,2.432,7.607c-.8,4.237-7.265,7.8-9.492,8.661a26.17,26.17,0,0,0,3.287-1.451C284.7,387.854,285.958,381.76,280.9,377.053Z",
    transform: "translate(-237.43 -372.983)",
    fill: "#f5f5f5",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M224.765,386.976a8.892,8.892,0,0,1-2.432-7.607c.8-4.237,7.265-7.8,9.492-8.661a26.256,26.256,0,0,0-3.287,1.451C220.965,376.175,219.706,382.27,224.765,386.976Z",
    transform: "translate(-221.726 -370.709)",
    fill: "#f5f5f5",
    opacity: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2743",
    "data-name": "Group 2743",
    transform: "translate(6.914 0.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2737",
    "data-name": "Group 2737"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 21.617,
    cy: 11.461,
    rx: 21.617,
    ry: 11.461,
    transform: "translate(0.001)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 21.617,
    cy: 11.461,
    rx: 21.617,
    ry: 11.461,
    transform: "translate(0.001)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M225.063,385.152c-1.738-2.949-1.17-6.2,1.7-8.958a14.186,14.186,0,0,1,1.831-1.473,18.637,18.637,0,0,1,1.749-1.059c.346-.185.7-.362,1.065-.53-.9,1.358-.569,2.812,4.522,3.085,9.963.534-2.663,9.278-2.663,9.278S226.844,382.648,225.063,385.152Z",
    transform: "translate(-224.081 -370.269)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M226.16,384.877c-1.5-.153-2.236-1.565-1.655-3.154a3.925,3.925,0,0,1,3.759-2.6c1.5.153,2.236,1.565,1.655,3.153A3.925,3.925,0,0,1,226.16,384.877Z",
    transform: "translate(-224.149 -372.412)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M248.592,390.277c.49-3.4,16.663-12.8,16.663-12.8s3.586-1.322,2.4-3.624a18.8,18.8,0,0,1,1.73,1.026q.561.371,1.051.764c4.814,3.828,4.821,8.858,0,12.691-.326.26-.677.516-1.049.765a18.512,18.512,0,0,1-1.6.958c-.548.3-1.121.569-1.713.824-.472.2-.961.4-1.457.577s-1,.347-1.516.5a34.158,34.158,0,0,1-4.825,1.065c-.36.053-.724.1-1.085.144a40.587,40.587,0,0,1-4.825.278,39.8,39.8,0,0,1-5.9-.445S249.055,392.512,248.592,390.277Z",
    transform: "translate(-230.822 -370.526)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M248.592,390.277c.49-3.4,16.663-12.8,16.663-12.8s3.586-1.322,2.4-3.624a18.8,18.8,0,0,1,1.73,1.026q.561.371,1.051.764c4.814,3.828,4.821,8.858,0,12.691-.326.26-.677.516-1.049.765a18.512,18.512,0,0,1-1.6.958c-.548.3-1.121.569-1.713.824-.472.2-.961.4-1.457.577s-1,.347-1.516.5a34.158,34.158,0,0,1-4.825,1.065c-.36.053-.724.1-1.085.144a40.587,40.587,0,0,1-4.825.278,39.8,39.8,0,0,1-5.9-.445S249.055,392.512,248.592,390.277Z",
    transform: "translate(-230.822 -370.526)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M259.474,375.724c6.033,3.2,6.277,8.3.736,11.656-.235.142-.483.283-.739.419-6.289,3.335-16.483,3.335-22.771,0s-6.292-8.74,0-12.075c.256-.136.523-.267.791-.391C243.814,372.395,253.441,372.526,259.474,375.724Z",
    transform: "translate(-226.461 -370.301)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M259.474,375.724c6.033,3.2,6.277,8.3.736,11.656-.235.142-.483.283-.739.419-6.289,3.335-16.483,3.335-22.771,0s-6.292-8.74,0-12.075c.256-.136.523-.267.791-.391C243.814,372.395,253.441,372.526,259.474,375.724Z",
    transform: "translate(-226.461 -370.301)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 15.393,
    cy: 8.161,
    rx: 15.393,
    ry: 8.161,
    transform: "translate(6.223 3.299)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 15.393,
    cy: 8.161,
    rx: 15.393,
    ry: 8.161,
    transform: "translate(6.223 3.299)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M259.331,379.749c-6.011-3.187-15.758-3.187-21.769,0-2.459,1.3-3.91,2.938-4.358,4.633.448,1.7,1.9,3.329,4.358,4.633,6.011,3.187,15.758,3.187,21.769,0,2.459-1.3,3.91-2.938,4.358-4.633C263.241,382.687,261.79,381.052,259.331,379.749Z",
    transform: "translate(-226.83 -371.783)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M259.331,379.749c-6.011-3.187-15.758-3.187-21.769,0-2.459,1.3-3.91,2.938-4.358,4.633.448,1.7,1.9,3.329,4.358,4.633,6.011,3.187,15.758,3.187,21.769,0,2.459-1.3,3.91-2.938,4.358-4.633C263.241,382.687,261.79,381.052,259.331,379.749Z",
    transform: "translate(-226.83 -371.783)",
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M260.383,386.055c0-.275,0-1.4,0-1.687-.006-.692-.523-1.363-1.643-1.966l-.038-.022a8.528,8.528,0,0,0-6.106-.513l-.016,0c-.809.187-1.578.429-2.278.65a24,24,0,0,1-2.445.695l0,0a4.66,4.66,0,0,1-1.163.1,2.651,2.651,0,0,1-.963-.234l.077-.049c.075-.046.156-.091.242-.137a5.726,5.726,0,0,1,.644-.294,4.831,4.831,0,0,1,3.423-.071l1.974-1.828v-1.678a10.183,10.183,0,0,0-5.4-.18,11.811,11.811,0,0,0-1.715.545L243,378.344l-2.355,1.249v1.678l.807.427a1.692,1.692,0,0,0-.347.979c0,.278,0,1.393,0,1.674,0,.694.541,1.361,1.677,1.963a7.346,7.346,0,0,0,3.252.86h0c.216.009.435.006.65,0a13.867,13.867,0,0,0,3.494-.693c.231-.071.457-.143.68-.215l-1.987,1.829v1.678a10.471,10.471,0,0,0,7.612-.3l1.949,1.033,2.356-1.249v-1.678l-.809-.429A1.859,1.859,0,0,0,260.383,386.055Zm-4.967-.144a5.238,5.238,0,0,1-.547.251,5.485,5.485,0,0,1-3.851.053c1.844-.6,3.384-1.12,4.7-.479C255.623,385.795,255.525,385.853,255.417,385.911Z",
    transform: "translate(-229.073 -372.137)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2742",
    "data-name": "Group 2742",
    transform: "translate(11.574 6.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2739",
    "data-name": "Group 2739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2738",
    "data-name": "Group 2738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M252.6,381.866l-.016,0c-.809.187-1.578.429-2.278.65a24,24,0,0,1-2.445.695l0,0a4.66,4.66,0,0,1-1.163.1,2.652,2.652,0,0,1-1.12-.307c-.758-.4-.868-.991.234-1.655.075-.046.156-.091.242-.137a5.613,5.613,0,0,1,.644-.294,4.827,4.827,0,0,1,3.423-.071l1.974-1.829a10.183,10.183,0,0,0-5.4-.18,11.811,11.811,0,0,0-1.715.545L243,378.344l-2.355,1.249,1.951,1.034a.119.119,0,0,1-.018.014c-1.979,1.381-2.02,2.815.208,4a7.345,7.345,0,0,0,3.252.86h0c.216.009.435.006.65,0a13.87,13.87,0,0,0,3.494-.693c2.26-.694,4.091-1.512,5.614-.705,1.02.542.738,1.221-.382,1.815a5.238,5.238,0,0,1-.547.251,5.47,5.47,0,0,1-3.922.026l-2.069,1.906a10.471,10.471,0,0,0,7.612-.3l1.949,1.034,2.356-1.249-1.949-1.034c1.959-1.392,2.185-2.908-.1-4.139l-.038-.022A8.528,8.528,0,0,0,252.6,381.866Z",
    transform: "translate(-240.647 -378.344)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2740",
    "data-name": "Group 2740",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    d: "M252.6,381.866l-.016,0c-.809.187-1.578.429-2.278.65a24,24,0,0,1-2.445.695l0,0a4.66,4.66,0,0,1-1.163.1,2.652,2.652,0,0,1-1.12-.307c-.758-.4-.868-.991.234-1.655.075-.046.156-.091.242-.137a5.613,5.613,0,0,1,.644-.294,4.827,4.827,0,0,1,3.423-.071l1.974-1.829a10.183,10.183,0,0,0-5.4-.18,11.811,11.811,0,0,0-1.715.545L243,378.344l-2.355,1.249,1.951,1.034a.119.119,0,0,1-.018.014c-1.979,1.381-2.02,2.815.208,4a7.345,7.345,0,0,0,3.252.86h0c.216.009.435.006.65,0a13.87,13.87,0,0,0,3.494-.693c2.26-.694,4.091-1.512,5.614-.705,1.02.542.738,1.221-.382,1.815a5.238,5.238,0,0,1-.547.251,5.47,5.47,0,0,1-3.922.026l-2.069,1.906a10.471,10.471,0,0,0,7.612-.3l1.949,1.034,2.356-1.249-1.949-1.034c1.959-1.392,2.185-2.908-.1-4.139l-.038-.022A8.528,8.528,0,0,0,252.6,381.866Z",
    transform: "translate(-240.647 -378.344)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2741",
    "data-name": "Group 2741",
    transform: "translate(0.001 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M240.648,379.593l2.378-.99,1.951.787L243,378.345Z",
    transform: "translate(-240.648 -378.345)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M248.908,379.038a11.963,11.963,0,0,1,5.062.157l-1.367,1.782,1.973-1.827A10.182,10.182,0,0,0,248.908,379.038Z",
    transform: "translate(-243.137 -378.468)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    d: "M263.858,384.164c.012.006.026.014.038.022,2.288,1.231,2.062,2.747.1,4.139,1.736-1.737,1.423-2.948-.463-3.948a9.624,9.624,0,0,0-5.784-.726A8.528,8.528,0,0,1,263.858,384.164Z",
    transform: "translate(-245.802 -380.129)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M266.519,391.12l1.494,1.054-1.9,1.228,2.356-1.249Z",
    transform: "translate(-248.322 -382.924)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    d: "M258.42,390.529a5.483,5.483,0,0,1-3.754.3l-2.238,1.63,2.069-1.906A5.47,5.47,0,0,0,258.42,390.529Z",
    transform: "translate(-244.198 -382.712)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M249.6,384.9a3.291,3.291,0,0,1-2.82-.246c-.681-.538-.245-1.114.772-1.614-1.1.664-.992,1.252-.234,1.655a2.652,2.652,0,0,0,1.12.307A4.663,4.663,0,0,0,249.6,384.9Z",
    transform: "translate(-242.398 -380.027)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M242.777,381.925c-.166.136-1.585,1.349-.959,2.562.665,1.294,2.743,2.125,4.42,2.292h0a7.345,7.345,0,0,1-3.252-.86C240.757,384.74,240.8,383.306,242.777,381.925Z",
    transform: "translate(-240.846 -379.628)",
    fill: "#f5f5f5",
    opacity: 0.45
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    d: "M221.89,380.071l.586-4.085.586,4.085,7.7.311-7.7.311-.586,4.085-.586-4.085-7.7-.311Z",
    transform: "translate(-214.185 -370.44)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Coins-3",
    "data-name": "Coins",
    transform: "translate(0 22.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Coin-4",
    "data-name": "Coin",
    transform: "translate(3.186 6.81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2749",
    "data-name": "Group 2749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2744",
    "data-name": "Group 2744",
    transform: "translate(0 3.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M209.311,427.841a14.565,14.565,0,0,0-5.554-4.717c-9.081-4.815-23.8-4.815-32.886,0a14.563,14.563,0,0,0-5.555,4.717H164.06V432.2h.017c.167,3.033,2.428,6.041,6.794,8.355,9.081,4.815,23.8,4.815,32.886,0,4.367-2.315,6.644-5.322,6.811-8.355h0v-4.363Z",
    transform: "translate(-164.06 -419.512)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M209.311,427.841a14.565,14.565,0,0,0-5.554-4.717c-9.081-4.815-23.8-4.815-32.886,0a14.563,14.563,0,0,0-5.555,4.717H164.06V432.2h.017c.167,3.033,2.428,6.041,6.794,8.355,9.081,4.815,23.8,4.815,32.886,0,4.367-2.315,6.644-5.322,6.811-8.355h0v-4.363Z",
    transform: "translate(-164.06 -419.512)",
    opacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M187.316,419.512a36.041,36.041,0,0,0-16.444,3.611,14.563,14.563,0,0,0-5.555,4.717H164.06V432.2h.016c.168,3.033,2.429,6.041,6.8,8.355a36.041,36.041,0,0,0,16.444,3.612Z",
    transform: "translate(-164.06 -419.512)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M174.614,422.632a26.437,26.437,0,0,0-3.743,1.61,14.563,14.563,0,0,0-5.555,4.717H164.06v4.363h.016c.168,3.033,2.429,6.041,6.8,8.355a26.5,26.5,0,0,0,3.743,1.61Z",
    transform: "translate(-164.06 -420.63)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    d: "M215.522,422.632a26.508,26.508,0,0,1,3.743,1.61,14.566,14.566,0,0,1,5.554,4.717h1.256v4.363h0c-.167,3.033-2.444,6.041-6.811,8.355a26.494,26.494,0,0,1-3.743,1.61Z",
    transform: "translate(-179.568 -420.63)",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2748",
    "data-name": "Group 2748",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2746",
    "data-name": "Group 2746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2745",
    "data-name": "Group 2745"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    d: "M170.871,416.891c-9.081,4.815-9.08,12.621,0,17.436,7.946,4.213,20.211,4.74,29.237,1.58h0c.12-.042.24-.085.36-.128a26.221,26.221,0,0,0,3.288-1.451c7.573-4.015,8.831-10.11,3.773-14.816l0,0a17.63,17.63,0,0,0-3.771-2.617C194.677,412.076,179.952,412.076,170.871,416.891Z",
    transform: "translate(-164.06 -413.28)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    d: "M170.871,416.891c-9.081,4.815-9.08,12.621,0,17.436,7.946,4.213,20.211,4.74,29.237,1.58h0c.12-.042.24-.085.36-.128a26.221,26.221,0,0,0,3.288-1.451c7.573-4.015,8.831-10.11,3.773-14.816l0,0a17.63,17.63,0,0,0-3.771-2.617C194.677,412.076,179.952,412.076,170.871,416.891Z",
    transform: "translate(-164.06 -413.28)",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2747",
    "data-name": "Group 2747",
    transform: "translate(0 2.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M223.234,422.991a8.894,8.894,0,0,1,2.432,7.607c-.8,4.237-7.266,7.8-9.493,8.661a26.226,26.226,0,0,0,3.288-1.451C227.034,433.792,228.292,427.7,223.234,422.991Z",
    transform: "translate(-179.764 -418.921)",
    fill: "#f5f5f5",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M167.1,432.914a8.893,8.893,0,0,1-2.432-7.606c.8-4.237,7.266-7.8,9.493-8.661a26.222,26.222,0,0,0-3.288,1.451C163.3,422.113,162.04,428.208,167.1,432.914Z",
    transform: "translate(-164.06 -416.647)",
    fill: "#f5f5f5",
    opacity: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2756",
    "data-name": "Group 2756",
    transform: "translate(1.645 0.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2750",
    "data-name": "Group 2750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M203.317,434.172c8.442-4.476,8.442-11.732,0-16.208s-22.129-4.476-30.57,0-8.442,11.732,0,16.208S194.875,438.647,203.317,434.172Z",
    transform: "translate(-166.415 -414.607)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M203.317,434.172c8.442-4.476,8.442-11.732,0-16.208s-22.129-4.476-30.57,0-8.442,11.732,0,16.208S194.875,438.647,203.317,434.172Z",
    transform: "translate(-166.415 -414.607)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M220.552,431.09c1.738-2.949,1.171-6.2-1.7-8.958a14.183,14.183,0,0,0-1.831-1.473,18.659,18.659,0,0,0-1.75-1.059q-.518-.278-1.065-.53c.9,1.358.569,2.812-4.522,3.085-9.963.534,2.663,9.278,2.663,9.278S218.772,428.585,220.552,431.09Z",
    transform: "translate(-178.3 -416.207)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    d: "M223.712,430.815c1.5-.154,2.236-1.566,1.655-3.154a3.927,3.927,0,0,0-3.759-2.6c-1.5.154-2.236,1.566-1.655,3.154A3.926,3.926,0,0,0,223.712,430.815Z",
    transform: "translate(-182.488 -418.35)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M191.885,436.215c-.49-3.4-16.664-12.8-16.664-12.8s-3.586-1.321-2.4-3.624a18.845,18.845,0,0,0-1.729,1.027q-.561.371-1.051.764c-4.815,3.828-4.821,8.857,0,12.691.325.26.676.516,1.049.765.5.332,1.028.651,1.6.958.549.3,1.122.569,1.713.824.472.2.961.4,1.457.577s1,.346,1.516.5a34.275,34.275,0,0,0,4.825,1.065c.36.053.724.1,1.086.144a40.579,40.579,0,0,0,4.825.278,39.781,39.781,0,0,0,5.9-.445S191.422,438.45,191.885,436.215Z",
    transform: "translate(-166.42 -416.464)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M191.885,436.215c-.49-3.4-16.664-12.8-16.664-12.8s-3.586-1.321-2.4-3.624a18.845,18.845,0,0,0-1.729,1.027q-.561.371-1.051.764c-4.815,3.828-4.821,8.857,0,12.691.325.26.676.516,1.049.765.5.332,1.028.651,1.6.958.549.3,1.122.569,1.713.824.472.2.961.4,1.457.577s1,.346,1.516.5a34.275,34.275,0,0,0,4.825,1.065c.36.053.724.1,1.086.144a40.579,40.579,0,0,0,4.825.278,39.781,39.781,0,0,0,5.9-.445S191.422,438.45,191.885,436.215Z",
    transform: "translate(-166.42 -416.464)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M179.011,421.662c-6.032,3.2-6.277,8.3-.736,11.656.235.142.482.283.738.419,6.289,3.334,16.483,3.334,22.772,0s6.291-8.74,0-12.075c-.256-.136-.522-.267-.79-.391C194.671,418.333,185.044,418.464,179.011,421.662Z",
    transform: "translate(-168.789 -416.239)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    d: "M179.011,421.662c-6.032,3.2-6.277,8.3-.736,11.656.235.142.482.283.738.419,6.289,3.334,16.483,3.334,22.772,0s6.291-8.74,0-12.075c-.256-.136-.522-.267-.79-.391C194.671,418.333,185.044,418.464,179.011,421.662Z",
    transform: "translate(-168.789 -416.239)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    d: "M179.832,422.139c-6.011,3.187-6.011,8.355,0,11.542s15.758,3.187,21.769,0,6.012-8.355,0-11.542S185.844,418.951,179.832,422.139Z",
    transform: "translate(-169.1 -416.45)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    d: "M179.832,422.139c-6.011,3.187-6.011,8.355,0,11.542s15.758,3.187,21.769,0,6.012-8.355,0-11.542S185.844,418.951,179.832,422.139Z",
    transform: "translate(-169.1 -416.45)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M179.9,425.687c6.012-3.187,15.758-3.187,21.77,0,2.459,1.3,3.91,2.938,4.358,4.633-.448,1.694-1.9,3.329-4.358,4.632-6.011,3.187-15.758,3.187-21.769,0-2.459-1.3-3.91-2.938-4.358-4.632C175.988,428.624,177.44,426.99,179.9,425.687Z",
    transform: "translate(-169.165 -417.721)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M179.9,425.687c6.012-3.187,15.758-3.187,21.77,0,2.459,1.3,3.91,2.938,4.358,4.633-.448,1.694-1.9,3.329-4.358,4.632-6.011,3.187-15.758,3.187-21.769,0-2.459-1.3-3.91-2.938-4.358-4.632C175.988,428.624,177.44,426.99,179.9,425.687Z",
    transform: "translate(-169.165 -417.721)",
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    d: "M202.717,431.993c0-.275,0-1.4,0-1.687-.006-.692-.522-1.363-1.643-1.966a.3.3,0,0,0-.038-.022,8.528,8.528,0,0,0-6.106-.513l-.016,0c-.809.187-1.578.429-2.278.649a24.045,24.045,0,0,1-2.445.7l0,0a4.7,4.7,0,0,1-1.163.1,2.664,2.664,0,0,1-.962-.234l.076-.049c.075-.046.157-.092.242-.137a5.794,5.794,0,0,1,.644-.294,4.827,4.827,0,0,1,3.423-.071l1.974-1.829v-1.678a10.189,10.189,0,0,0-5.4-.18,11.813,11.813,0,0,0-1.715.545l-1.973-1.046-2.356,1.249v1.677l.807.428a1.7,1.7,0,0,0-.347.978c0,.279,0,1.394,0,1.674,0,.694.541,1.361,1.677,1.963a7.354,7.354,0,0,0,3.252.86h0c.215.008.435.006.65,0a13.861,13.861,0,0,0,3.494-.693c.231-.071.458-.144.68-.216l-1.986,1.829v1.678a10.476,10.476,0,0,0,7.611-.3l1.949,1.033,2.355-1.249v-1.678l-.809-.429A1.851,1.851,0,0,0,202.717,431.993Zm-4.967-.144a5.25,5.25,0,0,1-.547.251,5.481,5.481,0,0,1-3.851.052c1.844-.6,3.384-1.12,4.7-.478C197.957,431.733,197.859,431.791,197.751,431.849Z",
    transform: "translate(-171.407 -418.075)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2755",
    "data-name": "Group 2755",
    transform: "translate(11.574 6.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2752",
    "data-name": "Group 2752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2751",
    "data-name": "Group 2751"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    d: "M194.932,427.8l-.016,0c-.809.187-1.578.429-2.278.649a24.045,24.045,0,0,1-2.445.7l0,0a4.7,4.7,0,0,1-1.163.1,2.641,2.641,0,0,1-1.119-.307c-.759-.4-.868-.99.233-1.654.075-.046.157-.092.242-.137a5.782,5.782,0,0,1,.644-.294,4.827,4.827,0,0,1,3.423-.071l1.974-1.829a10.189,10.189,0,0,0-5.4-.18,11.813,11.813,0,0,0-1.715.545l-1.973-1.046-2.356,1.249,1.951,1.034-.018.014c-1.98,1.381-2.021,2.815.207,4a7.355,7.355,0,0,0,3.252.86h0c.215.008.435.006.65,0a13.864,13.864,0,0,0,3.494-.693c2.26-.694,4.091-1.512,5.614-.705,1.02.541.738,1.221-.382,1.815a5.25,5.25,0,0,1-.547.251,5.474,5.474,0,0,1-3.922.026l-2.069,1.9a10.47,10.47,0,0,0,7.611-.3l1.949,1.033,2.355-1.248-1.949-1.034c1.96-1.392,2.185-2.908-.1-4.139a.3.3,0,0,0-.038-.022A8.528,8.528,0,0,0,194.932,427.8Z",
    transform: "translate(-182.981 -424.282)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2753",
    "data-name": "Group 2753",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1567",
    "data-name": "Path 1567",
    d: "M194.932,427.8l-.016,0c-.809.187-1.578.429-2.278.649a24.045,24.045,0,0,1-2.445.7l0,0a4.7,4.7,0,0,1-1.163.1,2.641,2.641,0,0,1-1.119-.307c-.759-.4-.868-.99.233-1.654.075-.046.157-.092.242-.137a5.782,5.782,0,0,1,.644-.294,4.827,4.827,0,0,1,3.423-.071l1.974-1.829a10.189,10.189,0,0,0-5.4-.18,11.813,11.813,0,0,0-1.715.545l-1.973-1.046-2.356,1.249,1.951,1.034-.018.014c-1.98,1.381-2.021,2.815.207,4a7.355,7.355,0,0,0,3.252.86h0c.215.008.435.006.65,0a13.864,13.864,0,0,0,3.494-.693c2.26-.694,4.091-1.512,5.614-.705,1.02.541.738,1.221-.382,1.815a5.25,5.25,0,0,1-.547.251,5.474,5.474,0,0,1-3.922.026l-2.069,1.9a10.47,10.47,0,0,0,7.611-.3l1.949,1.033,2.355-1.248-1.949-1.034c1.96-1.392,2.185-2.908-.1-4.139a.3.3,0,0,0-.038-.022A8.528,8.528,0,0,0,194.932,427.8Z",
    transform: "translate(-182.981 -424.282)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2754",
    "data-name": "Group 2754",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    "data-name": "Path 1568",
    d: "M182.983,425.531l2.378-.99,1.951.787-1.973-1.046Z",
    transform: "translate(-182.983 -424.283)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    d: "M191.242,424.975a11.968,11.968,0,0,1,5.063.157l-1.367,1.782,1.974-1.828A10.2,10.2,0,0,0,191.242,424.975Z",
    transform: "translate(-185.472 -424.406)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1570",
    "data-name": "Path 1570",
    d: "M206.192,430.1a.308.308,0,0,1,.038.022c2.289,1.231,2.063,2.747.1,4.139,1.736-1.737,1.423-2.948-.463-3.948a9.622,9.622,0,0,0-5.784-.726A8.528,8.528,0,0,1,206.192,430.1Z",
    transform: "translate(-188.137 -426.067)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1571",
    "data-name": "Path 1571",
    d: "M208.853,437.058l1.494,1.054-1.9,1.228,2.356-1.249Z",
    transform: "translate(-190.656 -428.862)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    d: "M200.754,436.467a5.481,5.481,0,0,1-3.754.3l-2.237,1.63,2.069-1.9A5.474,5.474,0,0,0,200.754,436.467Z",
    transform: "translate(-186.533 -428.65)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    d: "M191.939,430.836a3.292,3.292,0,0,1-2.821-.246c-.681-.538-.244-1.114.772-1.614-1.1.664-.992,1.252-.233,1.654a2.641,2.641,0,0,0,1.119.307A4.7,4.7,0,0,0,191.939,430.836Z",
    transform: "translate(-184.732 -425.965)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    d: "M185.112,427.863c-.167.135-1.585,1.349-.959,2.563.664,1.294,2.743,2.125,4.42,2.292h0a7.354,7.354,0,0,1-3.252-.86C183.091,430.678,183.132,429.244,185.112,427.863Z",
    transform: "translate(-183.18 -425.566)",
    fill: "#f5f5f5",
    opacity: 0.45
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Coin-5",
    "data-name": "Coin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2762",
    "data-name": "Group 2762",
    transform: "translate(4.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2757",
    "data-name": "Group 2757",
    transform: "translate(0 3.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    d: "M211.892,417.227a14.56,14.56,0,0,0-5.554-4.717c-9.081-4.815-23.8-4.815-32.886,0a14.563,14.563,0,0,0-5.555,4.717h-1.256v4.363h.017c.167,3.033,2.428,6.04,6.794,8.355,9.081,4.815,23.8,4.815,32.886,0,4.367-2.315,6.644-5.322,6.811-8.355h0v-4.363Z",
    transform: "translate(-166.641 -408.898)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M211.892,417.227a14.56,14.56,0,0,0-5.554-4.717c-9.081-4.815-23.8-4.815-32.886,0a14.563,14.563,0,0,0-5.555,4.717h-1.256v4.363h.017c.167,3.033,2.428,6.04,6.794,8.355,9.081,4.815,23.8,4.815,32.886,0,4.367-2.315,6.644-5.322,6.811-8.355h0v-4.363Z",
    transform: "translate(-166.641 -408.898)",
    opacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    d: "M189.9,408.9a36.04,36.04,0,0,0-16.444,3.611,14.555,14.555,0,0,0-5.554,4.717h-1.257v4.363h.017c.167,3.033,2.428,6.041,6.794,8.355a36.041,36.041,0,0,0,16.444,3.611Z",
    transform: "translate(-166.641 -408.898)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M177.195,412.018a26.5,26.5,0,0,0-3.743,1.61,14.555,14.555,0,0,0-5.554,4.717h-1.257v4.363h.017c.167,3.033,2.428,6.04,6.794,8.355a26.492,26.492,0,0,0,3.743,1.61Z",
    transform: "translate(-166.641 -410.016)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M218.1,412.018a26.5,26.5,0,0,1,3.743,1.61,14.566,14.566,0,0,1,5.554,4.717h1.256v4.363h0c-.167,3.033-2.444,6.04-6.811,8.356a26.562,26.562,0,0,1-3.743,1.609Z",
    transform: "translate(-182.149 -410.016)",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2761",
    "data-name": "Group 2761",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2759",
    "data-name": "Group 2759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2758",
    "data-name": "Group 2758"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M173.452,406.277c-9.081,4.814-9.08,12.621,0,17.436,7.945,4.213,20.211,4.74,29.237,1.58h0l.361-.128a26.267,26.267,0,0,0,3.287-1.451c7.573-4.015,8.831-10.11,3.773-14.816l0,0a17.623,17.623,0,0,0-3.77-2.617C197.258,401.463,182.534,401.462,173.452,406.277Z",
    transform: "translate(-166.641 -402.666)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M173.452,406.277c-9.081,4.814-9.08,12.621,0,17.436,7.945,4.213,20.211,4.74,29.237,1.58h0l.361-.128a26.267,26.267,0,0,0,3.287-1.451c7.573-4.015,8.831-10.11,3.773-14.816l0,0a17.623,17.623,0,0,0-3.77-2.617C197.258,401.463,182.534,401.462,173.452,406.277Z",
    transform: "translate(-166.641 -402.666)",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2760",
    "data-name": "Group 2760",
    transform: "translate(0 2.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M225.815,412.377a8.894,8.894,0,0,1,2.432,7.607c-.8,4.237-7.265,7.8-9.492,8.661a26.258,26.258,0,0,0,3.287-1.451C229.615,423.178,230.873,417.083,225.815,412.377Z",
    transform: "translate(-182.346 -408.307)",
    fill: "#f5f5f5",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M169.68,422.3a8.89,8.89,0,0,1-2.433-7.606c.8-4.238,7.266-7.8,9.493-8.661a26.129,26.129,0,0,0-3.288,1.451C165.88,411.5,164.621,417.594,169.68,422.3Z",
    transform: "translate(-166.642 -406.033)",
    fill: "#f5f5f5",
    opacity: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2769",
    "data-name": "Group 2769",
    transform: "translate(0 0.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2763",
    "data-name": "Group 2763",
    transform: "translate(6.635)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 21.616,
    cy: 11.461,
    rx: 21.616,
    ry: 11.461,
    transform: "translate(0.001)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 21.616,
    cy: 11.461,
    rx: 21.616,
    ry: 11.461,
    transform: "translate(0.001)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M169.979,420.476c-1.738-2.949-1.171-6.2,1.7-8.958a14.176,14.176,0,0,1,1.831-1.473,18.64,18.64,0,0,1,1.75-1.059c.345-.185.7-.362,1.065-.53-.9,1.358-.569,2.812,4.522,3.085,9.964.534-2.662,9.278-2.662,9.278S171.759,417.972,169.979,420.476Z",
    transform: "translate(-168.996 -405.592)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M171.075,420.2c-1.5-.154-2.236-1.566-1.655-3.154a3.927,3.927,0,0,1,3.759-2.6c1.5.154,2.236,1.566,1.655,3.154A3.926,3.926,0,0,1,171.075,420.2Z",
    transform: "translate(-169.064 -407.736)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M193.508,425.6c.49-3.4,16.663-12.8,16.663-12.8s3.587-1.322,2.4-3.624A18.7,18.7,0,0,1,214.3,410.2q.561.372,1.051.764c4.815,3.828,4.821,8.858,0,12.691-.325.26-.677.516-1.049.765-.5.332-1.028.651-1.6.958-.549.3-1.122.569-1.714.824-.471.2-.961.4-1.457.577s-1,.346-1.516.5a34.263,34.263,0,0,1-4.826,1.065c-.359.053-.723.1-1.085.144a40.592,40.592,0,0,1-4.825.278,39.789,39.789,0,0,1-5.9-.445S193.97,427.836,193.508,425.6Z",
    transform: "translate(-175.738 -405.85)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M193.508,425.6c.49-3.4,16.663-12.8,16.663-12.8s3.587-1.322,2.4-3.624A18.7,18.7,0,0,1,214.3,410.2q.561.372,1.051.764c4.815,3.828,4.821,8.858,0,12.691-.325.26-.677.516-1.049.765-.5.332-1.028.651-1.6.958-.549.3-1.122.569-1.714.824-.471.2-.961.4-1.457.577s-1,.346-1.516.5a34.263,34.263,0,0,1-4.826,1.065c-.359.053-.723.1-1.085.144a40.592,40.592,0,0,1-4.825.278,39.789,39.789,0,0,1-5.9-.445S193.97,427.836,193.508,425.6Z",
    transform: "translate(-175.738 -405.85)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M204.389,411.048c6.033,3.2,6.277,8.3.736,11.656-.235.142-.482.283-.738.419-6.289,3.334-16.483,3.334-22.772,0s-6.291-8.74,0-12.075c.256-.136.522-.267.79-.391C188.73,407.719,198.357,407.85,204.389,411.048Z",
    transform: "translate(-171.377 -405.625)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M204.389,411.048c6.033,3.2,6.277,8.3.736,11.656-.235.142-.482.283-.738.419-6.289,3.334-16.483,3.334-22.772,0s-6.291-8.74,0-12.075c.256-.136.522-.267.79-.391C188.73,407.719,198.357,407.85,204.389,411.048Z",
    transform: "translate(-171.377 -405.625)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M204.181,411.525c6.012,3.187,6.012,8.355,0,11.542s-15.758,3.187-21.769,0-6.011-8.355,0-11.542S198.17,408.337,204.181,411.525Z",
    transform: "translate(-171.68 -405.835)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M204.181,411.525c6.012,3.187,6.012,8.355,0,11.542s-15.758,3.187-21.769,0-6.011-8.355,0-11.542S198.17,408.337,204.181,411.525Z",
    transform: "translate(-171.68 -405.835)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M204.246,415.073c-6.011-3.187-15.758-3.187-21.769,0-2.458,1.3-3.91,2.938-4.358,4.633.448,1.694,1.9,3.329,4.358,4.633,6.012,3.187,15.758,3.187,21.769,0,2.459-1.3,3.91-2.938,4.358-4.632C208.156,418.01,206.7,416.376,204.246,415.073Z",
    transform: "translate(-171.745 -407.107)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M204.246,415.073c-6.011-3.187-15.758-3.187-21.769,0-2.458,1.3-3.91,2.938-4.358,4.633.448,1.694,1.9,3.329,4.358,4.633,6.012,3.187,15.758,3.187,21.769,0,2.459-1.3,3.91-2.938,4.358-4.632C208.156,418.01,206.7,416.376,204.246,415.073Z",
    transform: "translate(-171.745 -407.107)",
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M205.3,421.379c0-.275,0-1.4,0-1.687-.006-.692-.522-1.363-1.643-1.966a.4.4,0,0,0-.038-.022,8.528,8.528,0,0,0-6.106-.513l-.016,0c-.809.187-1.577.429-2.278.649a23.992,23.992,0,0,1-2.445.7l0,0a4.691,4.691,0,0,1-1.163.1,2.653,2.653,0,0,1-.963-.234l.076-.049c.075-.046.156-.092.242-.137a5.566,5.566,0,0,1,.644-.294,4.83,4.83,0,0,1,3.423-.072L197,416.027v-1.678a10.187,10.187,0,0,0-5.4-.18,11.8,11.8,0,0,0-1.716.545l-1.973-1.046-2.356,1.249v1.678l.807.427a1.7,1.7,0,0,0-.347.978c0,.279,0,1.394,0,1.675,0,.694.541,1.361,1.677,1.963a7.354,7.354,0,0,0,3.252.86h0c.215.009.435.006.65,0a13.863,13.863,0,0,0,3.493-.693c.232-.071.458-.144.68-.215l-1.986,1.829v1.678a10.473,10.473,0,0,0,7.611-.3l1.949,1.033,2.355-1.249V422.9l-.808-.429A1.85,1.85,0,0,0,205.3,421.379Zm-4.967-.144a5.257,5.257,0,0,1-.546.251,5.487,5.487,0,0,1-3.852.053c1.844-.6,3.384-1.12,4.7-.479C200.538,421.119,200.44,421.177,200.332,421.235Z",
    transform: "translate(-167.353 -407.46)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2768",
    "data-name": "Group 2768",
    transform: "translate(18.209 6.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2765",
    "data-name": "Group 2765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2764",
    "data-name": "Group 2764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M197.513,417.19l-.016,0c-.809.187-1.577.429-2.278.649a23.992,23.992,0,0,1-2.445.7l0,0a4.691,4.691,0,0,1-1.163.1,2.644,2.644,0,0,1-1.12-.307c-.758-.4-.868-.99.233-1.654.075-.046.156-.091.242-.137a5.683,5.683,0,0,1,.644-.294,4.831,4.831,0,0,1,3.423-.071L197,414.349a10.187,10.187,0,0,0-5.4-.18,11.8,11.8,0,0,0-1.716.545l-1.973-1.046-2.356,1.249,1.951,1.035-.018.014c-1.98,1.381-2.021,2.815.208,4a7.35,7.35,0,0,0,3.252.86h0c.215.008.435.006.65,0a13.854,13.854,0,0,0,3.493-.693c2.26-.694,4.091-1.512,5.614-.705,1.02.541.738,1.221-.382,1.815a5.257,5.257,0,0,1-.546.251,5.476,5.476,0,0,1-3.923.026l-2.069,1.905a10.472,10.472,0,0,0,7.611-.3l1.949,1.033,2.355-1.249-1.949-1.034c1.959-1.392,2.185-2.908-.1-4.139a.4.4,0,0,0-.038-.022A8.528,8.528,0,0,0,197.513,417.19Z",
    transform: "translate(-185.562 -413.668)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2766",
    "data-name": "Group 2766",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M197.513,417.19l-.016,0c-.809.187-1.577.429-2.278.649a23.992,23.992,0,0,1-2.445.7l0,0a4.691,4.691,0,0,1-1.163.1,2.644,2.644,0,0,1-1.12-.307c-.758-.4-.868-.99.233-1.654.075-.046.156-.091.242-.137a5.683,5.683,0,0,1,.644-.294,4.831,4.831,0,0,1,3.423-.071L197,414.349a10.187,10.187,0,0,0-5.4-.18,11.8,11.8,0,0,0-1.716.545l-1.973-1.046-2.356,1.249,1.951,1.035-.018.014c-1.98,1.381-2.021,2.815.208,4a7.35,7.35,0,0,0,3.252.86h0c.215.008.435.006.65,0a13.854,13.854,0,0,0,3.493-.693c2.26-.694,4.091-1.512,5.614-.705,1.02.541.738,1.221-.382,1.815a5.257,5.257,0,0,1-.546.251,5.476,5.476,0,0,1-3.923.026l-2.069,1.905a10.472,10.472,0,0,0,7.611-.3l1.949,1.033,2.355-1.249-1.949-1.034c1.959-1.392,2.185-2.908-.1-4.139a.4.4,0,0,0-.038-.022A8.528,8.528,0,0,0,197.513,417.19Z",
    transform: "translate(-185.562 -413.668)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2767",
    "data-name": "Group 2767",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M185.564,414.917l2.378-.989,1.951.787-1.973-1.046Z",
    transform: "translate(-185.564 -413.669)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M193.823,414.361a11.968,11.968,0,0,1,5.063.157l-1.367,1.782,1.974-1.828A10.2,10.2,0,0,0,193.823,414.361Z",
    transform: "translate(-188.053 -413.792)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M208.773,419.488a.4.4,0,0,1,.038.022c2.289,1.231,2.063,2.747.1,4.139,1.735-1.737,1.422-2.948-.463-3.948a9.625,9.625,0,0,0-5.785-.726A8.528,8.528,0,0,1,208.773,419.488Z",
    transform: "translate(-190.718 -415.453)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M211.434,426.444l1.494,1.054-1.9,1.228,2.356-1.249Z",
    transform: "translate(-193.237 -418.247)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M203.336,425.853a5.483,5.483,0,0,1-3.754.3l-2.238,1.63,2.069-1.906A5.475,5.475,0,0,0,203.336,425.853Z",
    transform: "translate(-189.114 -418.036)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M194.52,420.222a3.294,3.294,0,0,1-2.821-.246c-.68-.538-.244-1.114.772-1.614-1.1.664-.991,1.252-.233,1.654a2.643,2.643,0,0,0,1.12.307A4.69,4.69,0,0,0,194.52,420.222Z",
    transform: "translate(-187.314 -415.351)",
    fill: "#f5f5f5",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M187.693,417.249c-.167.135-1.585,1.349-.959,2.563.664,1.294,2.743,2.125,4.42,2.292h0a7.349,7.349,0,0,1-3.252-.86C185.672,420.064,185.713,418.63,187.693,417.249Z",
    transform: "translate(-185.761 -414.952)",
    fill: "#f5f5f5",
    opacity: 0.45
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M167.2,416.213l.586-4.085.586,4.085,7.705.311-7.705.311-.586,4.085-.586-4.085-7.7-.311Z",
    transform: "translate(-159.499 -406.909)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(185.867 99.255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character-2",
    "data-name": "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bottom",
    transform: "translate(42.844 66.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2773",
    "data-name": "Group 2773",
    transform: "translate(0 89.848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2772",
    "data-name": "Group 2772",
    transform: "translate(0 13.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M325.162,413.844c-.476-.089-.578,1.228-.479,1.808s1.833,2.666,5.241,3.686,8.3.908,10.372,1.041,5.116,1.367,7.109,1.963c4.629,1.383,7.471.079,8.822-.866a1.916,1.916,0,0,0,.694-1.514c.11-1.263.015-1.529-.146-1.535Z",
    transform: "translate(-324.649 -407.413)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2771",
    "data-name": "Group 2771",
    transform: "translate(0.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2770",
    "data-name": "Group 2770"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M356.839,410.743a22.834,22.834,0,0,1,.443,2.681c.105,1.085.168,2.468-.715,3.234a6.92,6.92,0,0,1-4.895,1.508,15.685,15.685,0,0,1-5.98-1.213,14.331,14.331,0,0,0-5.087-1.436,55.8,55.8,0,0,1-7.229-.475,18.347,18.347,0,0,1-5.157-1.58,6.327,6.327,0,0,1-2.872-2.976,4.527,4.527,0,0,1,3.256-4.116,11.812,11.812,0,0,1,5.487-.461c2.013.228,3.5.635,5.3.709a9.554,9.554,0,0,0,3.651-.4,3.346,3.346,0,0,0,1.305-1.342c.362-.55.531-1.059,1.109-1.051,0,0,9.424.964,10.275,1.1.968.149.7,1.352.661,2-.031.561-.011.575-.041,1.136a7.145,7.145,0,0,0,.29,1.88Q356.75,410.338,356.839,410.743Z",
    transform: "translate(-325.348 -403.823)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M341.9,407.3a1.315,1.315,0,0,0-.42-.193c-.8-.2-1.522.471-1.942,1.012a4.574,4.574,0,0,0-.57,1.078,2.455,2.455,0,0,0-.215,1.46c.027.126.112.277.249.261s.176-.154.2-.268a5.439,5.439,0,0,1,.864-1.906,2.354,2.354,0,0,1,.591-.667,2.457,2.457,0,0,1,.873-.384c.129-.028.676.031.574-.2a.328.328,0,0,0-.1-.112C341.978,407.348,341.941,407.321,341.9,407.3Z",
    transform: "translate(-328.889 -404.986)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M345.615,407.8a1.677,1.677,0,0,0-1.119.164,2.077,2.077,0,0,0-.768.922,2.914,2.914,0,0,0-.381,2.518c.124.245.356.148.469-.049a3.2,3.2,0,0,0,.2-.769,6.814,6.814,0,0,1,.718-1.616,2.607,2.607,0,0,1,.413-.572,1.278,1.278,0,0,1,.4-.273.864.864,0,0,1,.233-.063,2.26,2.26,0,0,1,.228,0c.015-.107-.11-.18-.22-.216A1.709,1.709,0,0,0,345.615,407.8Z",
    transform: "translate(-330.235 -405.238)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M349.448,407.216a1.546,1.546,0,0,0-.748.357,1.824,1.824,0,0,0-.408.634,6.559,6.559,0,0,0-.531,1.613,1.9,1.9,0,0,0,.159,1.161c.075.142.225.291.388.242.178-.053.191-.3.224-.443.059-.26.068-.534.1-.8a4.532,4.532,0,0,1,1.317-2.6c.036-.037.075-.08.066-.128-.014-.072-.118-.089-.2-.085A2.431,2.431,0,0,0,349.448,407.216Z",
    transform: "translate(-331.605 -405.023)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M335.224,406.838c-.829-.1-2.709.762-3.852,3.019a12.461,12.461,0,0,0-1.027,5.262,8.472,8.472,0,0,1-4.377-2.486,3.039,3.039,0,0,1,.314-4.953c1.376-1.2,3.349-1.88,6.313-1.718,3.326.181,3.512,1.019,3.512,1.019Z",
    transform: "translate(-324.746 -404.581)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    d: "M365.939,383.757s-1.811,12.062-2.086,14.543c-.117,1.055-2.654,2.214-6.171,1.893-2.47-.225-4-1.595-4.226-2.768s-.943-15.39-.943-15.39Z",
    transform: "translate(-333.046 -382.035)",
    fill: "#c8856a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2776",
    "data-name": "Group 2776",
    transform: "translate(53.698 80.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    d: "M417.341,379.17l-3.993-11.643-11.841,2.019s7.221,12.558,8.164,13.7C411.225,385.135,417.341,379.17,417.341,379.17Z",
    transform: "translate(-401.507 -367.527)",
    fill: "#c8856a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2775",
    "data-name": "Group 2775",
    transform: "translate(1.493 9.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    d: "M424.848,388.006a8.184,8.184,0,0,1-.168,3.259c-.158,1.078-.329,2.137-.418,3.223a11.544,11.544,0,0,1-.3,1.964,11.086,11.086,0,0,0-.1,2.37c-.021.829-.042,1.658-.054,2.487a4.121,4.121,0,0,0,0,1.062c.094.343-5.719,3.4-8.065,4.582-.136.07-.272.124-.425.187a3.906,3.906,0,0,1-3.808-.819,5.653,5.653,0,0,1,1.58-6.54s.3.015.238-2.092a44.084,44.084,0,0,0-.175-4.516,9.1,9.1,0,0,0-.773-2.738,6.268,6.268,0,0,1-1-2.534c.029-.715.546-1.184.915-1.764a9.629,9.629,0,0,1,4.251-3.082c.863-.355,2.269-.744,3.155-.251.478.266.7.782,1.045,1.188a6.331,6.331,0,0,0,1.525,1.154,5.643,5.643,0,0,1,2.486,2.6C424.8,387.834,424.825,387.92,424.848,388.006Z",
    transform: "translate(-405.876 -382.57)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    d: "M411.063,409.321a7.544,7.544,0,0,0-.756,1.007H410.3a6.981,6.981,0,0,0-.816,5.533c-4.1-.343-5.184-2.52-5.184-2.52s-.229-1.881,2.133-3.246a5.869,5.869,0,0,1,.892-.43.176.176,0,0,0,.043-.023A6.517,6.517,0,0,1,411.063,409.321Z",
    transform: "translate(-403.84 -392.111)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    d: "M427.995,391.828c1.08.384.8,3.106.119,5.727s-1.052,3.534-.706,5.714.546,3.156-.422,3.955-8.667,4.1-8.667,4.1a24.184,24.184,0,0,0,1.719-8.187c.2-4.831.554-7.942,2.994-10.138A4.928,4.928,0,0,1,427.995,391.828Z",
    transform: "translate(-408.066 -385.803)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    d: "M404.1,406.557a14.936,14.936,0,0,0,6.425,2.575c3.435.359,3.606-.853,3.968-4.592s.5-8.909,2.1-11.185,4.3-3.286,5.36-3.055c.218-.1,1.27.618,1.614,1.054a6.2,6.2,0,0,0-4.5,1.657c-2.145,1.926-2.537,5.993-2.635,9.689s-.276,7.98-3.481,8.43a12.38,12.38,0,0,1-8.737-2.44A1.41,1.41,0,0,1,404.1,406.557Z",
    transform: "translate(-403.644 -385.329)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2774",
    "data-name": "Group 2774",
    transform: "translate(6.856 10.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    d: "M414.124,407.253a1.048,1.048,0,0,0-.476.684,2.072,2.072,0,0,0,1.165,1.941c.433.227.8.137.106-.642A3.832,3.832,0,0,1,414.124,407.253Z",
    transform: "translate(-413.513 -401.785)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M414.109,403.2a.885.885,0,0,0-.291.566,3.214,3.214,0,0,0,1.413,2.037c.755.309.348-.456,0-.811A13.6,13.6,0,0,1,414.109,403.2Z",
    transform: "translate(-413.566 -400.331)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    d: "M413.814,398.731a.641.641,0,0,0-.356.463c-.02.3,1.529,1.368,2.013,1.333s.6-.178,0-.55S413.814,398.731,413.814,398.731Z",
    transform: "translate(-413.458 -398.731)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    d: "M390.3,333.621s-9.109-15.216-14.562-25.482c-1.875-3.531-2.721-5.05-3.3-7.763s-2.79-10.175-2.79-10.175l-3.008,15.809a49.935,49.935,0,0,1,1.36,8.754c.178,3.32-.4,7.186-1.69,14.419-1.856,10.433-2.673,13-2.673,13-.81.562-2.9.676-4.991.763-4.85.2-7.181-1.881-7.181-1.881s-1.281-18.376-1.719-22.591a240.636,240.636,0,0,1-1.624-37.569,315.925,315.925,0,0,1,2.867-32.064l34.183-6.848a32.149,32.149,0,0,1,6.015,20.714c-.78,10.89-1.369,34.463-1.369,34.463,1.877,2.812,3.55,5.681,5.317,12.576,1.035,4.041,3.05,12.787,4.473,19.193A10.678,10.678,0,0,0,390.3,333.621Z",
    transform: "translate(-331.688 -241.994)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    d: "M378.983,301.521l4.412-22.393s4.74-.508,10.994-5.548c0,0-.42,3.928-8.731,7.3l-4.75,19.9.866,10.922Z",
    transform: "translate(-341.022 -253.315)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pen",
    transform: "translate(0 1.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2781",
    "data-name": "Group 2781",
    transform: "translate(0 40.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2778",
    "data-name": "Group 2778",
    transform: "translate(0 49.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2777",
    "data-name": "Group 2777"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    d: "M269.157,283.357l-1.932,1.334,0,0c-.845.584-3.3,1.613-3.806,1s1.259-2.493,2.105-3.076l1.936-1.336a3.2,3.2,0,0,0,.259.447l0,0c.047.071.1.141.145.206.142.192.277.349.352.442a5.649,5.649,0,0,0,.942.978",
    transform: "translate(-263.326 -281.279)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    d: "M263.527,286.756c-.2.373-.274.7-.112.9s.49.221.9.162A1.149,1.149,0,0,1,263.527,286.756Z",
    transform: "translate(-263.326 -283.242)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    d: "M287.8,269.907a3.107,3.107,0,0,0,1.11-3.208c-.392-2.985-3.18-6.354-6.207-7.526a3.886,3.886,0,0,0-3.63.072l0,0-.027.019-.006,0-.006.005c-2.987,2.079-10.1,9.052-11.434,13.324l.061.074a1.477,1.477,0,0,0-.064.715,3.919,3.919,0,0,0,2.3,2.785,1.979,1.979,0,0,0,.736.137l.006.007C275.5,276.325,284.835,271.953,287.8,269.907Z",
    transform: "translate(-264.607 -223.821)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2779",
    "data-name": "Group 2779",
    transform: "translate(13.862 33.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    "data-name": "Path 1625",
    d: "M295.243,267.944l-.85-1.039a4.668,4.668,0,0,0,.031-1.54,10.86,10.86,0,0,0-6.34-7.746,5.912,5.912,0,0,0-1.62-.4l-.85-1.039-1.691,1.875,0,.006a3.5,3.5,0,0,0-.713,2.92,10.861,10.861,0,0,0,6.339,7.746,4.4,4.4,0,0,0,3.253.183l0,.005Z",
    transform: "translate(-283.167 -256.18)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    d: "M295.243,267.944l-.85-1.039a4.668,4.668,0,0,0,.031-1.54,10.86,10.86,0,0,0-6.34-7.746,5.912,5.912,0,0,0-1.62-.4l-.85-1.039-1.691,1.875,0,.006a3.5,3.5,0,0,0-.713,2.92,10.861,10.861,0,0,0,6.339,7.746,4.4,4.4,0,0,0,3.253.183l0,.005Z",
    transform: "translate(-283.167 -256.18)",
    opacity: 0.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2780",
    "data-name": "Group 2780",
    transform: "translate(15.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    "data-name": "Path 1627",
    d: "M344.595,213.163c-.44-3.33-3.522-7.1-6.883-8.411a4.336,4.336,0,0,0-4.069.083l-46.807,32.3a3.524,3.524,0,0,0-1.218,3.567c.441,3.33,3.523,7.1,6.883,8.41a4.334,4.334,0,0,0,4.069-.083l46.807-32.3A3.524,3.524,0,0,0,344.595,213.163Z",
    transform: "translate(-285.565 -204.298)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    d: "M344.595,213.163c-.44-3.33-3.522-7.1-6.883-8.411a4.336,4.336,0,0,0-4.069.083l-46.807,32.3a3.524,3.524,0,0,0-1.218,3.567c.441,3.33,3.523,7.1,6.883,8.41a4.334,4.334,0,0,0,4.069-.083l46.807-32.3A3.524,3.524,0,0,0,344.595,213.163Z",
    transform: "translate(-285.565 -204.298)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    d: "M352.612,208.4c.441,3.33,3.523,7.1,6.883,8.411a4.335,4.335,0,0,0,4.069-.083,3.525,3.525,0,0,0,1.218-3.567c-.44-3.33-3.522-7.1-6.883-8.411a4.336,4.336,0,0,0-4.069.083A3.527,3.527,0,0,0,352.612,208.4Z",
    transform: "translate(-290.216 -204.298)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2783",
    "data-name": "Group 2783",
    transform: "translate(60.41 37.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2782",
    "data-name": "Group 2782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    "data-name": "Path 1630",
    d: "M367.892,209.74c-.509-3.844-4.066-8.19-7.945-9.708-1.94-.759-3.593-.667-4.7.1l-3.991,2.754c-1.1.762-1.661,2.195-1.406,4.117.509,3.844,4.065,8.19,7.945,9.708,1.939.759,3.592.667,4.7-.1l3.991-2.754C367.59,213.094,368.146,211.662,367.892,209.74Z",
    transform: "translate(-349.792 -199.507)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1631",
    "data-name": "Path 1631",
    d: "M367.892,209.74c-.509-3.844-4.066-8.19-7.945-9.708-1.94-.759-3.593-.667-4.7.1l-3.991,2.754c-1.1.762-1.661,2.195-1.406,4.117.509,3.844,4.065,8.19,7.945,9.708,1.939.759,3.592.667,4.7-.1l3.991-2.754C367.59,213.094,368.146,211.662,367.892,209.74Z",
    transform: "translate(-349.792 -199.507)",
    fill: "#fff",
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    "data-name": "Path 1632",
    d: "M355.565,204.244c.509,3.844,4.066,8.19,7.945,9.708,1.939.759,3.592.667,4.7-.095s1.661-2.195,1.406-4.117c-.509-3.844-4.066-8.19-7.945-9.708-1.94-.759-3.593-.667-4.7.1S355.31,202.322,355.565,204.244Z",
    transform: "translate(-351.513 -199.507)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2784",
    "data-name": "Group 2784",
    transform: "translate(65.247 1.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    d: "M422.335,153.251c-.495-3.739-3.954-7.967-7.729-9.443-1.887-.738-3.495-.649-4.569.093l-51.895,35.816c-1.075.742-1.615,2.135-1.368,4,.495,3.739,3.955,7.967,7.729,9.443,1.887.738,3.495.649,4.569-.093l51.895-35.816C422.042,156.515,422.582,155.122,422.335,153.251Z",
    transform: "translate(-356.715 -143.297)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    d: "M422.335,153.251c-.495-3.739-3.954-7.967-7.729-9.443-1.887-.738-3.495-.649-4.569.093l-51.895,35.816c-1.075.742-1.615,2.135-1.368,4,.495,3.739,3.955,7.967,7.729,9.443,1.887.738,3.495.649,4.569-.093l51.895-35.816C422.042,156.515,422.582,155.122,422.335,153.251Z",
    transform: "translate(-356.715 -143.297)",
    fill: "#fff",
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    d: "M443.35,156.657a7.913,7.913,0,0,0,1.807-11.7A9.64,9.64,0,0,0,432.42,143.3h0c-1.075.742-1.615,2.135-1.368,4,.495,3.739,3.955,7.967,7.729,9.443,1.887.738,3.495.649,4.569-.093Z",
    transform: "translate(-313.851 -141.594)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2785",
    "data-name": "Group 2785",
    transform: "translate(82.368 15.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M422.358,176.37l-.233-1.812-5.954-2.33L382.3,195.605a1.955,1.955,0,0,0-1.068,1.768c.044.3.191,1.488.231,1.8.069.527.5,1,1.289,1.312a6.888,6.888,0,0,0,5.735-.738Z",
    transform: "translate(-381.221 -168.141)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M382.633,198.429c-1.523,1.051-1.425,2.425.22,3.068a6.888,6.888,0,0,0,5.735-.738l33.87-23.376-5.955-2.33Z",
    transform: "translate(-381.321 -169.153)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M430.461,165.857l.781,5.9,5.954,2.329-.78-5.9Z",
    transform: "translate(-396.059 -165.857)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M429.9,165.857l-1.293.893.781,5.9,1.294-.893Z",
    transform: "translate(-395.501 -165.857)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2786",
    "data-name": "Group 2786",
    transform: "translate(127.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M452.454,146.418a2.549,2.549,0,0,0,.581-3.767,3.105,3.105,0,0,0-4.1-.534h0l-2.357,1.626a1.275,1.275,0,0,0-.441,1.29,4.264,4.264,0,0,0,2.489,3.042,1.57,1.57,0,0,0,1.472-.03l2.357-1.626Z",
    transform: "translate(-446.117 -141.577)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M448.625,149.184a1.57,1.57,0,0,0,1.472-.03l2.357-1.626h0a2.6,2.6,0,0,0,1.154-2.39h0c-.045.762-1.171,1.529-2.477,2.43s-2.53,1.121-4.062-.6c-1.117-1.25-.6-1.989-.232-2.3l-.261.18a1.275,1.275,0,0,0-.441,1.29A4.264,4.264,0,0,0,448.625,149.184Z",
    transform: "translate(-446.117 -142.686)",
    fill: "#37474f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Top",
    transform: "translate(16.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M409.294,203.5a109.889,109.889,0,0,0-7.509-11.738,8.3,8.3,0,0,0-8.361-3.583l.372,15.876,7.182,9.408-6,7.861,4.537,6.481s9.393-8.131,12.035-10.679c2.765-2.666,2.475-3.916,1.39-6.525A77.706,77.706,0,0,0,409.294,203.5Z",
    transform: "translate(-319.047 -156.619)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2789",
    "data-name": "Group 2789",
    transform: "translate(46.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M380.045,172.075c-.885-.137-2.673.181-2.79-.506-.25-1.468-1.183-3.434-1.238-5.192s4.817-5.494,5.276-10.751-7.371-13.071-14.109-12.517-10.024,2.572-11.329,7.156c-.347,1.219-.413,2.17.075,4.636a14.783,14.783,0,0,0-.18,10.16c1.066,3.052,2.243,3.794,3.985,4.165a15.086,15.086,0,0,0,4.018.121,23.664,23.664,0,0,1,.444,3.73,2.038,2.038,0,0,1-1.752,2C365.03,176.824,380.943,177.715,380.045,172.075Z",
    transform: "translate(-353.84 -140.484)",
    fill: "#c8856a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M353.482,150.6a4.454,4.454,0,0,0,1.908,3,9.882,9.882,0,0,1-.034-2.268,8.569,8.569,0,0,1,1.029-3.241c3.254-1.7,8.926-.672,11.651,1.426a4.842,4.842,0,0,0,1.353,5.382c.119,1.212-.613,3.129.983,3.713.458.1.59-.3.664-.636.544-2.452,2.919-3.821,4.875-2.229,2.638,2.113-1.105,8.233-4.414,5.536-.268,1.873,2.971,4.879,4.165,4.62,1.615-3.08,12.788-15.161,2.08-19.14-.977-3.04-4.517-5.506-8.4-6.058C359.634,139.32,352.378,144.373,353.482,150.6Z",
    transform: "translate(-353.371 -139.55)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M390.677,152.853c-.263.033-.526.054-.78.065a6.224,6.224,0,0,1-2.106-.427c-1.833-.5-3.32-.762-4.543-2.271a11.836,11.836,0,0,1-1.487-2.135c-1.1-2.226-1.253-7.064,1.9-7.99a4.09,4.09,0,0,1,3.464.7c.031-1.053,1.286-1.8,2.433-1.755a6.144,6.144,0,0,1,3.1,1.263,2.4,2.4,0,0,0-2.1.549,5.6,5.6,0,0,1,3.476.592,2.71,2.71,0,0,1,1.633,1.391,1.879,1.879,0,0,1-.938,1.994,3.983,3.983,0,0,1,1.392,1.517,2.4,2.4,0,0,1,.21,1.9,1.7,1.7,0,0,1-1.587,1.1,1.845,1.845,0,0,1-.389,2.788,1.8,1.8,0,0,0-.712-1.685,1.873,1.873,0,0,1-.916,1.725A4.779,4.779,0,0,1,390.677,152.853Z",
    transform: "translate(-361.71 -139.033)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    d: "M361.678,173.276a1.947,1.947,0,0,0,2.355,1.217,1.724,1.724,0,0,0,1.341-2.135Z",
    transform: "translate(-355.874 -150.978)",
    fill: "#af6152"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    d: "M363.712,174.832a2.69,2.69,0,0,1,2.331-1.556,1.782,1.782,0,0,1-1.4,1.546A2.081,2.081,0,0,1,363.712,174.832Z",
    transform: "translate(-356.487 -151.307)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2788",
    "data-name": "Group 2788",
    transform: "translate(2.312 10.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2787",
    "data-name": "Group 2787"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    d: "M366.876,163.3a.972.972,0,0,0,.671,1.266,1.126,1.126,0,0,0,1.373-.658.971.971,0,0,0-.671-1.266A1.126,1.126,0,0,0,366.876,163.3Z",
    transform: "translate(-359.735 -158.251)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    d: "M368.082,158.2l2.263,1.213a1.187,1.187,0,0,0-.483-1.675A1.352,1.352,0,0,0,368.082,158.2Z",
    transform: "translate(-360.116 -156.456)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    d: "M356.751,157.474l2.48-.844a1.307,1.307,0,0,0-1.662-.727A1.233,1.233,0,0,0,356.751,157.474Z",
    transform: "translate(-356.68 -155.828)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    d: "M356.882,162.677a.99.99,0,1,0,1-.925A.956.956,0,0,0,356.882,162.677Z",
    transform: "translate(-356.741 -157.951)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M357.335,165.757l3.377,1.219,1.22-5.941Z",
    transform: "translate(-356.877 -157.694)",
    fill: "#af6152"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    d: "M367.676,181.545a20.922,20.922,0,0,0,3.788-.951c2.272-.923,3.377-2.161,3.824-3.481-.024,1.654-1.156,3.461-4.022,4.524a15.23,15.23,0,0,1-3.409.944Z",
    transform: "translate(-357.682 -152.682)",
    fill: "#af6152"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2790",
    "data-name": "Group 2790",
    transform: "translate(41.043 29.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M374.167,185.117c1.539.833,3.017,1.094,6.463,1.652s5.693,1.769,6.6,5.9-.389,8.851-1.624,13.84-2.1,9.571-1.724,11.409,5.149,8.441,6.708,16.639c-2.846,2.969-10.722,5.154-10.722,5.154a52.594,52.594,0,0,0-3.355-11.293c.235,6.553.195,8.866-.325,12.7a51.94,51.94,0,0,1-13.1,1.744c-5.949-.218-11.957-1.808-15.031-4.333,0,0,2.263-12.535,2.846-16.986l-.911-5.008a7.4,7.4,0,0,1-3.256-3.2c-1.486-3.148-1.254-8.785.05-11.7,1.574-3.523,5.928-9.464,5.928-9.464s3.448-1.146,6.757-2.176a10.1,10.1,0,0,1,2.025-2.245,21.613,21.613,0,0,0,9.948-.454C374.107,186.493,374.167,185.117,374.167,185.117Z",
    transform: "translate(-345.711 -185.117)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    d: "M370.212,193.567a29.634,29.634,0,0,0,6.962-.29,13.861,13.861,0,0,0,2.983-.86,12,12,0,0,0,1.344-.685c.426-.251.784-.607,1.214-.844.038-.021.058.05.04.072a5.117,5.117,0,0,1-1.084.927,8.412,8.412,0,0,1-1.332.795,12.667,12.667,0,0,1-3.076.935,20.21,20.21,0,0,1-3.536.355,17.57,17.57,0,0,1-1.792-.048,11.665,11.665,0,0,1-1.715-.313C370.2,193.607,370.187,193.566,370.212,193.567Z",
    transform: "translate(-353.091 -187.184)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2791",
    "data-name": "Group 2791",
    transform: "translate(0 36.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M335.11,196.312s-4.2,1.242-6.008,2.68-3.946,5.706-6.357,9.908-6.56,11.833-6.56,11.833-5.232,1.018-8.454,1.551c-2.674.441-4.954,1.039-7.025.8a38.772,38.772,0,0,0-5.9-.216c-1.97.189-1.77,1.272-3.061,1.6s-1.224,1.1-1.891,2.134-1.346-.064-2.363,1.608-.228,6.066-.228,6.066l2.185-1.488a17.534,17.534,0,0,0,2.419.067c1.958-.055,2.572-1.218,5.793-1.692,3.2-.244,14.341.12,19.728-.26s6.933-.464,8.6-2.746,10.475-16.133,10.475-16.133C340.635,204.045,335.11,196.312,335.11,196.312Z",
    transform: "translate(-286.966 -196.179)",
    fill: "#c8856a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M344.449,196.1c-4.019,1.283-5.993,2.423-7.97,4.732s-11.144,19.748-11.144,19.748l-5.806,1.216a6.1,6.1,0,0,0-1.232,3.722,17.563,17.563,0,0,0,.187,3.626l6.334.325-6.083.887a2.891,2.891,0,0,0,.493,1.1s8.793-.223,12.2-.456,4.394-2,6.409-4.946,8.6-12.322,8.6-12.322S351.678,200.093,344.449,196.1Z",
    transform: "translate(-296.404 -196.104)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_1",
    "data-name": "Speech Bubble 1",
    transform: "translate(255.672 50.133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble-3",
    "data-name": "Speech Bubble",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble-4",
    "data-name": "Speech Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2792",
    "data-name": "Group 2792",
    transform: "translate(6.814 28.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M375.57,107.6l7.49,3.983-2.975,6.141a.641.641,0,0,1-.285.293c-.355.185-2.456,1.3-2.573,1.365a.708.708,0,0,1-1-.368l-3.231-10.046Z",
    transform: "translate(-372.992 -107.601)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M375.57,107.6l7.49,3.983-2.975,6.141a.641.641,0,0,1-.285.293c-.355.185-2.456,1.3-2.573,1.365a.708.708,0,0,1-1-.368l-3.231-10.046Z",
    transform: "translate(-372.992 -107.601)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M380.482,113.714l-2.975,6.141a.708.708,0,0,1-1.284-.078l-3.231-10.046Z",
    transform: "translate(-372.992 -108.365)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M380.482,113.714l-2.975,6.141a.708.708,0,0,1-1.284-.078l-3.231-10.046Z",
    transform: "translate(-372.992 -108.365)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2793",
    "data-name": "Group 2793"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M367.922,62.63l22.132,11.744a1.424,1.424,0,0,1,.711,1.13V99.727a1.407,1.407,0,0,1-.715,1.123l-2.545,1.31a1.716,1.716,0,0,1-1.424-.007L363.949,90.41a1.425,1.425,0,0,1-.71-1.13V65.056a1.408,1.408,0,0,1,.714-1.123l2.545-1.309A1.717,1.717,0,0,1,367.922,62.63Z",
    transform: "translate(-363.239 -62.471)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M363.252,64.938c.056-.328.348-.446.7-.259l22.13,11.745a1.394,1.394,0,0,1,.5.488l3.96-2.074a1.359,1.359,0,0,0-.488-.465L367.925,62.628a1.713,1.713,0,0,0-1.424-.006l-2.543,1.309A1.436,1.436,0,0,0,363.252,64.938Z",
    transform: "translate(-363.243 -62.47)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M386.792,102.961V78.737a1.424,1.424,0,0,0-.71-1.13L363.949,65.863c-.392-.208-.71-.039-.71.377V90.464a1.425,1.425,0,0,0,.71,1.13l22.133,11.744C386.474,103.546,386.792,103.377,386.792,102.961Z",
    transform: "translate(-363.239 -63.654)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M386.792,102.961V78.737a1.424,1.424,0,0,0-.71-1.13L363.949,65.863c-.392-.208-.71-.039-.71.377V90.464a1.425,1.425,0,0,0,.71,1.13l22.133,11.744C386.474,103.546,386.792,103.377,386.792,102.961Z",
    transform: "translate(-363.239 -63.654)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    d: "M395.934,109.062a1.759,1.759,0,0,0,1.425.008l2.543-1.312a1.4,1.4,0,0,0,.715-1.121V82.411a1.262,1.262,0,0,0-.227-.665l-3.957,2.074a1.22,1.22,0,0,1,.21.642v24.222C396.644,109.065,396.352,109.285,395.934,109.062Z",
    transform: "translate(-373.091 -69.379)",
    opacity: 0.15
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M375.084,80.657q.036.735.036,1.285c0,.367-.013.765-.036,1.2a2.339,2.339,0,0,1-.877,1.977,2.012,2.012,0,0,1-2.053-.18,5.211,5.211,0,0,1-2.053-2,6.322,6.322,0,0,1-.878-2.908q-.036-.684-.036-1.234t.036-1.247a2.429,2.429,0,0,1,.832-2.027,2.03,2.03,0,0,1,2.1.2,5.187,5.187,0,0,1,2.1,2.02A6.275,6.275,0,0,1,375.084,80.657Zm4.314-.1a.673.673,0,0,1,.262-.219.488.488,0,0,1,.389.078l1.881,1a.79.79,0,0,1,.316.308.854.854,0,0,1,.117.433.5.5,0,0,1-.017.119.484.484,0,0,1-.055.124l-8.934,11.885a.668.668,0,0,1-.263.219.484.484,0,0,1-.388-.078l-1.881-1a.782.782,0,0,1-.317-.309.848.848,0,0,1-.117-.432.506.506,0,0,1,.017-.119.457.457,0,0,1,.055-.124Zm-7.831.859a2.691,2.691,0,0,0,.153.8.909.909,0,0,0,.435.513q.306.162.435-.052a1.407,1.407,0,0,0,.152-.634,26.7,26.7,0,0,0,0-2.759,2.734,2.734,0,0,0-.152-.8.914.914,0,0,0-.435-.513c-.2-.108-.349-.091-.435.051a1.394,1.394,0,0,0-.153.635A27.07,27.07,0,0,0,371.566,81.412ZM383.831,94.6q.036.735.036,1.285t-.036,1.2a2.339,2.339,0,0,1-.878,1.977,2.011,2.011,0,0,1-2.053-.181,5.2,5.2,0,0,1-2.053-2,6.311,6.311,0,0,1-.878-2.907q-.036-.684-.036-1.234t.036-1.247a2.426,2.426,0,0,1,.832-2.026,2.026,2.026,0,0,1,2.1.2,5.19,5.19,0,0,1,2.1,2.02A6.292,6.292,0,0,1,383.831,94.6Zm-3.518.755a2.691,2.691,0,0,0,.152.8.912.912,0,0,0,.435.513q.3.162.435-.051a1.4,1.4,0,0,0,.152-.635,26.731,26.731,0,0,0,0-2.759,2.71,2.71,0,0,0-.152-.8.916.916,0,0,0-.435-.513c-.2-.108-.349-.09-.435.052a1.391,1.391,0,0,0-.152.633A26.718,26.718,0,0,0,380.313,95.354Z",
    transform: "translate(-365.032 -67.074)",
    fill: "#fafafa"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTax);
export default __webpack_public_path__ + "static/media/tax.eaf5342c45f48c7f99a899c5dfe979eb.svg";
export { ForwardRef as ReactComponent };